export const IconsMindLineData = [
  "line-icon-A-Z",
  "line-icon-Aa",
  "line-icon-Add-Bag",
  "line-icon-Add-Basket",
  "line-icon-Add-Cart",
  "line-icon-Add-File",
  "line-icon-Add-SpaceAfterParagraph",
  "line-icon-Add-SpaceBeforeParagraph",
  "line-icon-Add-User",
  "line-icon-Add-UserStar",
  "line-icon-Add-Window",
  "line-icon-Add",
  "line-icon-Address-Book",
  "line-icon-Address-Book2",
  "line-icon-Administrator",
  "line-icon-Aerobics-2",
  "line-icon-Aerobics-3",
  "line-icon-Aerobics",
  "line-icon-Affiliate",
  "line-icon-Aim",
  "line-icon-Air-Balloon",
  "line-icon-Airbrush",
  "line-icon-Airship",
  "line-icon-Alarm-Clock",
  "line-icon-Alarm-Clock2",
  "line-icon-Alarm",
  "line-icon-Alien-2",
  "line-icon-Alien",
  "line-icon-Aligator",
  "line-icon-Align-Center",
  "line-icon-Align-JustifyAll",
  "line-icon-Align-JustifyCenter",
  "line-icon-Align-JustifyLeft",
  "line-icon-Align-JustifyRight",
  "line-icon-Align-Left",
  "line-icon-Align-Right",
  "line-icon-Alpha",
  "line-icon-Ambulance",
  "line-icon-AMX",
  "line-icon-Anchor-2",
  "line-icon-Anchor",
  "line-icon-Android-Store",
  "line-icon-Android",
  "line-icon-Angel-Smiley",
  "line-icon-Angel",
  "line-icon-Angry",
  "line-icon-Apple-Bite",
  "line-icon-Apple-Store",
  "line-icon-Apple",
  "line-icon-Approved-Window",
  "line-icon-Aquarius-2",
  "line-icon-Aquarius",
  "line-icon-Archery-2",
  "line-icon-Archery",
  "line-icon-Argentina",
  "line-icon-Aries-2",
  "line-icon-Aries",
  "line-icon-Army-Key",
  "line-icon-Arrow-Around",
  "line-icon-Arrow-Back3",
  "line-icon-Arrow-Back",
  "line-icon-Arrow-Back2",
  "line-icon-Arrow-Barrier",
  "line-icon-Arrow-Circle",
  "line-icon-Arrow-Cross",
  "line-icon-Arrow-Down",
  "line-icon-Arrow-Down2",
  "line-icon-Arrow-Down3",
  "line-icon-Arrow-DowninCircle",
  "line-icon-Arrow-Fork",
  "line-icon-Arrow-Forward",
  "line-icon-Arrow-Forward2",
  "line-icon-Arrow-From",
  "line-icon-Arrow-Inside",
  "line-icon-Arrow-Inside45",
  "line-icon-Arrow-InsideGap",
  "line-icon-Arrow-InsideGap45",
  "line-icon-Arrow-Into",
  "line-icon-Arrow-Join",
  "line-icon-Arrow-Junction",
  "line-icon-Arrow-Left",
  "line-icon-Arrow-Left2",
  "line-icon-Arrow-LeftinCircle",
  "line-icon-Arrow-Loop",
  "line-icon-Arrow-Merge",
  "line-icon-Arrow-Mix",
  "line-icon-Arrow-Next",
  "line-icon-Arrow-OutLeft",
  "line-icon-Arrow-OutRight",
  "line-icon-Arrow-Outside",
  "line-icon-Arrow-Outside45",
  "line-icon-Arrow-OutsideGap",
  "line-icon-Arrow-OutsideGap45",
  "line-icon-Arrow-Over",
  "line-icon-Arrow-Refresh",
  "line-icon-Arrow-Refresh2",
  "line-icon-Arrow-Right",
  "line-icon-Arrow-Right2",
  "line-icon-Arrow-RightinCircle",
  "line-icon-Arrow-Shuffle",
  "line-icon-Arrow-Squiggly",
  "line-icon-Arrow-Through",
  "line-icon-Arrow-To",
  "line-icon-Arrow-TurnLeft",
  "line-icon-Arrow-TurnRight",
  "line-icon-Arrow-Up",
  "line-icon-Arrow-Up2",
  "line-icon-Arrow-Up3",
  "line-icon-Arrow-UpinCircle",
  "line-icon-Arrow-XLeft",
  "line-icon-Arrow-XRight",
  "line-icon-Ask",
  "line-icon-Assistant",
  "line-icon-Astronaut",
  "line-icon-At-Sign",
  "line-icon-ATM",
  "line-icon-Atom",
  "line-icon-Audio",
  "line-icon-Auto-Flash",
  "line-icon-Autumn",
  "line-icon-Baby-Clothes",
  "line-icon-Baby-Clothes2",
  "line-icon-Baby-Cry",
  "line-icon-Baby",
  "line-icon-Back2",
  "line-icon-Back-Media",
  "line-icon-Back-Music",
  "line-icon-Back",
  "line-icon-Background",
  "line-icon-Bacteria",
  "line-icon-Bag-Coins",
  "line-icon-Bag-Items",
  "line-icon-Bag-Quantity",
  "line-icon-Bag",
  "line-icon-Bakelite",
  "line-icon-Ballet-Shoes",
  "line-icon-Balloon",
  "line-icon-Banana",
  "line-icon-Band-Aid",
  "line-icon-Bank",
  "line-icon-Bar-Chart",
  "line-icon-Bar-Chart2",
  "line-icon-Bar-Chart3",
  "line-icon-Bar-Chart4",
  "line-icon-Bar-Chart5",
  "line-icon-Bar-Code",
  "line-icon-Barricade-2",
  "line-icon-Barricade",
  "line-icon-Baseball",
  "line-icon-Basket-Ball",
  "line-icon-Basket-Coins",
  "line-icon-Basket-Items",
  "line-icon-Basket-Quantity",
  "line-icon-Bat-2",
  "line-icon-Bat",
  "line-icon-Bathrobe",
  "line-icon-Batman-Mask",
  "line-icon-Battery-0",
  "line-icon-Battery-25",
  "line-icon-Battery-50",
  "line-icon-Battery-75",
  "line-icon-Battery-100",
  "line-icon-Battery-Charge",
  "line-icon-Bear",
  "line-icon-Beard-2",
  "line-icon-Beard-3",
  "line-icon-Beard",
  "line-icon-Bebo",
  "line-icon-Bee",
  "line-icon-Beer-Glass",
  "line-icon-Beer",
  "line-icon-Bell-2",
  "line-icon-Bell",
  "line-icon-Belt-2",
  "line-icon-Belt-3",
  "line-icon-Belt",
  "line-icon-Berlin-Tower",
  "line-icon-Beta",
  "line-icon-Betvibes",
  "line-icon-Bicycle-2",
  "line-icon-Bicycle-3",
  "line-icon-Bicycle",
  "line-icon-Big-Bang",
  "line-icon-Big-Data",
  "line-icon-Bike-Helmet",
  "line-icon-Bikini",
  "line-icon-Bilk-Bottle2",
  "line-icon-Billing",
  "line-icon-Bing",
  "line-icon-Binocular",
  "line-icon-Bio-Hazard",
  "line-icon-Biotech",
  "line-icon-Bird-DeliveringLetter",
  "line-icon-Bird",
  "line-icon-Birthday-Cake",
  "line-icon-Bisexual",
  "line-icon-Bishop",
  "line-icon-Bitcoin",
  "line-icon-Black-Cat",
  "line-icon-Blackboard",
  "line-icon-Blinklist",
  "line-icon-Block-Cloud",
  "line-icon-Block-Window",
  "line-icon-Blogger",
  "line-icon-Blood",
  "line-icon-Blouse",
  "line-icon-Blueprint",
  "line-icon-Board",
  "line-icon-Bodybuilding",
  "line-icon-Bold-Text",
  "line-icon-Bone",
  "line-icon-Bones",
  "line-icon-Book",
  "line-icon-Bookmark",
  "line-icon-Books-2",
  "line-icon-Books",
  "line-icon-Boom",
  "line-icon-Boot-2",
  "line-icon-Boot",
  "line-icon-Bottom-ToTop",
  "line-icon-Bow-2",
  "line-icon-Bow-3",
  "line-icon-Bow-4",
  "line-icon-Bow-5",
  "line-icon-Bow-6",
  "line-icon-Bow",
  "line-icon-Bowling-2",
  "line-icon-Bowling",
  "line-icon-Box2",
  "line-icon-Box-Close",
  "line-icon-Box-Full",
  "line-icon-Box-Open",
  "line-icon-Box-withFolders",
  "line-icon-Box",
  "line-icon-Boy",
  "line-icon-Bra",
  "line-icon-Brain-2",
  "line-icon-Brain-3",
  "line-icon-Brain",
  "line-icon-Brazil",
  "line-icon-Bread-2",
  "line-icon-Bread",
  "line-icon-Bridge",
  "line-icon-Brightkite",
  "line-icon-Broke-Link2",
  "line-icon-Broken-Link",
  "line-icon-Broom",
  "line-icon-Brush",
  "line-icon-Bucket",
  "line-icon-Bug",
  "line-icon-Building",
  "line-icon-Bulleted-List",
  "line-icon-Bus-2",
  "line-icon-Bus",
  "line-icon-Business-Man",
  "line-icon-Business-ManWoman",
  "line-icon-Business-Mens",
  "line-icon-Business-Woman",
  "line-icon-Butterfly",
  "line-icon-Button",
  "line-icon-Cable-Car",
  "line-icon-Cake",
  "line-icon-Calculator-2",
  "line-icon-Calculator-3",
  "line-icon-Calculator",
  "line-icon-Calendar-2",
  "line-icon-Calendar-3",
  "line-icon-Calendar-4",
  "line-icon-Calendar-Clock",
  "line-icon-Calendar",
  "line-icon-Camel",
  "line-icon-Camera-2",
  "line-icon-Camera-3",
  "line-icon-Camera-4",
  "line-icon-Camera-5",
  "line-icon-Camera-Back",
  "line-icon-Camera",
  "line-icon-Can-2",
  "line-icon-Can",
  "line-icon-Canada",
  "line-icon-Cancer-2",
  "line-icon-Cancer-3",
  "line-icon-Cancer",
  "line-icon-Candle",
  "line-icon-Candy-Cane",
  "line-icon-Candy",
  "line-icon-Cannon",
  "line-icon-Cap-2",
  "line-icon-Cap-3",
  "line-icon-Cap-Smiley",
  "line-icon-Cap",
  "line-icon-Capricorn-2",
  "line-icon-Capricorn",
  "line-icon-Car-2",
  "line-icon-Car-3",
  "line-icon-Car-Coins",
  "line-icon-Car-Items",
  "line-icon-Car-Wheel",
  "line-icon-Car",
  "line-icon-Cardigan",
  "line-icon-Cardiovascular",
  "line-icon-Cart-Quantity",
  "line-icon-Casette-Tape",
  "line-icon-Cash-Register",
  "line-icon-Cash-register2",
  "line-icon-Castle",
  "line-icon-Cat",
  "line-icon-Cathedral",
  "line-icon-Cauldron",
  "line-icon-CD-2",
  "line-icon-CD-Cover",
  "line-icon-CD",
  "line-icon-Cello",
  "line-icon-Celsius",
  "line-icon-Chacked-Flag",
  "line-icon-Chair",
  "line-icon-Charger",
  "line-icon-Check-2",
  "line-icon-Check",
  "line-icon-Checked-User",
  "line-icon-Checkmate",
  "line-icon-Checkout-Bag",
  "line-icon-Checkout-Basket",
  "line-icon-Checkout",
  "line-icon-Cheese",
  "line-icon-Cheetah",
  "line-icon-Chef-Hat",
  "line-icon-Chef-Hat2",
  "line-icon-Chef",
  "line-icon-Chemical-2",
  "line-icon-Chemical-3",
  "line-icon-Chemical-4",
  "line-icon-Chemical-5",
  "line-icon-Chemical",
  "line-icon-Chess-Board",
  "line-icon-Chess",
  "line-icon-Chicken",
  "line-icon-Chile",
  "line-icon-Chimney",
  "line-icon-China",
  "line-icon-Chinese-Temple",
  "line-icon-Chip",
  "line-icon-Chopsticks-2",
  "line-icon-Chopsticks",
  "line-icon-Christmas-Ball",
  "line-icon-Christmas-Bell",
  "line-icon-Christmas-Candle",
  "line-icon-Christmas-Hat",
  "line-icon-Christmas-Sleigh",
  "line-icon-Christmas-Snowman",
  "line-icon-Christmas-Sock",
  "line-icon-Christmas-Tree",
  "line-icon-Christmas",
  "line-icon-Chrome",
  "line-icon-Chrysler-Building",
  "line-icon-Cinema",
  "line-icon-Circular-Point",
  "line-icon-City-Hall",
  "line-icon-Clamp",
  "line-icon-Clapperboard-Close",
  "line-icon-Clapperboard-Open",
  "line-icon-Claps",
  "line-icon-Clef",
  "line-icon-Clinic",
  "line-icon-Clock-2",
  "line-icon-Clock-3",
  "line-icon-Clock-4",
  "line-icon-Clock-Back",
  "line-icon-Clock-Forward",
  "line-icon-Clock",
  "line-icon-Close-Window",
  "line-icon-Close",
  "line-icon-Clothing-Store",
  "line-icon-Cloud--",
  "line-icon-Cloud-",
  "line-icon-Cloud-Camera",
  "line-icon-Cloud-Computer",
  "line-icon-Cloud-Email",
  "line-icon-Cloud-Hail",
  "line-icon-Cloud-Laptop",
  "line-icon-Cloud-Lock",
  "line-icon-Cloud-Moon",
  "line-icon-Cloud-Music",
  "line-icon-Cloud-Picture",
  "line-icon-Cloud-Rain",
  "line-icon-Cloud-Remove",
  "line-icon-Cloud-Secure",
  "line-icon-Cloud-Settings",
  "line-icon-Cloud-Smartphone",
  "line-icon-Cloud-Snow",
  "line-icon-Cloud-Sun",
  "line-icon-Cloud-Tablet",
  "line-icon-Cloud-Video",
  "line-icon-Cloud-Weather",
  "line-icon-Cloud",
  "line-icon-Clouds-Weather",
  "line-icon-Clouds",
  "line-icon-Clown",
  "line-icon-CMYK",
  "line-icon-Coat",
  "line-icon-Cocktail",
  "line-icon-Coconut",
  "line-icon-Code-Window",
  "line-icon-Coding",
  "line-icon-Coffee-2",
  "line-icon-Coffee-Bean",
  "line-icon-Coffee-Machine",
  "line-icon-Coffee-toGo",
  "line-icon-Coffee",
  "line-icon-Coffin",
  "line-icon-Coin",
  "line-icon-Coins-2",
  "line-icon-Coins-3",
  "line-icon-Coins",
  "line-icon-Colombia",
  "line-icon-Colosseum",
  "line-icon-Column-2",
  "line-icon-Column-3",
  "line-icon-Column",
  "line-icon-Comb-2",
  "line-icon-Comb",
  "line-icon-Communication-Tower",
  "line-icon-Communication-Tower2",
  "line-icon-Compass-2",
  "line-icon-Compass-3",
  "line-icon-Compass-4",
  "line-icon-Compass-Rose",
  "line-icon-Compass",
  "line-icon-Computer-2",
  "line-icon-Computer-3",
  "line-icon-Computer-Secure",
  "line-icon-Computer",
  "line-icon-Conference",
  "line-icon-Confused",
  "line-icon-Conservation",
  "line-icon-Consulting",
  "line-icon-Contrast",
  "line-icon-Control-2",
  "line-icon-Control",
  "line-icon-Cookie-Man",
  "line-icon-Cookies",
  "line-icon-Cool-Guy",
  "line-icon-Cool",
  "line-icon-Copyright",
  "line-icon-Costume",
  "line-icon-Couple-Sign",
  "line-icon-Cow",
  "line-icon-CPU",
  "line-icon-Crane",
  "line-icon-Cranium",
  "line-icon-Credit-Card",
  "line-icon-Credit-Card2",
  "line-icon-Credit-Card3",
  "line-icon-Cricket",
  "line-icon-Criminal",
  "line-icon-Croissant",
  "line-icon-Crop-2",
  "line-icon-Crop-3",
  "line-icon-Crown-2",
  "line-icon-Crown",
  "line-icon-Crying",
  "line-icon-Cube-Molecule",
  "line-icon-Cube-Molecule2",
  "line-icon-Cupcake",
  "line-icon-Cursor-Click",
  "line-icon-Cursor-Click2",
  "line-icon-Cursor-Move",
  "line-icon-Cursor-Move2",
  "line-icon-Cursor-Select",
  "line-icon-Cursor",
  "line-icon-D-Eyeglasses",
  "line-icon-D-Eyeglasses2",
  "line-icon-Dam",
  "line-icon-Danemark",
  "line-icon-Danger-2",
  "line-icon-Danger",
  "line-icon-Dashboard",
  "line-icon-Data-Backup",
  "line-icon-Data-Block",
  "line-icon-Data-Center",
  "line-icon-Data-Clock",
  "line-icon-Data-Cloud",
  "line-icon-Data-Compress",
  "line-icon-Data-Copy",
  "line-icon-Data-Download",
  "line-icon-Data-Financial",
  "line-icon-Data-Key",
  "line-icon-Data-Lock",
  "line-icon-Data-Network",
  "line-icon-Data-Password",
  "line-icon-Data-Power",
  "line-icon-Data-Refresh",
  "line-icon-Data-Save",
  "line-icon-Data-Search",
  "line-icon-Data-Security",
  "line-icon-Data-Settings",
  "line-icon-Data-Sharing",
  "line-icon-Data-Shield",
  "line-icon-Data-Signal",
  "line-icon-Data-Storage",
  "line-icon-Data-Stream",
  "line-icon-Data-Transfer",
  "line-icon-Data-Unlock",
  "line-icon-Data-Upload",
  "line-icon-Data-Yes",
  "line-icon-Data",
  "line-icon-David-Star",
  "line-icon-Daylight",
  "line-icon-Death",
  "line-icon-Debian",
  "line-icon-Dec",
  "line-icon-Decrase-Inedit",
  "line-icon-Deer-2",
  "line-icon-Deer",
  "line-icon-Delete-File",
  "line-icon-Delete-Window",
  "line-icon-Delicious",
  "line-icon-Depression",
  "line-icon-Deviantart",
  "line-icon-Device-SyncwithCloud",
  "line-icon-Diamond",
  "line-icon-Dice-2",
  "line-icon-Dice",
  "line-icon-Digg",
  "line-icon-Digital-Drawing",
  "line-icon-Diigo",
  "line-icon-Dinosaur",
  "line-icon-Diploma-2",
  "line-icon-Diploma",
  "line-icon-Direction-East",
  "line-icon-Direction-North",
  "line-icon-Direction-South",
  "line-icon-Direction-West",
  "line-icon-Director",
  "line-icon-Disk",
  "line-icon-Dj",
  "line-icon-DNA-2",
  "line-icon-DNA-Helix",
  "line-icon-DNA",
  "line-icon-Doctor",
  "line-icon-Dog",
  "line-icon-Dollar-Sign",
  "line-icon-Dollar-Sign2",
  "line-icon-Dollar",
  "line-icon-Dolphin",
  "line-icon-Domino",
  "line-icon-Door-Hanger",
  "line-icon-Door",
  "line-icon-Doplr",
  "line-icon-Double-Circle",
  "line-icon-Double-Tap",
  "line-icon-Doughnut",
  "line-icon-Dove",
  "line-icon-Down-2",
  "line-icon-Down-3",
  "line-icon-Down-4",
  "line-icon-Down",
  "line-icon-Download-2",
  "line-icon-Download-fromCloud",
  "line-icon-Download-Window",
  "line-icon-Download",
  "line-icon-Downward",
  "line-icon-Drag-Down",
  "line-icon-Drag-Left",
  "line-icon-Drag-Right",
  "line-icon-Drag-Up",
  "line-icon-Drag",
  "line-icon-Dress",
  "line-icon-Drill-2",
  "line-icon-Drill",
  "line-icon-Drop",
  "line-icon-Dropbox",
  "line-icon-Drum",
  "line-icon-Dry",
  "line-icon-Duck",
  "line-icon-Dumbbell",
  "line-icon-Duplicate-Layer",
  "line-icon-Duplicate-Window",
  "line-icon-DVD",
  "line-icon-Eagle",
  "line-icon-Ear",
  "line-icon-Earphones-2",
  "line-icon-Earphones",
  "line-icon-Eci-Icon",
  "line-icon-Edit-Map",
  "line-icon-Edit",
  "line-icon-Eggs",
  "line-icon-Egypt",
  "line-icon-Eifel-Tower",
  "line-icon-eject-2",
  "line-icon-Eject",
  "line-icon-El-Castillo",
  "line-icon-Elbow",
  "line-icon-Electric-Guitar",
  "line-icon-Electricity",
  "line-icon-Elephant",
  "line-icon-Email",
  "line-icon-Embassy",
  "line-icon-Empire-StateBuilding",
  "line-icon-Empty-Box",
  "line-icon-End2",
  "line-icon-End-2",
  "line-icon-End",
  "line-icon-Endways",
  "line-icon-Engineering",
  "line-icon-Envelope-2",
  "line-icon-Envelope",
  "line-icon-Environmental-2",
  "line-icon-Environmental-3",
  "line-icon-Environmental",
  "line-icon-Equalizer",
  "line-icon-Eraser-2",
  "line-icon-Eraser-3",
  "line-icon-Eraser",
  "line-icon-Error-404Window",
  "line-icon-Euro-Sign",
  "line-icon-Euro-Sign2",
  "line-icon-Euro",
  "line-icon-Evernote",
  "line-icon-Evil",
  "line-icon-Explode",
  "line-icon-Eye-2",
  "line-icon-Eye-Blind",
  "line-icon-Eye-Invisible",
  "line-icon-Eye-Scan",
  "line-icon-Eye-Visible",
  "line-icon-Eye",
  "line-icon-Eyebrow-2",
  "line-icon-Eyebrow-3",
  "line-icon-Eyebrow",
  "line-icon-Eyeglasses-Smiley",
  "line-icon-Eyeglasses-Smiley2",
  "line-icon-Face-Style",
  "line-icon-Face-Style2",
  "line-icon-Face-Style3",
  "line-icon-Face-Style4",
  "line-icon-Face-Style5",
  "line-icon-Face-Style6",
  "line-icon-Facebook-2",
  "line-icon-Facebook",
  "line-icon-Factory-2",
  "line-icon-Factory",
  "line-icon-Fahrenheit",
  "line-icon-Family-Sign",
  "line-icon-Fan",
  "line-icon-Farmer",
  "line-icon-Fashion",
  "line-icon-Favorite-Window",
  "line-icon-Fax",
  "line-icon-Feather",
  "line-icon-Feedburner",
  "line-icon-Female-2",
  "line-icon-Female-Sign",
  "line-icon-Female",
  "line-icon-File-Block",
  "line-icon-File-Bookmark",
  "line-icon-File-Chart",
  "line-icon-File-Clipboard",
  "line-icon-File-ClipboardFileText",
  "line-icon-File-ClipboardTextImage",
  "line-icon-File-Cloud",
  "line-icon-File-Copy",
  "line-icon-File-Copy2",
  "line-icon-File-CSV",
  "line-icon-File-Download",
  "line-icon-File-Edit",
  "line-icon-File-Excel",
  "line-icon-File-Favorite",
  "line-icon-File-Fire",
  "line-icon-File-Graph",
  "line-icon-File-Hide",
  "line-icon-File-Horizontal",
  "line-icon-File-HorizontalText",
  "line-icon-File-HTML",
  "line-icon-File-JPG",
  "line-icon-File-Link",
  "line-icon-File-Loading",
  "line-icon-File-Lock",
  "line-icon-File-Love",
  "line-icon-File-Music",
  "line-icon-File-Network",
  "line-icon-File-Pictures",
  "line-icon-File-Pie",
  "line-icon-File-Presentation",
  "line-icon-File-Refresh",
  "line-icon-File-Search",
  "line-icon-File-Settings",
  "line-icon-File-Share",
  "line-icon-File-TextImage",
  "line-icon-File-Trash",
  "line-icon-File-TXT",
  "line-icon-File-Upload",
  "line-icon-File-Video",
  "line-icon-File-Word",
  "line-icon-File-Zip",
  "line-icon-File",
  "line-icon-Files",
  "line-icon-Film-Board",
  "line-icon-Film-Cartridge",
  "line-icon-Film-Strip",
  "line-icon-Film-Video",
  "line-icon-Film",
  "line-icon-Filter-2",
  "line-icon-Filter",
  "line-icon-Financial",
  "line-icon-Find-User",
  "line-icon-Finger-DragFourSides",
  "line-icon-Finger-DragTwoSides",
  "line-icon-Finger-Print",
  "line-icon-Finger",
  "line-icon-Fingerprint-2",
  "line-icon-Fingerprint",
  "line-icon-Fire-Flame",
  "line-icon-Fire-Flame2",
  "line-icon-Fire-Hydrant",
  "line-icon-Fire-Staion",
  "line-icon-Firefox",
  "line-icon-Firewall",
  "line-icon-First-Aid",
  "line-icon-First",
  "line-icon-Fish-Food",
  "line-icon-Fish",
  "line-icon-Fit-To",
  "line-icon-Fit-To2",
  "line-icon-Five-Fingers",
  "line-icon-Five-FingersDrag",
  "line-icon-Five-FingersDrag2",
  "line-icon-Five-FingersTouch",
  "line-icon-Flag-2",
  "line-icon-Flag-3",
  "line-icon-Flag-4",
  "line-icon-Flag-5",
  "line-icon-Flag-6",
  "line-icon-Flag",
  "line-icon-Flamingo",
  "line-icon-Flash-2",
  "line-icon-Flash-Video",
  "line-icon-Flash",
  "line-icon-Flashlight",
  "line-icon-Flask-2",
  "line-icon-Flask",
  "line-icon-Flick",
  "line-icon-Flickr",
  "line-icon-Flowerpot",
  "line-icon-Fluorescent",
  "line-icon-Fog-Day",
  "line-icon-Fog-Night",
  "line-icon-Folder-Add",
  "line-icon-Folder-Archive",
  "line-icon-Folder-Binder",
  "line-icon-Folder-Binder2",
  "line-icon-Folder-Block",
  "line-icon-Folder-Bookmark",
  "line-icon-Folder-Close",
  "line-icon-Folder-Cloud",
  "line-icon-Folder-Delete",
  "line-icon-Folder-Download",
  "line-icon-Folder-Edit",
  "line-icon-Folder-Favorite",
  "line-icon-Folder-Fire",
  "line-icon-Folder-Hide",
  "line-icon-Folder-Link",
  "line-icon-Folder-Loading",
  "line-icon-Folder-Lock",
  "line-icon-Folder-Love",
  "line-icon-Folder-Music",
  "line-icon-Folder-Network",
  "line-icon-Folder-Open",
  "line-icon-Folder-Open2",
  "line-icon-Folder-Organizing",
  "line-icon-Folder-Pictures",
  "line-icon-Folder-Refresh",
  "line-icon-Folder-Remove-",
  "line-icon-Folder-Search",
  "line-icon-Folder-Settings",
  "line-icon-Folder-Share",
  "line-icon-Folder-Trash",
  "line-icon-Folder-Upload",
  "line-icon-Folder-Video",
  "line-icon-Folder-WithDocument",
  "line-icon-Folder-Zip",
  "line-icon-Folder",
  "line-icon-Folders",
  "line-icon-Font-Color",
  "line-icon-Font-Name",
  "line-icon-Font-Size",
  "line-icon-Font-Style",
  "line-icon-Font-StyleSubscript",
  "line-icon-Font-StyleSuperscript",
  "line-icon-Font-Window",
  "line-icon-Foot-2",
  "line-icon-Foot",
  "line-icon-Football-2",
  "line-icon-Football",
  "line-icon-Footprint-2",
  "line-icon-Footprint-3",
  "line-icon-Footprint",
  "line-icon-Forest",
  "line-icon-Fork",
  "line-icon-Formspring",
  "line-icon-Formula",
  "line-icon-Forsquare",
  "line-icon-Forward",
  "line-icon-Fountain-Pen",
  "line-icon-Four-Fingers",
  "line-icon-Four-FingersDrag",
  "line-icon-Four-FingersDrag2",
  "line-icon-Four-FingersTouch",
  "line-icon-Fox",
  "line-icon-Frankenstein",
  "line-icon-French-Fries",
  "line-icon-Friendfeed",
  "line-icon-Friendster",
  "line-icon-Frog",
  "line-icon-Fruits",
  "line-icon-Fuel",
  "line-icon-Full-Bag",
  "line-icon-Full-Basket",
  "line-icon-Full-Cart",
  "line-icon-Full-Moon",
  "line-icon-Full-Screen",
  "line-icon-Full-Screen2",
  "line-icon-Full-View",
  "line-icon-Full-View2",
  "line-icon-Full-ViewWindow",
  "line-icon-Function",
  "line-icon-Funky",
  "line-icon-Funny-Bicycle",
  "line-icon-Furl",
  "line-icon-Gamepad-2",
  "line-icon-Gamepad",
  "line-icon-Gas-Pump",
  "line-icon-Gaugage-2",
  "line-icon-Gaugage",
  "line-icon-Gay",
  "line-icon-Gear-2",
  "line-icon-Gear",
  "line-icon-Gears-2",
  "line-icon-Gears",
  "line-icon-Geek-2",
  "line-icon-Geek",
  "line-icon-Gemini-2",
  "line-icon-Gemini",
  "line-icon-Genius",
  "line-icon-Gentleman",
  "line-icon-Geo--",
  "line-icon-Geo-",
  "line-icon-Geo-Close",
  "line-icon-Geo-Love",
  "line-icon-Geo-Number",
  "line-icon-Geo-Star",
  "line-icon-Geo",
  "line-icon-Geo2--",
  "line-icon-Geo2-",
  "line-icon-Geo2-Close",
  "line-icon-Geo2-Love",
  "line-icon-Geo2-Number",
  "line-icon-Geo2-Star",
  "line-icon-Geo2",
  "line-icon-Geo3--",
  "line-icon-Geo3-",
  "line-icon-Geo3-Close",
  "line-icon-Geo3-Love",
  "line-icon-Geo3-Number",
  "line-icon-Geo3-Star",
  "line-icon-Geo3",
  "line-icon-Gey",
  "line-icon-Gift-Box",
  "line-icon-Giraffe",
  "line-icon-Girl",
  "line-icon-Glass-Water",
  "line-icon-Glasses-2",
  "line-icon-Glasses-3",
  "line-icon-Glasses",
  "line-icon-Global-Position",
  "line-icon-Globe-2",
  "line-icon-Globe",
  "line-icon-Gloves",
  "line-icon-Go-Bottom",
  "line-icon-Go-Top",
  "line-icon-Goggles",
  "line-icon-Golf-2",
  "line-icon-Golf",
  "line-icon-Google-Buzz",
  "line-icon-Google-Drive",
  "line-icon-Google-Play",
  "line-icon-Google-Plus",
  "line-icon-Google",
  "line-icon-Gopro",
  "line-icon-Gorilla",
  "line-icon-Gowalla",
  "line-icon-Grave",
  "line-icon-Graveyard",
  "line-icon-Greece",
  "line-icon-Green-Energy",
  "line-icon-Green-House",
  "line-icon-Guitar",
  "line-icon-Gun-2",
  "line-icon-Gun-3",
  "line-icon-Gun",
  "line-icon-Gymnastics",
  "line-icon-Hair-2",
  "line-icon-Hair-3",
  "line-icon-Hair-4",
  "line-icon-Hair",
  "line-icon-Half-Moon",
  "line-icon-Halloween-HalfMoon",
  "line-icon-Halloween-Moon",
  "line-icon-Hamburger",
  "line-icon-Hammer",
  "line-icon-Hand-Touch",
  "line-icon-Hand-Touch2",
  "line-icon-Hand-TouchSmartphone",
  "line-icon-Hand",
  "line-icon-Hands",
  "line-icon-Handshake",
  "line-icon-Hanger",
  "line-icon-Happy",
  "line-icon-Hat-2",
  "line-icon-Hat",
  "line-icon-Haunted-House",
  "line-icon-HD-Video",
  "line-icon-HD",
  "line-icon-HDD",
  "line-icon-Headphone",
  "line-icon-Headphones",
  "line-icon-Headset",
  "line-icon-Heart-2",
  "line-icon-Heart",
  "line-icon-Heels-2",
  "line-icon-Heels",
  "line-icon-Height-Window",
  "line-icon-Helicopter-2",
  "line-icon-Helicopter",
  "line-icon-Helix-2",
  "line-icon-Hello",
  "line-icon-Helmet-2",
  "line-icon-Helmet-3",
  "line-icon-Helmet",
  "line-icon-Hipo",
  "line-icon-Hipster-Glasses",
  "line-icon-Hipster-Glasses2",
  "line-icon-Hipster-Glasses3",
  "line-icon-Hipster-Headphones",
  "line-icon-Hipster-Men",
  "line-icon-Hipster-Men2",
  "line-icon-Hipster-Men3",
  "line-icon-Hipster-Sunglasses",
  "line-icon-Hipster-Sunglasses2",
  "line-icon-Hipster-Sunglasses3",
  "line-icon-Hokey",
  "line-icon-Holly",
  "line-icon-Home-2",
  "line-icon-Home-3",
  "line-icon-Home-4",
  "line-icon-Home-5",
  "line-icon-Home-Window",
  "line-icon-Home",
  "line-icon-Homosexual",
  "line-icon-Honey",
  "line-icon-Hong-Kong",
  "line-icon-Hoodie",
  "line-icon-Horror",
  "line-icon-Horse",
  "line-icon-Hospital-2",
  "line-icon-Hospital",
  "line-icon-Host",
  "line-icon-Hot-Dog",
  "line-icon-Hotel",
  "line-icon-Hour",
  "line-icon-Hub",
  "line-icon-Humor",
  "line-icon-Hurt",
  "line-icon-Ice-Cream",
  "line-icon-ICQ",
  "line-icon-ID-2",
  "line-icon-ID-3",
  "line-icon-ID-Card",
  "line-icon-Idea-2",
  "line-icon-Idea-3",
  "line-icon-Idea-4",
  "line-icon-Idea-5",
  "line-icon-Idea",
  "line-icon-Identification-Badge",
  "line-icon-ImDB",
  "line-icon-Inbox-Empty",
  "line-icon-Inbox-Forward",
  "line-icon-Inbox-Full",
  "line-icon-Inbox-Into",
  "line-icon-Inbox-Out",
  "line-icon-Inbox-Reply",
  "line-icon-Inbox",
  "line-icon-Increase-Inedit",
  "line-icon-Indent-FirstLine",
  "line-icon-Indent-LeftMargin",
  "line-icon-Indent-RightMargin",
  "line-icon-India",
  "line-icon-Info-Window",
  "line-icon-Information",
  "line-icon-Inifity",
  "line-icon-Instagram",
  "line-icon-Internet-2",
  "line-icon-Internet-Explorer",
  "line-icon-Internet-Smiley",
  "line-icon-Internet",
  "line-icon-iOS-Apple",
  "line-icon-Israel",
  "line-icon-Italic-Text",
  "line-icon-Jacket-2",
  "line-icon-Jacket",
  "line-icon-Jamaica",
  "line-icon-Japan",
  "line-icon-Japanese-Gate",
  "line-icon-Jeans",
  "line-icon-Jeep-2",
  "line-icon-Jeep",
  "line-icon-Jet",
  "line-icon-Joystick",
  "line-icon-Juice",
  "line-icon-Jump-Rope",
  "line-icon-Kangoroo",
  "line-icon-Kenya",
  "line-icon-Key-2",
  "line-icon-Key-3",
  "line-icon-Key-Lock",
  "line-icon-Key",
  "line-icon-Keyboard",
  "line-icon-Keyboard3",
  "line-icon-Keypad",
  "line-icon-King-2",
  "line-icon-King",
  "line-icon-Kiss",
  "line-icon-Knee",
  "line-icon-Knife-2",
  "line-icon-Knife",
  "line-icon-Knight",
  "line-icon-Koala",
  "line-icon-Korea",
  "line-icon-Lamp",
  "line-icon-Landscape-2",
  "line-icon-Landscape",
  "line-icon-Lantern",
  "line-icon-Laptop-2",
  "line-icon-Laptop-3",
  "line-icon-Laptop-Phone",
  "line-icon-Laptop-Secure",
  "line-icon-Laptop-Tablet",
  "line-icon-Laptop",
  "line-icon-Laser",
  "line-icon-Last-FM",
  "line-icon-Last",
  "line-icon-Laughing",
  "line-icon-Layer-1635",
  "line-icon-Layer-1646",
  "line-icon-Layer-Backward",
  "line-icon-Layer-Forward",
  "line-icon-Leafs-2",
  "line-icon-Leafs",
  "line-icon-Leaning-Tower",
  "line-icon-Left--Right",
  "line-icon-Left--Right3",
  "line-icon-Left-2",
  "line-icon-Left-3",
  "line-icon-Left-4",
  "line-icon-Left-ToRight",
  "line-icon-Left",
  "line-icon-Leg-2",
  "line-icon-Leg",
  "line-icon-Lego",
  "line-icon-Lemon",
  "line-icon-Len-2",
  "line-icon-Len-3",
  "line-icon-Len",
  "line-icon-Leo-2",
  "line-icon-Leo",
  "line-icon-Leopard",
  "line-icon-Lesbian",
  "line-icon-Lesbians",
  "line-icon-Letter-Close",
  "line-icon-Letter-Open",
  "line-icon-Letter-Sent",
  "line-icon-Libra-2",
  "line-icon-Libra",
  "line-icon-Library-2",
  "line-icon-Library",
  "line-icon-Life-Jacket",
  "line-icon-Life-Safer",
  "line-icon-Light-Bulb",
  "line-icon-Light-Bulb2",
  "line-icon-Light-BulbLeaf",
  "line-icon-Lighthouse",
  "line-icon-Like-2",
  "line-icon-Like",
  "line-icon-Line-Chart",
  "line-icon-Line-Chart2",
  "line-icon-Line-Chart3",
  "line-icon-Line-Chart4",
  "line-icon-Line-Spacing",
  "line-icon-Line-SpacingText",
  "line-icon-Link-2",
  "line-icon-Link",
  "line-icon-Linkedin-2",
  "line-icon-Linkedin",
  "line-icon-Linux",
  "line-icon-Lion",
  "line-icon-Livejournal",
  "line-icon-Loading-2",
  "line-icon-Loading-3",
  "line-icon-Loading-Window",
  "line-icon-Loading",
  "line-icon-Location-2",
  "line-icon-Location",
  "line-icon-Lock-2",
  "line-icon-Lock-3",
  "line-icon-Lock-User",
  "line-icon-Lock-Window",
  "line-icon-Lock",
  "line-icon-Lollipop-2",
  "line-icon-Lollipop-3",
  "line-icon-Lollipop",
  "line-icon-Loop",
  "line-icon-Loud",
  "line-icon-Loudspeaker",
  "line-icon-Love-2",
  "line-icon-Love-User",
  "line-icon-Love-Window",
  "line-icon-Love",
  "line-icon-Lowercase-Text",
  "line-icon-Luggafe-Front",
  "line-icon-Luggage-2",
  "line-icon-Macro",
  "line-icon-Magic-Wand",
  "line-icon-Magnet",
  "line-icon-Magnifi-Glass-",
  "line-icon-Magnifi-Glass",
  "line-icon-Magnifi-Glass2",
  "line-icon-Mail-2",
  "line-icon-Mail-3",
  "line-icon-Mail-Add",
  "line-icon-Mail-Attachement",
  "line-icon-Mail-Block",
  "line-icon-Mail-Delete",
  "line-icon-Mail-Favorite",
  "line-icon-Mail-Forward",
  "line-icon-Mail-Gallery",
  "line-icon-Mail-Inbox",
  "line-icon-Mail-Link",
  "line-icon-Mail-Lock",
  "line-icon-Mail-Love",
  "line-icon-Mail-Money",
  "line-icon-Mail-Open",
  "line-icon-Mail-Outbox",
  "line-icon-Mail-Password",
  "line-icon-Mail-Photo",
  "line-icon-Mail-Read",
  "line-icon-Mail-Removex",
  "line-icon-Mail-Reply",
  "line-icon-Mail-ReplyAll",
  "line-icon-Mail-Search",
  "line-icon-Mail-Send",
  "line-icon-Mail-Settings",
  "line-icon-Mail-Unread",
  "line-icon-Mail-Video",
  "line-icon-Mail-withAtSign",
  "line-icon-Mail-WithCursors",
  "line-icon-Mail",
  "line-icon-Mailbox-Empty",
  "line-icon-Mailbox-Full",
  "line-icon-Male-2",
  "line-icon-Male-Sign",
  "line-icon-Male",
  "line-icon-MaleFemale",
  "line-icon-Man-Sign",
  "line-icon-Management",
  "line-icon-Mans-Underwear",
  "line-icon-Mans-Underwear2",
  "line-icon-Map-Marker",
  "line-icon-Map-Marker2",
  "line-icon-Map-Marker3",
  "line-icon-Map",
  "line-icon-Map2",
  "line-icon-Marker-2",
  "line-icon-Marker-3",
  "line-icon-Marker",
  "line-icon-Martini-Glass",
  "line-icon-Mask",
  "line-icon-Master-Card",
  "line-icon-Maximize-Window",
  "line-icon-Maximize",
  "line-icon-Medal-2",
  "line-icon-Medal-3",
  "line-icon-Medal",
  "line-icon-Medical-Sign",
  "line-icon-Medicine-2",
  "line-icon-Medicine-3",
  "line-icon-Medicine",
  "line-icon-Megaphone",
  "line-icon-Memory-Card",
  "line-icon-Memory-Card2",
  "line-icon-Memory-Card3",
  "line-icon-Men",
  "line-icon-Menorah",
  "line-icon-Mens",
  "line-icon-Metacafe",
  "line-icon-Mexico",
  "line-icon-Mic",
  "line-icon-Microphone-2",
  "line-icon-Microphone-3",
  "line-icon-Microphone-4",
  "line-icon-Microphone-5",
  "line-icon-Microphone-6",
  "line-icon-Microphone-7",
  "line-icon-Microphone",
  "line-icon-Microscope",
  "line-icon-Milk-Bottle",
  "line-icon-Mine",
  "line-icon-Minimize-Maximize-Close-Window",
  "line-icon-Minimize-Window",
  "line-icon-Minimize",
  "line-icon-Mirror",
  "line-icon-Mixer",
  "line-icon-Mixx",
  "line-icon-Money-2",
  "line-icon-Money-Bag",
  "line-icon-Money-Smiley",
  "line-icon-Money",
  "line-icon-Monitor-2",
  "line-icon-Monitor-3",
  "line-icon-Monitor-4",
  "line-icon-Monitor-5",
  "line-icon-Monitor-Analytics",
  "line-icon-Monitor-Laptop",
  "line-icon-Monitor-phone",
  "line-icon-Monitor-Tablet",
  "line-icon-Monitor-Vertical",
  "line-icon-Monitor",
  "line-icon-Monitoring",
  "line-icon-Monkey",
  "line-icon-Monster",
  "line-icon-Morocco",
  "line-icon-Motorcycle",
  "line-icon-Mouse-2",
  "line-icon-Mouse-3",
  "line-icon-Mouse-4",
  "line-icon-Mouse-Pointer",
  "line-icon-Mouse",
  "line-icon-Moustache-Smiley",
  "line-icon-Movie-Ticket",
  "line-icon-Movie",
  "line-icon-Mp3-File",
  "line-icon-Museum",
  "line-icon-Mushroom",
  "line-icon-Music-Note",
  "line-icon-Music-Note2",
  "line-icon-Music-Note3",
  "line-icon-Music-Note4",
  "line-icon-Music-Player",
  "line-icon-Mustache-2",
  "line-icon-Mustache-3",
  "line-icon-Mustache-4",
  "line-icon-Mustache-5",
  "line-icon-Mustache-6",
  "line-icon-Mustache-7",
  "line-icon-Mustache-8",
  "line-icon-Mustache",
  "line-icon-Mute",
  "line-icon-Myspace",
  "line-icon-Navigat-Start",
  "line-icon-Navigate-End",
  "line-icon-Navigation-LeftWindow",
  "line-icon-Navigation-RightWindow",
  "line-icon-Nepal",
  "line-icon-Netscape",
  "line-icon-Network-Window",
  "line-icon-Network",
  "line-icon-Neutron",
  "line-icon-New-Mail",
  "line-icon-New-Tab",
  "line-icon-Newspaper-2",
  "line-icon-Newspaper",
  "line-icon-Newsvine",
  "line-icon-Next2",
  "line-icon-Next-3",
  "line-icon-Next-Music",
  "line-icon-Next",
  "line-icon-No-Battery",
  "line-icon-No-Drop",
  "line-icon-No-Flash",
  "line-icon-No-Smoking",
  "line-icon-Noose",
  "line-icon-Normal-Text",
  "line-icon-Note",
  "line-icon-Notepad-2",
  "line-icon-Notepad",
  "line-icon-Nuclear",
  "line-icon-Numbering-List",
  "line-icon-Nurse",
  "line-icon-Office-Lamp",
  "line-icon-Office",
  "line-icon-Oil",
  "line-icon-Old-Camera",
  "line-icon-Old-Cassette",
  "line-icon-Old-Clock",
  "line-icon-Old-Radio",
  "line-icon-Old-Sticky",
  "line-icon-Old-Sticky2",
  "line-icon-Old-Telephone",
  "line-icon-Old-TV",
  "line-icon-On-Air",
  "line-icon-On-Off-2",
  "line-icon-On-Off-3",
  "line-icon-On-off",
  "line-icon-One-Finger",
  "line-icon-One-FingerTouch",
  "line-icon-One-Window",
  "line-icon-Open-Banana",
  "line-icon-Open-Book",
  "line-icon-Opera-House",
  "line-icon-Opera",
  "line-icon-Optimization",
  "line-icon-Orientation-2",
  "line-icon-Orientation-3",
  "line-icon-Orientation",
  "line-icon-Orkut",
  "line-icon-Ornament",
  "line-icon-Over-Time",
  "line-icon-Over-Time2",
  "line-icon-Owl",
  "line-icon-Pac-Man",
  "line-icon-Paint-Brush",
  "line-icon-Paint-Bucket",
  "line-icon-Paintbrush",
  "line-icon-Palette",
  "line-icon-Palm-Tree",
  "line-icon-Panda",
  "line-icon-Panorama",
  "line-icon-Pantheon",
  "line-icon-Pantone",
  "line-icon-Pants",
  "line-icon-Paper-Plane",
  "line-icon-Paper",
  "line-icon-Parasailing",
  "line-icon-Parrot",
  "line-icon-Password-2shopping",
  "line-icon-Password-Field",
  "line-icon-Password-shopping",
  "line-icon-Password",
  "line-icon-pause-2",
  "line-icon-Pause",
  "line-icon-Paw",
  "line-icon-Pawn",
  "line-icon-Paypal",
  "line-icon-Pen-2",
  "line-icon-Pen-3",
  "line-icon-Pen-4",
  "line-icon-Pen-5",
  "line-icon-Pen-6",
  "line-icon-Pen",
  "line-icon-Pencil-Ruler",
  "line-icon-Pencil",
  "line-icon-Penguin",
  "line-icon-Pentagon",
  "line-icon-People-onCloud",
  "line-icon-Pepper-withFire",
  "line-icon-Pepper",
  "line-icon-Petrol",
  "line-icon-Petronas-Tower",
  "line-icon-Philipines",
  "line-icon-Phone-2",
  "line-icon-Phone-3",
  "line-icon-Phone-3G",
  "line-icon-Phone-4G",
  "line-icon-Phone-Simcard",
  "line-icon-Phone-SMS",
  "line-icon-Phone-Wifi",
  "line-icon-Phone",
  "line-icon-Photo-2",
  "line-icon-Photo-3",
  "line-icon-Photo-Album",
  "line-icon-Photo-Album2",
  "line-icon-Photo-Album3",
  "line-icon-Photo",
  "line-icon-Photos",
  "line-icon-Physics",
  "line-icon-Pi",
  "line-icon-Piano",
  "line-icon-Picasa",
  "line-icon-Pie-Chart",
  "line-icon-Pie-Chart2",
  "line-icon-Pie-Chart3",
  "line-icon-Pilates-2",
  "line-icon-Pilates-3",
  "line-icon-Pilates",
  "line-icon-Pilot",
  "line-icon-Pinch",
  "line-icon-Ping-Pong",
  "line-icon-Pinterest",
  "line-icon-Pipe",
  "line-icon-Pipette",
  "line-icon-Piramids",
  "line-icon-Pisces-2",
  "line-icon-Pisces",
  "line-icon-Pizza-Slice",
  "line-icon-Pizza",
  "line-icon-Plane-2",
  "line-icon-Plane",
  "line-icon-Plant",
  "line-icon-Plasmid",
  "line-icon-Plaster",
  "line-icon-Plastic-CupPhone",
  "line-icon-Plastic-CupPhone2",
  "line-icon-Plate",
  "line-icon-Plates",
  "line-icon-Plaxo",
  "line-icon-Play-Music",
  "line-icon-Plug-In",
  "line-icon-Plug-In2",
  "line-icon-Plurk",
  "line-icon-Pointer",
  "line-icon-Poland",
  "line-icon-Police-Man",
  "line-icon-Police-Station",
  "line-icon-Police-Woman",
  "line-icon-Police",
  "line-icon-Polo-Shirt",
  "line-icon-Portrait",
  "line-icon-Portugal",
  "line-icon-Post-Mail",
  "line-icon-Post-Mail2",
  "line-icon-Post-Office",
  "line-icon-Post-Sign",
  "line-icon-Post-Sign2ways",
  "line-icon-Posterous",
  "line-icon-Pound-Sign",
  "line-icon-Pound-Sign2",
  "line-icon-Pound",
  "line-icon-Power-2",
  "line-icon-Power-3",
  "line-icon-Power-Cable",
  "line-icon-Power-Station",
  "line-icon-Power",
  "line-icon-Prater",
  "line-icon-Present",
  "line-icon-Presents",
  "line-icon-Press",
  "line-icon-Preview",
  "line-icon-Previous",
  "line-icon-Pricing",
  "line-icon-Printer",
  "line-icon-Professor",
  "line-icon-Profile",
  "line-icon-Project",
  "line-icon-Projector-2",
  "line-icon-Projector",
  "line-icon-Pulse",
  "line-icon-Pumpkin",
  "line-icon-Punk",
  "line-icon-Punker",
  "line-icon-Puzzle",
  "line-icon-QIK",
  "line-icon-QR-Code",
  "line-icon-Queen-2",
  "line-icon-Queen",
  "line-icon-Quill-2",
  "line-icon-Quill-3",
  "line-icon-Quill",
  "line-icon-Quotes-2",
  "line-icon-Quotes",
  "line-icon-Radio",
  "line-icon-Radioactive",
  "line-icon-Rafting",
  "line-icon-Rain-Drop",
  "line-icon-Rainbow-2",
  "line-icon-Rainbow",
  "line-icon-Ram",
  "line-icon-Razzor-Blade",
  "line-icon-Receipt-2",
  "line-icon-Receipt-3",
  "line-icon-Receipt-4",
  "line-icon-Receipt",
  "line-icon-Record2",
  "line-icon-Record-3",
  "line-icon-Record-Music",
  "line-icon-Record",
  "line-icon-Recycling-2",
  "line-icon-Recycling",
  "line-icon-Reddit",
  "line-icon-Redhat",
  "line-icon-Redirect",
  "line-icon-Redo",
  "line-icon-Reel",
  "line-icon-Refinery",
  "line-icon-Refresh-Window",
  "line-icon-Refresh",
  "line-icon-Reload-2",
  "line-icon-Reload-3",
  "line-icon-Reload",
  "line-icon-Remote-Controll",
  "line-icon-Remote-Controll2",
  "line-icon-Remove-Bag",
  "line-icon-Remove-Basket",
  "line-icon-Remove-Cart",
  "line-icon-Remove-File",
  "line-icon-Remove-User",
  "line-icon-Remove-Window",
  "line-icon-Remove",
  "line-icon-Rename",
  "line-icon-Repair",
  "line-icon-Repeat-2",
  "line-icon-Repeat-3",
  "line-icon-Repeat-4",
  "line-icon-Repeat-5",
  "line-icon-Repeat-6",
  "line-icon-Repeat-7",
  "line-icon-Repeat",
  "line-icon-Reset",
  "line-icon-Resize",
  "line-icon-Restore-Window",
  "line-icon-Retouching",
  "line-icon-Retro-Camera",
  "line-icon-Retro",
  "line-icon-Retweet",
  "line-icon-Reverbnation",
  "line-icon-Rewind",
  "line-icon-RGB",
  "line-icon-Ribbon-2",
  "line-icon-Ribbon-3",
  "line-icon-Ribbon",
  "line-icon-Right-2",
  "line-icon-Right-3",
  "line-icon-Right-4",
  "line-icon-Right-ToLeft",
  "line-icon-Right",
  "line-icon-Road-2",
  "line-icon-Road-3",
  "line-icon-Road",
  "line-icon-Robot-2",
  "line-icon-Robot",
  "line-icon-Rock-andRoll",
  "line-icon-Rocket",
  "line-icon-Roller",
  "line-icon-Roof",
  "line-icon-Rook",
  "line-icon-Rotate-Gesture",
  "line-icon-Rotate-Gesture2",
  "line-icon-Rotate-Gesture3",
  "line-icon-Rotation-390",
  "line-icon-Rotation",
  "line-icon-Router-2",
  "line-icon-Router",
  "line-icon-RSS",
  "line-icon-Ruler-2",
  "line-icon-Ruler",
  "line-icon-Running-Shoes",
  "line-icon-Running",
  "line-icon-Safari",
  "line-icon-Safe-Box",
  "line-icon-Safe-Box2",
  "line-icon-Safety-PinClose",
  "line-icon-Safety-PinOpen",
  "line-icon-Sagittarus-2",
  "line-icon-Sagittarus",
  "line-icon-Sailing-Ship",
  "line-icon-Sand-watch",
  "line-icon-Sand-watch2",
  "line-icon-Santa-Claus",
  "line-icon-Santa-Claus2",
  "line-icon-Santa-onSled",
  "line-icon-Satelite-2",
  "line-icon-Satelite",
  "line-icon-Save-Window",
  "line-icon-Save",
  "line-icon-Saw",
  "line-icon-Saxophone",
  "line-icon-Scale",
  "line-icon-Scarf",
  "line-icon-Scissor",
  "line-icon-Scooter-Front",
  "line-icon-Scooter",
  "line-icon-Scorpio-2",
  "line-icon-Scorpio",
  "line-icon-Scotland",
  "line-icon-Screwdriver",
  "line-icon-Scroll-Fast",
  "line-icon-Scroll",
  "line-icon-Scroller-2",
  "line-icon-Scroller",
  "line-icon-Sea-Dog",
  "line-icon-Search-onCloud",
  "line-icon-Search-People",
  "line-icon-secound",
  "line-icon-secound2",
  "line-icon-Security-Block",
  "line-icon-Security-Bug",
  "line-icon-Security-Camera",
  "line-icon-Security-Check",
  "line-icon-Security-Settings",
  "line-icon-Security-Smiley",
  "line-icon-Securiy-Remove",
  "line-icon-Seed",
  "line-icon-Selfie",
  "line-icon-Serbia",
  "line-icon-Server-2",
  "line-icon-Server",
  "line-icon-Servers",
  "line-icon-Settings-Window",
  "line-icon-Sewing-Machine",
  "line-icon-Sexual",
  "line-icon-Share-onCloud",
  "line-icon-Share-Window",
  "line-icon-Share",
  "line-icon-Sharethis",
  "line-icon-Shark",
  "line-icon-Sheep",
  "line-icon-Sheriff-Badge",
  "line-icon-Shield",
  "line-icon-Ship-2",
  "line-icon-Ship",
  "line-icon-Shirt",
  "line-icon-Shoes-2",
  "line-icon-Shoes-3",
  "line-icon-Shoes",
  "line-icon-Shop-2",
  "line-icon-Shop-3",
  "line-icon-Shop-4",
  "line-icon-Shop",
  "line-icon-Shopping-Bag",
  "line-icon-Shopping-Basket",
  "line-icon-Shopping-Cart",
  "line-icon-Short-Pants",
  "line-icon-Shoutwire",
  "line-icon-Shovel",
  "line-icon-Shuffle-2",
  "line-icon-Shuffle-3",
  "line-icon-Shuffle-4",
  "line-icon-Shuffle",
  "line-icon-Shutter",
  "line-icon-Sidebar-Window",
  "line-icon-Signal",
  "line-icon-Singapore",
  "line-icon-Skate-Shoes",
  "line-icon-Skateboard-2",
  "line-icon-Skateboard",
  "line-icon-Skeleton",
  "line-icon-Ski",
  "line-icon-Skirt",
  "line-icon-Skrill",
  "line-icon-Skull",
  "line-icon-Skydiving",
  "line-icon-Skype",
  "line-icon-Sled-withGifts",
  "line-icon-Sled",
  "line-icon-Sleeping",
  "line-icon-Sleet",
  "line-icon-Slippers",
  "line-icon-Smart",
  "line-icon-Smartphone-2",
  "line-icon-Smartphone-3",
  "line-icon-Smartphone-4",
  "line-icon-Smartphone-Secure",
  "line-icon-Smartphone",
  "line-icon-Smile",
  "line-icon-Smoking-Area",
  "line-icon-Smoking-Pipe",
  "line-icon-Snake",
  "line-icon-Snorkel",
  "line-icon-Snow-2",
  "line-icon-Snow-Dome",
  "line-icon-Snow-Storm",
  "line-icon-Snow",
  "line-icon-Snowflake-2",
  "line-icon-Snowflake-3",
  "line-icon-Snowflake-4",
  "line-icon-Snowflake",
  "line-icon-Snowman",
  "line-icon-Soccer-Ball",
  "line-icon-Soccer-Shoes",
  "line-icon-Socks",
  "line-icon-Solar",
  "line-icon-Sound-Wave",
  "line-icon-Sound",
  "line-icon-Soundcloud",
  "line-icon-Soup",
  "line-icon-South-Africa",
  "line-icon-Space-Needle",
  "line-icon-Spain",
  "line-icon-Spam-Mail",
  "line-icon-Speach-Bubble",
  "line-icon-Speach-Bubble2",
  "line-icon-Speach-Bubble3",
  "line-icon-Speach-Bubble4",
  "line-icon-Speach-Bubble5",
  "line-icon-Speach-Bubble6",
  "line-icon-Speach-Bubble7",
  "line-icon-Speach-Bubble8",
  "line-icon-Speach-Bubble9",
  "line-icon-Speach-Bubble10",
  "line-icon-Speach-Bubble11",
  "line-icon-Speach-Bubble12",
  "line-icon-Speach-Bubble13",
  "line-icon-Speach-BubbleAsking",
  "line-icon-Speach-BubbleComic",
  "line-icon-Speach-BubbleComic2",
  "line-icon-Speach-BubbleComic3",
  "line-icon-Speach-BubbleComic4",
  "line-icon-Speach-BubbleDialog",
  "line-icon-Speach-Bubbles",
  "line-icon-Speak-2",
  "line-icon-Speak",
  "line-icon-Speaker-2",
  "line-icon-Speaker",
  "line-icon-Spell-Check",
  "line-icon-Spell-CheckABC",
  "line-icon-Spermium",
  "line-icon-Spider",
  "line-icon-Spiderweb",
  "line-icon-Split-FourSquareWindow",
  "line-icon-Split-Horizontal",
  "line-icon-Split-Horizontal2Window",
  "line-icon-Split-Vertical",
  "line-icon-Split-Vertical2",
  "line-icon-Split-Window",
  "line-icon-Spoder",
  "line-icon-Spoon",
  "line-icon-Sport-Mode",
  "line-icon-Sports-Clothings1",
  "line-icon-Sports-Clothings2",
  "line-icon-Sports-Shirt",
  "line-icon-Spot",
  "line-icon-Spray",
  "line-icon-Spread",
  "line-icon-Spring",
  "line-icon-Spurl",
  "line-icon-Spy",
  "line-icon-Squirrel",
  "line-icon-SSL",
  "line-icon-St-BasilsCathedral",
  "line-icon-St-PaulsCathedral",
  "line-icon-Stamp-2",
  "line-icon-Stamp",
  "line-icon-Stapler",
  "line-icon-Star-Track",
  "line-icon-Star",
  "line-icon-Starfish",
  "line-icon-Start2",
  "line-icon-Start-3",
  "line-icon-Start-ways",
  "line-icon-Start",
  "line-icon-Statistic",
  "line-icon-Stethoscope",
  "line-icon-stop--2",
  "line-icon-Stop-Music",
  "line-icon-Stop",
  "line-icon-Stopwatch-2",
  "line-icon-Stopwatch",
  "line-icon-Storm",
  "line-icon-Street-View",
  "line-icon-Street-View2",
  "line-icon-Strikethrough-Text",
  "line-icon-Stroller",
  "line-icon-Structure",
  "line-icon-Student-Female",
  "line-icon-Student-Hat",
  "line-icon-Student-Hat2",
  "line-icon-Student-Male",
  "line-icon-Student-MaleFemale",
  "line-icon-Students",
  "line-icon-Studio-Flash",
  "line-icon-Studio-Lightbox",
  "line-icon-Stumbleupon",
  "line-icon-Suit",
  "line-icon-Suitcase",
  "line-icon-Sum-2",
  "line-icon-Sum",
  "line-icon-Summer",
  "line-icon-Sun-CloudyRain",
  "line-icon-Sun",
  "line-icon-Sunglasses-2",
  "line-icon-Sunglasses-3",
  "line-icon-Sunglasses-Smiley",
  "line-icon-Sunglasses-Smiley2",
  "line-icon-Sunglasses-W",
  "line-icon-Sunglasses-W2",
  "line-icon-Sunglasses-W3",
  "line-icon-Sunglasses",
  "line-icon-Sunrise",
  "line-icon-Sunset",
  "line-icon-Superman",
  "line-icon-Support",
  "line-icon-Surprise",
  "line-icon-Sushi",
  "line-icon-Sweden",
  "line-icon-Swimming-Short",
  "line-icon-Swimming",
  "line-icon-Swimmwear",
  "line-icon-Switch",
  "line-icon-Switzerland",
  "line-icon-Sync-Cloud",
  "line-icon-Sync",
  "line-icon-Synchronize-2",
  "line-icon-Synchronize",
  "line-icon-T-Shirt",
  "line-icon-Tablet-2",
  "line-icon-Tablet-3",
  "line-icon-Tablet-Orientation",
  "line-icon-Tablet-Phone",
  "line-icon-Tablet-Secure",
  "line-icon-Tablet-Vertical",
  "line-icon-Tablet",
  "line-icon-Tactic",
  "line-icon-Tag-2",
  "line-icon-Tag-3",
  "line-icon-Tag-4",
  "line-icon-Tag-5",
  "line-icon-Tag",
  "line-icon-Taj-Mahal",
  "line-icon-Talk-Man",
  "line-icon-Tap",
  "line-icon-Target-Market",
  "line-icon-Target",
  "line-icon-Taurus-2",
  "line-icon-Taurus",
  "line-icon-Taxi-2",
  "line-icon-Taxi-Sign",
  "line-icon-Taxi",
  "line-icon-Teacher",
  "line-icon-Teapot",
  "line-icon-Technorati",
  "line-icon-Teddy-Bear",
  "line-icon-Tee-Mug",
  "line-icon-Telephone-2",
  "line-icon-Telephone",
  "line-icon-Telescope",
  "line-icon-Temperature-2",
  "line-icon-Temperature-3",
  "line-icon-Temperature",
  "line-icon-Temple",
  "line-icon-Tennis-Ball",
  "line-icon-Tennis",
  "line-icon-Tent",
  "line-icon-Test-Tube",
  "line-icon-Test-Tube2",
  "line-icon-Testimonal",
  "line-icon-Text-Box",
  "line-icon-Text-Effect",
  "line-icon-Text-HighlightColor",
  "line-icon-Text-Paragraph",
  "line-icon-Thailand",
  "line-icon-The-WhiteHouse",
  "line-icon-This-SideUp",
  "line-icon-Thread",
  "line-icon-Three-ArrowFork",
  "line-icon-Three-Fingers",
  "line-icon-Three-FingersDrag",
  "line-icon-Three-FingersDrag2",
  "line-icon-Three-FingersTouch",
  "line-icon-Thumb",
  "line-icon-Thumbs-DownSmiley",
  "line-icon-Thumbs-UpSmiley",
  "line-icon-Thunder",
  "line-icon-Thunderstorm",
  "line-icon-Ticket",
  "line-icon-Tie-2",
  "line-icon-Tie-3",
  "line-icon-Tie-4",
  "line-icon-Tie",
  "line-icon-Tiger",
  "line-icon-Time-Backup",
  "line-icon-Time-Bomb",
  "line-icon-Time-Clock",
  "line-icon-Time-Fire",
  "line-icon-Time-Machine",
  "line-icon-Time-Window",
  "line-icon-Timer-2",
  "line-icon-Timer",
  "line-icon-To-Bottom",
  "line-icon-To-Bottom2",
  "line-icon-To-Left",
  "line-icon-To-Right",
  "line-icon-To-Top",
  "line-icon-To-Top2",
  "line-icon-Token-",
  "line-icon-Tomato",
  "line-icon-Tongue",
  "line-icon-Tooth-2",
  "line-icon-Tooth",
  "line-icon-Top-ToBottom",
  "line-icon-Touch-Window",
  "line-icon-Tourch",
  "line-icon-Tower-2",
  "line-icon-Tower-Bridge",
  "line-icon-Tower",
  "line-icon-Trace",
  "line-icon-Tractor",
  "line-icon-traffic-Light",
  "line-icon-Traffic-Light2",
  "line-icon-Train-2",
  "line-icon-Train",
  "line-icon-Tram",
  "line-icon-Transform-2",
  "line-icon-Transform-3",
  "line-icon-Transform-4",
  "line-icon-Transform",
  "line-icon-Trash-withMen",
  "line-icon-Tree-2",
  "line-icon-Tree-3",
  "line-icon-Tree-4",
  "line-icon-Tree-5",
  "line-icon-Tree",
  "line-icon-Trekking",
  "line-icon-Triangle-ArrowDown",
  "line-icon-Triangle-ArrowLeft",
  "line-icon-Triangle-ArrowRight",
  "line-icon-Triangle-ArrowUp",
  "line-icon-Tripod-2",
  "line-icon-Tripod-andVideo",
  "line-icon-Tripod-withCamera",
  "line-icon-Tripod-withGopro",
  "line-icon-Trophy-2",
  "line-icon-Trophy",
  "line-icon-Truck",
  "line-icon-Trumpet",
  "line-icon-Tumblr",
  "line-icon-Turkey",
  "line-icon-Turn-Down",
  "line-icon-Turn-Down2",
  "line-icon-Turn-DownFromLeft",
  "line-icon-Turn-DownFromRight",
  "line-icon-Turn-Left",
  "line-icon-Turn-Left3",
  "line-icon-Turn-Right",
  "line-icon-Turn-Right3",
  "line-icon-Turn-Up",
  "line-icon-Turn-Up2",
  "line-icon-Turtle",
  "line-icon-Tuxedo",
  "line-icon-TV",
  "line-icon-Twister",
  "line-icon-Twitter-2",
  "line-icon-Twitter",
  "line-icon-Two-Fingers",
  "line-icon-Two-FingersDrag",
  "line-icon-Two-FingersDrag2",
  "line-icon-Two-FingersScroll",
  "line-icon-Two-FingersTouch",
  "line-icon-Two-Windows",
  "line-icon-Type-Pass",
  "line-icon-Ukraine",
  "line-icon-Umbrela",
  "line-icon-Umbrella-2",
  "line-icon-Umbrella-3",
  "line-icon-Under-LineText",
  "line-icon-Undo",
  "line-icon-United-Kingdom",
  "line-icon-United-States",
  "line-icon-University-2",
  "line-icon-University",
  "line-icon-Unlike-2",
  "line-icon-Unlike",
  "line-icon-Unlock-2",
  "line-icon-Unlock-3",
  "line-icon-Unlock",
  "line-icon-Up--Down",
  "line-icon-Up--Down3",
  "line-icon-Up-2",
  "line-icon-Up-3",
  "line-icon-Up-4",
  "line-icon-Up",
  "line-icon-Upgrade",
  "line-icon-Upload-2",
  "line-icon-Upload-toCloud",
  "line-icon-Upload-Window",
  "line-icon-Upload",
  "line-icon-Uppercase-Text",
  "line-icon-Upward",
  "line-icon-URL-Window",
  "line-icon-Usb-2",
  "line-icon-Usb-Cable",
  "line-icon-Usb",
  "line-icon-User",
  "line-icon-Ustream",
  "line-icon-Vase",
  "line-icon-Vector-2",
  "line-icon-Vector-3",
  "line-icon-Vector-4",
  "line-icon-Vector-5",
  "line-icon-Vector",
  "line-icon-Venn-Diagram",
  "line-icon-Vest-2",
  "line-icon-Vest",
  "line-icon-Viddler",
  "line-icon-Video-2",
  "line-icon-Video-3",
  "line-icon-Video-4",
  "line-icon-Video-5",
  "line-icon-Video-6",
  "line-icon-Video-GameController",
  "line-icon-Video-Len",
  "line-icon-Video-Len2",
  "line-icon-Video-Photographer",
  "line-icon-Video-Tripod",
  "line-icon-Video",
  "line-icon-Vietnam",
  "line-icon-View-Height",
  "line-icon-View-Width",
  "line-icon-Vimeo",
  "line-icon-Virgo-2",
  "line-icon-Virgo",
  "line-icon-Virus-2",
  "line-icon-Virus-3",
  "line-icon-Virus",
  "line-icon-Visa",
  "line-icon-Voice",
  "line-icon-Voicemail",
  "line-icon-Volleyball",
  "line-icon-Volume-Down",
  "line-icon-Volume-Up",
  "line-icon-VPN",
  "line-icon-Wacom-Tablet",
  "line-icon-Waiter",
  "line-icon-Walkie-Talkie",
  "line-icon-Wallet-2",
  "line-icon-Wallet-3",
  "line-icon-Wallet",
  "line-icon-Warehouse",
  "line-icon-Warning-Window",
  "line-icon-Watch-2",
  "line-icon-Watch-3",
  "line-icon-Watch",
  "line-icon-Wave-2",
  "line-icon-Wave",
  "line-icon-Webcam",
  "line-icon-weight-Lift",
  "line-icon-Wheelbarrow",
  "line-icon-Wheelchair",
  "line-icon-Width-Window",
  "line-icon-Wifi-2",
  "line-icon-Wifi-Keyboard",
  "line-icon-Wifi",
  "line-icon-Wind-Turbine",
  "line-icon-Windmill",
  "line-icon-Window-2",
  "line-icon-Window",
  "line-icon-Windows-2",
  "line-icon-Windows-Microsoft",
  "line-icon-Windows",
  "line-icon-Windsock",
  "line-icon-Windy",
  "line-icon-Wine-Bottle",
  "line-icon-Wine-Glass",
  "line-icon-Wink",
  "line-icon-Winter-2",
  "line-icon-Winter",
  "line-icon-Wireless",
  "line-icon-Witch-Hat",
  "line-icon-Witch",
  "line-icon-Wizard",
  "line-icon-Wolf",
  "line-icon-Woman-Sign",
  "line-icon-WomanMan",
  "line-icon-Womans-Underwear",
  "line-icon-Womans-Underwear2",
  "line-icon-Women",
  "line-icon-Wonder-Woman",
  "line-icon-Wordpress",
  "line-icon-Worker-Clothes",
  "line-icon-Worker",
  "line-icon-Wrap-Text",
  "line-icon-Wreath",
  "line-icon-Wrench",
  "line-icon-X-Box",
  "line-icon-X-ray",
  "line-icon-Xanga",
  "line-icon-Xing",
  "line-icon-Yacht",
  "line-icon-Yahoo-Buzz",
  "line-icon-Yahoo",
  "line-icon-Yelp",
  "line-icon-Yes",
  "line-icon-Ying-Yang",
  "line-icon-Youtube",
  "line-icon-Z-A",
  "line-icon-Zebra",
  "line-icon-Zombie",
  "line-icon-Zoom-Gesture",
  "line-icon-Zootool",
]

export const IconsMindSolidData = [
  "solid-icon-A-Z",
  "solid-icon-Aa",
  "solid-icon-Add-Bag",
  "solid-icon-Add-Basket",
  "solid-icon-Add-Cart",
  "solid-icon-Add-File",
  "solid-icon-Add-SpaceAfterParagraph",
  "solid-icon-Add-SpaceBeforeParagraph",
  "solid-icon-Add-User",
  "solid-icon-Add-UserStar",
  "solid-icon-Add-Window",
  "solid-icon-Add",
  "solid-icon-Address-Book",
  "solid-icon-Address-Book2",
  "solid-icon-Administrator",
  "solid-icon-Aerobics-2",
  "solid-icon-Aerobics-3",
  "solid-icon-Aerobics",
  "solid-icon-Affiliate",
  "solid-icon-Aim",
  "solid-icon-Air-Balloon",
  "solid-icon-Airbrush",
  "solid-icon-Airship",
  "solid-icon-Alarm-Clock",
  "solid-icon-Alarm-Clock2",
  "solid-icon-Alarm",
  "solid-icon-Alien-2",
  "solid-icon-Alien",
  "solid-icon-Aligator",
  "solid-icon-Align-Center",
  "solid-icon-Align-JustifyAll",
  "solid-icon-Align-JustifyCenter",
  "solid-icon-Align-JustifyLeft",
  "solid-icon-Align-JustifyRight",
  "solid-icon-Align-Left",
  "solid-icon-Align-Right",
  "solid-icon-Alpha",
  "solid-icon-Ambulance",
  "solid-icon-AMX",
  "solid-icon-Anchor-2",
  "solid-icon-Anchor",
  "solid-icon-Android-Store",
  "solid-icon-Android",
  "solid-icon-Angel-Smiley",
  "solid-icon-Angel",
  "solid-icon-Angry",
  "solid-icon-Apple-Bite",
  "solid-icon-Apple-Store",
  "solid-icon-Apple",
  "solid-icon-Approved-Window",
  "solid-icon-Aquarius-2",
  "solid-icon-Aquarius",
  "solid-icon-Archery-2",
  "solid-icon-Archery",
  "solid-icon-Argentina",
  "solid-icon-Aries-2",
  "solid-icon-Aries",
  "solid-icon-Army-Key",
  "solid-icon-Arrow-Around",
  "solid-icon-Arrow-Back",
  "solid-icon-Arrow-Back2",
  "solid-icon-Arrow-back3",
  "solid-icon-Arrow-Barrier",
  "solid-icon-Arrow-Circle",
  "solid-icon-Arrow-Cross",
  "solid-icon-Arrow-Down",
  "solid-icon-Arrow-Down2",
  "solid-icon-Arrow-Down3",
  "solid-icon-Arrow-DowninCircle",
  "solid-icon-Arrow-Fork",
  "solid-icon-Arrow-Forward",
  "solid-icon-Arrow-Forward2",
  "solid-icon-Arrow-From",
  "solid-icon-Arrow-Inside",
  "solid-icon-Arrow-Inside45",
  "solid-icon-Arrow-InsideGap",
  "solid-icon-Arrow-InsideGap45",
  "solid-icon-Arrow-Into",
  "solid-icon-Arrow-Join",
  "solid-icon-Arrow-Junction",
  "solid-icon-Arrow-Left",
  "solid-icon-Arrow-Left2",
  "solid-icon-Arrow-LeftinCircle",
  "solid-icon-Arrow-Loop",
  "solid-icon-Arrow-Merge",
  "solid-icon-Arrow-Mix",
  "solid-icon-Arrow-Next",
  "solid-icon-Arrow-OutLeft",
  "solid-icon-Arrow-OutRight",
  "solid-icon-Arrow-Outside",
  "solid-icon-Arrow-Outside45",
  "solid-icon-Arrow-OutsideGap",
  "solid-icon-Arrow-OutsideGap45",
  "solid-icon-Arrow-Over",
  "solid-icon-Arrow-Refresh",
  "solid-icon-Arrow-Refresh2",
  "solid-icon-Arrow-Right",
  "solid-icon-Arrow-Right2",
  "solid-icon-Arrow-RightinCircle",
  "solid-icon-Arrow-Shuffle",
  "solid-icon-Arrow-Squiggly",
  "solid-icon-Arrow-Through",
  "solid-icon-Arrow-To",
  "solid-icon-Arrow-TurnLeft",
  "solid-icon-Arrow-TurnRight",
  "solid-icon-Arrow-Up",
  "solid-icon-Arrow-Up2",
  "solid-icon-Arrow-Up3",
  "solid-icon-Arrow-UpinCircle",
  "solid-icon-Arrow-XLeft",
  "solid-icon-Arrow-XRight",
  "solid-icon-Ask",
  "solid-icon-Assistant",
  "solid-icon-Astronaut",
  "solid-icon-At-Sign",
  "solid-icon-ATM",
  "solid-icon-Atom",
  "solid-icon-Audio",
  "solid-icon-Auto-Flash",
  "solid-icon-Autumn",
  "solid-icon-Baby-Clothes",
  "solid-icon-Baby-Clothes2",
  "solid-icon-Baby-Cry",
  "solid-icon-Baby",
  "solid-icon-Back-Media",
  "solid-icon-Back-Media2",
  "solid-icon-Back-Music",
  "solid-icon-Back",
  "solid-icon-Background",
  "solid-icon-Bacteria",
  "solid-icon-Bag-Coins",
  "solid-icon-Bag-Items",
  "solid-icon-Bag-Quantity",
  "solid-icon-Bag",
  "solid-icon-Bakelite",
  "solid-icon-Ballet-Shoes",
  "solid-icon-Balloon",
  "solid-icon-Banana",
  "solid-icon-Band-Aid",
  "solid-icon-Bank",
  "solid-icon-Bar-Chart",
  "solid-icon-Bar-Chart2",
  "solid-icon-Bar-Chart3",
  "solid-icon-Bar-Chart4",
  "solid-icon-Bar-Chart5",
  "solid-icon-Bar-Code",
  "solid-icon-Barricade-2",
  "solid-icon-Barricade",
  "solid-icon-Baseball",
  "solid-icon-Basket-Ball",
  "solid-icon-Basket-Coins",
  "solid-icon-Basket-Items",
  "solid-icon-Basket-Quantity",
  "solid-icon-Bat-2",
  "solid-icon-Bat",
  "solid-icon-Bathrobe",
  "solid-icon-Batman-Mask",
  "solid-icon-Battery-0",
  "solid-icon-Battery-25",
  "solid-icon-Battery-50",
  "solid-icon-Battery-75",
  "solid-icon-Battery-100",
  "solid-icon-Battery-Charge",
  "solid-icon-Bear",
  "solid-icon-Beard-2",
  "solid-icon-Beard-3",
  "solid-icon-Beard",
  "solid-icon-Bebo",
  "solid-icon-Bee",
  "solid-icon-Beer-Glass",
  "solid-icon-Beer",
  "solid-icon-Behance",
  "solid-icon-Bell-2",
  "solid-icon-Bell",
  "solid-icon-Belt-2",
  "solid-icon-Belt-3",
  "solid-icon-Belt",
  "solid-icon-Berlin-Tower",
  "solid-icon-Beta",
  "solid-icon-Betvibes",
  "solid-icon-Bicycle-2",
  "solid-icon-Bicycle-3",
  "solid-icon-Bicycle",
  "solid-icon-Big-Bang",
  "solid-icon-Big-Data",
  "solid-icon-Bike-Helmet",
  "solid-icon-Bikini",
  "solid-icon-Bilk-Bottle2",
  "solid-icon-Billing",
  "solid-icon-Bing",
  "solid-icon-Binocular",
  "solid-icon-Bio-Hazard",
  "solid-icon-Biotech",
  "solid-icon-Bird-DeliveringLetter",
  "solid-icon-Bird",
  "solid-icon-Birthday-Cake",
  "solid-icon-Bisexual",
  "solid-icon-Bishop",
  "solid-icon-Bitcoin",
  "solid-icon-Black-Cat",
  "solid-icon-Blackboard",
  "solid-icon-Blinklist",
  "solid-icon-Block-Cloud",
  "solid-icon-Block-Window",
  "solid-icon-Blogger",
  "solid-icon-Blood",
  "solid-icon-Blouse",
  "solid-icon-Blueprint",
  "solid-icon-Board",
  "solid-icon-Bodybuilding",
  "solid-icon-Bold-Text",
  "solid-icon-Bone",
  "solid-icon-Bones",
  "solid-icon-Book",
  "solid-icon-Bookmark",
  "solid-icon-Books-2",
  "solid-icon-Books",
  "solid-icon-Boom",
  "solid-icon-Boot-2",
  "solid-icon-Boot",
  "solid-icon-Bottom-ToTop",
  "solid-icon-Bow-2",
  "solid-icon-Bow-3",
  "solid-icon-Bow-4",
  "solid-icon-Bow-5",
  "solid-icon-Bow-6",
  "solid-icon-Bow",
  "solid-icon-Bowling-2",
  "solid-icon-Bowling",
  "solid-icon-Box-Close",
  "solid-icon-Box-Full",
  "solid-icon-Box-Gloves",
  "solid-icon-Box-Open",
  "solid-icon-Box-withFolders",
  "solid-icon-Box",
  "solid-icon-Boy",
  "solid-icon-Bra",
  "solid-icon-Brain-2",
  "solid-icon-Brain-3",
  "solid-icon-Brain",
  "solid-icon-Brazil",
  "solid-icon-Bread-2",
  "solid-icon-Bread",
  "solid-icon-Bridge",
  "solid-icon-Brightkite",
  "solid-icon-Broke-Link2",
  "solid-icon-Broken-Link",
  "solid-icon-Broom",
  "solid-icon-Brush",
  "solid-icon-Bucket",
  "solid-icon-Bug",
  "solid-icon-Building",
  "solid-icon-Bulleted-List",
  "solid-icon-Bus-2",
  "solid-icon-Bus",
  "solid-icon-Business-Man",
  "solid-icon-Business-ManWoman",
  "solid-icon-Business-Mens",
  "solid-icon-Business-Woman",
  "solid-icon-Butterfly",
  "solid-icon-Button",
  "solid-icon-Cable-Car",
  "solid-icon-Cake",
  "solid-icon-Calculator-2",
  "solid-icon-Calculator-3",
  "solid-icon-Calculator",
  "solid-icon-Calendar-2",
  "solid-icon-Calendar-3",
  "solid-icon-Calendar-4",
  "solid-icon-Calendar-Clock",
  "solid-icon-Calendar",
  "solid-icon-Camel",
  "solid-icon-Camera-2",
  "solid-icon-Camera-3",
  "solid-icon-Camera-4",
  "solid-icon-Camera-5",
  "solid-icon-Camera-Back",
  "solid-icon-Camera",
  "solid-icon-Can-2",
  "solid-icon-Can",
  "solid-icon-Canada",
  "solid-icon-Cancer-2",
  "solid-icon-Cancer-3",
  "solid-icon-Cancer",
  "solid-icon-Candle",
  "solid-icon-Candy-Cane",
  "solid-icon-Candy",
  "solid-icon-Cannon",
  "solid-icon-Cap-2",
  "solid-icon-Cap-3",
  "solid-icon-Cap-Smiley",
  "solid-icon-Cap",
  "solid-icon-Capricorn-2",
  "solid-icon-Capricorn",
  "solid-icon-Car-2",
  "solid-icon-Car-3",
  "solid-icon-Car-Coins",
  "solid-icon-Car-Items",
  "solid-icon-Car-Wheel",
  "solid-icon-Car",
  "solid-icon-Cardigan",
  "solid-icon-Cardiovascular",
  "solid-icon-Cart-Quantity",
  "solid-icon-Casette-Tape",
  "solid-icon-Cash-Register",
  "solid-icon-Cash-register2",
  "solid-icon-Castle",
  "solid-icon-Cat",
  "solid-icon-Cathedral",
  "solid-icon-Cauldron",
  "solid-icon-CD-2",
  "solid-icon-CD-Cover",
  "solid-icon-CD",
  "solid-icon-Cello",
  "solid-icon-Celsius",
  "solid-icon-Chacked-Flag",
  "solid-icon-Chair",
  "solid-icon-Charger",
  "solid-icon-Check-2",
  "solid-icon-Check",
  "solid-icon-Checked-User",
  "solid-icon-Checkmate",
  "solid-icon-Checkout-Bag",
  "solid-icon-Checkout-Basket",
  "solid-icon-Checkout",
  "solid-icon-Cheese",
  "solid-icon-Cheetah",
  "solid-icon-Chef-Hat",
  "solid-icon-Chef-Hat2",
  "solid-icon-Chef",
  "solid-icon-Chemical-2",
  "solid-icon-Chemical-3",
  "solid-icon-Chemical-4",
  "solid-icon-Chemical-5",
  "solid-icon-Chemical",
  "solid-icon-Chess-Board",
  "solid-icon-Chess",
  "solid-icon-Chicken",
  "solid-icon-Chile",
  "solid-icon-Chimney",
  "solid-icon-China",
  "solid-icon-Chinese-Temple",
  "solid-icon-Chip",
  "solid-icon-Chopsticks-2",
  "solid-icon-Chopsticks",
  "solid-icon-Christmas-Ball",
  "solid-icon-Christmas-Bell",
  "solid-icon-Christmas-Candle",
  "solid-icon-Christmas-Hat",
  "solid-icon-Christmas-Sleigh",
  "solid-icon-Christmas-Snowman",
  "solid-icon-Christmas-Sock",
  "solid-icon-Christmas-Tree",
  "solid-icon-Christmas",
  "solid-icon-Chrome",
  "solid-icon-Chrysler-Building",
  "solid-icon-Cinema",
  "solid-icon-Circular-Point",
  "solid-icon-City-Hall",
  "solid-icon-Clamp",
  "solid-icon-Clapperboard-Close",
  "solid-icon-Clapperboard-Open",
  "solid-icon-Claps",
  "solid-icon-Clef",
  "solid-icon-Clinic",
  "solid-icon-Clock-2",
  "solid-icon-Clock-3",
  "solid-icon-Clock-4",
  "solid-icon-Clock-Back",
  "solid-icon-Clock-Forward",
  "solid-icon-Clock",
  "solid-icon-Close-Window",
  "solid-icon-Close",
  "solid-icon-Clothing-Store",
  "solid-icon-Cloud--",
  "solid-icon-Cloud-",
  "solid-icon-Cloud-Camera",
  "solid-icon-Cloud-Computer",
  "solid-icon-Cloud-Email",
  "solid-icon-Cloud-Hail",
  "solid-icon-Cloud-Laptop",
  "solid-icon-Cloud-Lock",
  "solid-icon-Cloud-Moon",
  "solid-icon-Cloud-Music",
  "solid-icon-Cloud-Picture",
  "solid-icon-Cloud-Rain",
  "solid-icon-Cloud-Remove",
  "solid-icon-Cloud-Secure",
  "solid-icon-Cloud-Settings",
  "solid-icon-Cloud-Smartphone",
  "solid-icon-Cloud-Snow",
  "solid-icon-Cloud-Sun",
  "solid-icon-Cloud-Tablet",
  "solid-icon-Cloud-Video",
  "solid-icon-Cloud-Weather",
  "solid-icon-Cloud",
  "solid-icon-Clouds-Weather",
  "solid-icon-Clouds",
  "solid-icon-Clown",
  "solid-icon-CMYK",
  "solid-icon-Coat",
  "solid-icon-Cocktail",
  "solid-icon-Coconut",
  "solid-icon-Code-Window",
  "solid-icon-Coding",
  "solid-icon-Coffee-2",
  "solid-icon-Coffee-Bean",
  "solid-icon-Coffee-Machine",
  "solid-icon-Coffee-toGo",
  "solid-icon-Coffee",
  "solid-icon-Coffin",
  "solid-icon-Coin",
  "solid-icon-Coins-2",
  "solid-icon-Coins-3",
  "solid-icon-Coins",
  "solid-icon-Colombia",
  "solid-icon-Colosseum",
  "solid-icon-Column-2",
  "solid-icon-Column-3",
  "solid-icon-Column",
  "solid-icon-Comb-2",
  "solid-icon-Comb",
  "solid-icon-Communication-Tower",
  "solid-icon-Communication-Tower2",
  "solid-icon-Compass-2",
  "solid-icon-Compass-3",
  "solid-icon-Compass-4",
  "solid-icon-Compass-Rose",
  "solid-icon-Compass",
  "solid-icon-Computer-2",
  "solid-icon-Computer-3",
  "solid-icon-Computer-Secure",
  "solid-icon-Computer",
  "solid-icon-Conference",
  "solid-icon-Confused",
  "solid-icon-Conservation",
  "solid-icon-Consulting",
  "solid-icon-Contrast",
  "solid-icon-Control-2",
  "solid-icon-Control",
  "solid-icon-Cookie-Man",
  "solid-icon-Cookies",
  "solid-icon-Cool-Guy",
  "solid-icon-Cool",
  "solid-icon-Copyright",
  "solid-icon-Costume",
  "solid-icon-Couple-Sign",
  "solid-icon-Cow",
  "solid-icon-CPU",
  "solid-icon-Crane",
  "solid-icon-Cranium",
  "solid-icon-Credit-Card",
  "solid-icon-Credit-Card2",
  "solid-icon-Credit-Card3",
  "solid-icon-Cricket",
  "solid-icon-Criminal",
  "solid-icon-Croissant",
  "solid-icon-Crop-2",
  "solid-icon-Crop-3",
  "solid-icon-Crown-2",
  "solid-icon-Crown",
  "solid-icon-Crying",
  "solid-icon-Cube-Molecule",
  "solid-icon-Cube-Molecule2",
  "solid-icon-Cupcake",
  "solid-icon-Cursor-Click",
  "solid-icon-Cursor-Click2",
  "solid-icon-Cursor-Move",
  "solid-icon-Cursor-Move2",
  "solid-icon-Cursor-Select",
  "solid-icon-Cursor",
  "solid-icon-D-Eyeglasses",
  "solid-icon-D-Eyeglasses2",
  "solid-icon-Dam",
  "solid-icon-Danemark",
  "solid-icon-Danger-2",
  "solid-icon-Danger",
  "solid-icon-Dashboard",
  "solid-icon-Data-Backup",
  "solid-icon-Data-Block",
  "solid-icon-Data-Center",
  "solid-icon-Data-Clock",
  "solid-icon-Data-Cloud",
  "solid-icon-Data-Compress",
  "solid-icon-Data-Copy",
  "solid-icon-Data-Download",
  "solid-icon-Data-Financial",
  "solid-icon-Data-Key",
  "solid-icon-Data-Lock",
  "solid-icon-Data-Network",
  "solid-icon-Data-Password",
  "solid-icon-Data-Power",
  "solid-icon-Data-Refresh",
  "solid-icon-Data-Save",
  "solid-icon-Data-Search",
  "solid-icon-Data-Security",
  "solid-icon-Data-Settings",
  "solid-icon-Data-Sharing",
  "solid-icon-Data-Shield",
  "solid-icon-Data-Signal",
  "solid-icon-Data-Storage",
  "solid-icon-Data-Stream",
  "solid-icon-Data-Transfer",
  "solid-icon-Data-Unlock",
  "solid-icon-Data-Upload",
  "solid-icon-Data-Yes",
  "solid-icon-Data",
  "solid-icon-David-Star",
  "solid-icon-Daylight",
  "solid-icon-Death",
  "solid-icon-Debian",
  "solid-icon-Dec",
  "solid-icon-Decrase-Inedit",
  "solid-icon-Deer-2",
  "solid-icon-Deer",
  "solid-icon-Delete-File",
  "solid-icon-Delete-Window",
  "solid-icon-Delicious",
  "solid-icon-Depression",
  "solid-icon-Deviantart",
  "solid-icon-Device-SyncwithCloud",
  "solid-icon-Diamond",
  "solid-icon-Dice-2",
  "solid-icon-Dice",
  "solid-icon-Digg",
  "solid-icon-Digital-Drawing",
  "solid-icon-Diigo",
  "solid-icon-Dinosaur",
  "solid-icon-Diploma-2",
  "solid-icon-Diploma",
  "solid-icon-Direction-East",
  "solid-icon-Direction-North",
  "solid-icon-Direction-South",
  "solid-icon-Direction-West",
  "solid-icon-Director",
  "solid-icon-Disk",
  "solid-icon-Dj",
  "solid-icon-DNA-2",
  "solid-icon-DNA-Helix",
  "solid-icon-DNA",
  "solid-icon-Doctor",
  "solid-icon-Dog",
  "solid-icon-Dollar-Sign",
  "solid-icon-Dollar-Sign2",
  "solid-icon-Dollar",
  "solid-icon-Dolphin",
  "solid-icon-Domino",
  "solid-icon-Door-Hanger",
  "solid-icon-Door",
  "solid-icon-Doplr",
  "solid-icon-Double-Circle",
  "solid-icon-Double-Tap",
  "solid-icon-Doughnut",
  "solid-icon-Dove",
  "solid-icon-Down-2",
  "solid-icon-Down-3",
  "solid-icon-Down-4",
  "solid-icon-Down",
  "solid-icon-Download-2",
  "solid-icon-Download-fromCloud",
  "solid-icon-Download-Window",
  "solid-icon-Download",
  "solid-icon-Downward",
  "solid-icon-Drag-Down",
  "solid-icon-Drag-Left",
  "solid-icon-Drag-Right",
  "solid-icon-Drag-Up",
  "solid-icon-Drag",
  "solid-icon-Dress",
  "solid-icon-Dribble",
  "solid-icon-Drill-2",
  "solid-icon-Drill",
  "solid-icon-Drop",
  "solid-icon-Dropbox",
  "solid-icon-Drum",
  "solid-icon-Dry",
  "solid-icon-Duck",
  "solid-icon-Dumbbell",
  "solid-icon-Duplicate-Layer",
  "solid-icon-Duplicate-Window",
  "solid-icon-DVD",
  "solid-icon-Eagle",
  "solid-icon-Ear",
  "solid-icon-Earphones-2",
  "solid-icon-Earphones",
  "solid-icon-Eci-Icon",
  "solid-icon-Edit-Map",
  "solid-icon-Edit",
  "solid-icon-Eggs",
  "solid-icon-Egypt",
  "solid-icon-Eifel-Tower",
  "solid-icon-Eject-2",
  "solid-icon-Eject",
  "solid-icon-El-Castillo",
  "solid-icon-Elbow",
  "solid-icon-Electric-Guitar",
  "solid-icon-Electricity",
  "solid-icon-Elephant",
  "solid-icon-Email",
  "solid-icon-Embassy",
  "solid-icon-Empire-StateBuilding",
  "solid-icon-Empty-Box",
  "solid-icon-End2",
  "solid-icon-End-2",
  "solid-icon-End",
  "solid-icon-Endways",
  "solid-icon-Engineering",
  "solid-icon-Envelope-2",
  "solid-icon-Envelope",
  "solid-icon-Environmental-2",
  "solid-icon-Environmental-3",
  "solid-icon-Environmental",
  "solid-icon-Equalizer",
  "solid-icon-Eraser-2",
  "solid-icon-Eraser-3",
  "solid-icon-Eraser",
  "solid-icon-Error-404Window",
  "solid-icon-Euro-Sign",
  "solid-icon-Euro-Sign2",
  "solid-icon-Euro",
  "solid-icon-Evernote",
  "solid-icon-Evil",
  "solid-icon-Explode",
  "solid-icon-Eye-2",
  "solid-icon-Eye-Blind",
  "solid-icon-Eye-Invisible",
  "solid-icon-Eye-Scan",
  "solid-icon-Eye-Visible",
  "solid-icon-Eye",
  "solid-icon-Eyebrow-2",
  "solid-icon-Eyebrow-3",
  "solid-icon-Eyebrow",
  "solid-icon-Eyeglasses-Smiley",
  "solid-icon-Eyeglasses-Smiley2",
  "solid-icon-Face-Style",
  "solid-icon-Face-Style2",
  "solid-icon-Face-Style3",
  "solid-icon-Face-Style4",
  "solid-icon-Face-Style5",
  "solid-icon-Face-Style6",
  "solid-icon-Facebook-2",
  "solid-icon-Facebook",
  "solid-icon-Factory-2",
  "solid-icon-Factory",
  "solid-icon-Fahrenheit",
  "solid-icon-Family-Sign",
  "solid-icon-Fan",
  "solid-icon-Farmer",
  "solid-icon-Fashion",
  "solid-icon-Favorite-Window",
  "solid-icon-Fax",
  "solid-icon-Feather",
  "solid-icon-Feedburner",
  "solid-icon-Female-2",
  "solid-icon-Female-Sign",
  "solid-icon-Female",
  "solid-icon-File-Block",
  "solid-icon-File-Bookmark",
  "solid-icon-File-Chart",
  "solid-icon-File-Clipboard",
  "solid-icon-File-ClipboardFileText",
  "solid-icon-File-ClipboardTextImage",
  "solid-icon-File-Cloud",
  "solid-icon-File-Copy",
  "solid-icon-File-Copy2",
  "solid-icon-File-CSV",
  "solid-icon-File-Download",
  "solid-icon-File-Edit",
  "solid-icon-File-Excel",
  "solid-icon-File-Favorite",
  "solid-icon-File-Fire",
  "solid-icon-File-Graph",
  "solid-icon-File-Hide",
  "solid-icon-File-Horizontal",
  "solid-icon-File-HorizontalText",
  "solid-icon-File-HTML",
  "solid-icon-File-JPG",
  "solid-icon-File-Link",
  "solid-icon-File-Loading",
  "solid-icon-File-Lock",
  "solid-icon-File-Love",
  "solid-icon-File-Music",
  "solid-icon-File-Network",
  "solid-icon-File-Pictures",
  "solid-icon-File-Pie",
  "solid-icon-File-Presentation",
  "solid-icon-File-Refresh",
  "solid-icon-File-Search",
  "solid-icon-File-Settings",
  "solid-icon-File-Share",
  "solid-icon-File-TextImage",
  "solid-icon-File-Trash",
  "solid-icon-File-TXT",
  "solid-icon-File-Upload",
  "solid-icon-File-Video",
  "solid-icon-File-Word",
  "solid-icon-File-Zip",
  "solid-icon-File",
  "solid-icon-Files",
  "solid-icon-Film-Board",
  "solid-icon-Film-Cartridge",
  "solid-icon-Film-Strip",
  "solid-icon-Film-Video",
  "solid-icon-Film",
  "solid-icon-Filter-2",
  "solid-icon-Filter",
  "solid-icon-Financial",
  "solid-icon-Find-User",
  "solid-icon-Finger-DragFourSides",
  "solid-icon-Finger-DragTwoSides",
  "solid-icon-Finger-Print",
  "solid-icon-Finger",
  "solid-icon-Fingerprint-2",
  "solid-icon-Fingerprint",
  "solid-icon-Fire-Flame",
  "solid-icon-Fire-Flame2",
  "solid-icon-Fire-Hydrant",
  "solid-icon-Fire-Staion",
  "solid-icon-Firefox",
  "solid-icon-Firewall",
  "solid-icon-First-Aid",
  "solid-icon-First",
  "solid-icon-Fish-Food",
  "solid-icon-Fish",
  "solid-icon-Fit-To",
  "solid-icon-Fit-To2",
  "solid-icon-Five-Fingers",
  "solid-icon-Five-FingersDrag",
  "solid-icon-Five-FingersDrag2",
  "solid-icon-Five-FingersTouch",
  "solid-icon-Flag-2",
  "solid-icon-Flag-3",
  "solid-icon-Flag-4",
  "solid-icon-Flag-5",
  "solid-icon-Flag-6",
  "solid-icon-Flag",
  "solid-icon-Flamingo",
  "solid-icon-Flash-2",
  "solid-icon-Flash-Video",
  "solid-icon-Flash",
  "solid-icon-Flashlight",
  "solid-icon-Flask-2",
  "solid-icon-Flask",
  "solid-icon-Flick",
  "solid-icon-Flickr",
  "solid-icon-Flowerpot",
  "solid-icon-Fluorescent",
  "solid-icon-Fog-Day",
  "solid-icon-Fog-Night",
  "solid-icon-Folder-Add",
  "solid-icon-Folder-Archive",
  "solid-icon-Folder-Binder",
  "solid-icon-Folder-Binder2",
  "solid-icon-Folder-Block",
  "solid-icon-Folder-Bookmark",
  "solid-icon-Folder-Close",
  "solid-icon-Folder-Cloud",
  "solid-icon-Folder-Delete",
  "solid-icon-Folder-Download",
  "solid-icon-Folder-Edit",
  "solid-icon-Folder-Favorite",
  "solid-icon-Folder-Fire",
  "solid-icon-Folder-Hide",
  "solid-icon-Folder-Link",
  "solid-icon-Folder-Loading",
  "solid-icon-Folder-Lock",
  "solid-icon-Folder-Love",
  "solid-icon-Folder-Music",
  "solid-icon-Folder-Network",
  "solid-icon-Folder-Open",
  "solid-icon-Folder-Open2",
  "solid-icon-Folder-Organizing",
  "solid-icon-Folder-Pictures",
  "solid-icon-Folder-Refresh",
  "solid-icon-Folder-Remove-",
  "solid-icon-Folder-Search",
  "solid-icon-Folder-Settings",
  "solid-icon-Folder-Share",
  "solid-icon-Folder-Trash",
  "solid-icon-Folder-Upload",
  "solid-icon-Folder-Video",
  "solid-icon-Folder-WithDocument",
  "solid-icon-Folder-Zip",
  "solid-icon-Folder",
  "solid-icon-Folders",
  "solid-icon-Font-Color",
  "solid-icon-Font-Name",
  "solid-icon-Font-Size",
  "solid-icon-Font-Style",
  "solid-icon-Font-StyleSubscript",
  "solid-icon-Font-StyleSuperscript",
  "solid-icon-Font-Window",
  "solid-icon-Foot-2",
  "solid-icon-Foot",
  "solid-icon-Football-2",
  "solid-icon-Football",
  "solid-icon-Footprint-2",
  "solid-icon-Footprint-3",
  "solid-icon-Footprint",
  "solid-icon-Forest",
  "solid-icon-Fork",
  "solid-icon-Formspring",
  "solid-icon-Formula",
  "solid-icon-Forsquare",
  "solid-icon-Forward",
  "solid-icon-Fountain-Pen",
  "solid-icon-Four-Fingers",
  "solid-icon-Four-FingersDrag",
  "solid-icon-Four-FingersDrag2",
  "solid-icon-Four-FingersTouch",
  "solid-icon-Fox",
  "solid-icon-Frankenstein",
  "solid-icon-French-Fries",
  "solid-icon-Friendfeed",
  "solid-icon-Friendster",
  "solid-icon-Frog",
  "solid-icon-Fruits",
  "solid-icon-Fuel",
  "solid-icon-Full-Basket",
  "solid-icon-Full-Cart",
  "solid-icon-Full-Moon",
  "solid-icon-Full-Screen",
  "solid-icon-Full-Screen2",
  "solid-icon-Full-View",
  "solid-icon-Full-View2",
  "solid-icon-Full-ViewWindow",
  "solid-icon-Function",
  "solid-icon-Funky",
  "solid-icon-Funny-Bicycle",
  "solid-icon-Furl",
  "solid-icon-Fyll-Bag",
  "solid-icon-Gamepad-2",
  "solid-icon-Gamepad",
  "solid-icon-Gas-Pump",
  "solid-icon-Gaugage-2",
  "solid-icon-Gaugage",
  "solid-icon-Gay",
  "solid-icon-Gear-2",
  "solid-icon-Gear",
  "solid-icon-Gears-2",
  "solid-icon-Gears",
  "solid-icon-Geek-2",
  "solid-icon-Geek",
  "solid-icon-Gemini-2",
  "solid-icon-Gemini",
  "solid-icon-Genius",
  "solid-icon-Gentleman",
  "solid-icon-Geo--",
  "solid-icon-Geo-",
  "solid-icon-Geo-Close",
  "solid-icon-Geo-Love",
  "solid-icon-Geo-Number",
  "solid-icon-Geo-Star",
  "solid-icon-Geo",
  "solid-icon-Geo2--",
  "solid-icon-Geo2-",
  "solid-icon-Geo2-Close",
  "solid-icon-Geo2-Love",
  "solid-icon-Geo2-Number",
  "solid-icon-Geo2-Star",
  "solid-icon-Geo2",
  "solid-icon-Geo3--",
  "solid-icon-Geo3-",
  "solid-icon-Geo3-Close",
  "solid-icon-Geo3-Love",
  "solid-icon-Geo3-Number",
  "solid-icon-Geo3-Star",
  "solid-icon-Geo3",
  "solid-icon-Gey",
  "solid-icon-Gift-Box",
  "solid-icon-Giraffe",
  "solid-icon-Girl",
  "solid-icon-Glass-Water",
  "solid-icon-Glasses-2",
  "solid-icon-Glasses-3",
  "solid-icon-Glasses",
  "solid-icon-Global-Position",
  "solid-icon-Globe-2",
  "solid-icon-Globe",
  "solid-icon-Gloves",
  "solid-icon-Go-Bottom",
  "solid-icon-Go-Top",
  "solid-icon-Goggles",
  "solid-icon-Golf-2",
  "solid-icon-Golf",
  "solid-icon-Google-Buzz",
  "solid-icon-Google-Drive",
  "solid-icon-Google-Play",
  "solid-icon-Google-Plus",
  "solid-icon-Google",
  "solid-icon-Gopro",
  "solid-icon-Gorilla",
  "solid-icon-Gowalla",
  "solid-icon-Grave",
  "solid-icon-Graveyard",
  "solid-icon-Greece",
  "solid-icon-Green-Energy",
  "solid-icon-Green-House",
  "solid-icon-Guitar",
  "solid-icon-Gun-2",
  "solid-icon-Gun-3",
  "solid-icon-Gun",
  "solid-icon-Gymnastics",
  "solid-icon-Hair-2",
  "solid-icon-Hair-3",
  "solid-icon-Hair-4",
  "solid-icon-Hair",
  "solid-icon-Half-Moon",
  "solid-icon-Halloween-HalfMoon",
  "solid-icon-Halloween-Moon",
  "solid-icon-Hamburger",
  "solid-icon-Hammer",
  "solid-icon-Hand-Touch",
  "solid-icon-Hand-Touch2",
  "solid-icon-Hand-TouchSmartphone",
  "solid-icon-Hand",
  "solid-icon-Hands",
  "solid-icon-Handshake",
  "solid-icon-Hanger",
  "solid-icon-Happy",
  "solid-icon-Hat-2",
  "solid-icon-Hat",
  "solid-icon-Haunted-House",
  "solid-icon-HD-Video",
  "solid-icon-HD",
  "solid-icon-HDD",
  "solid-icon-Headphone",
  "solid-icon-Headphones",
  "solid-icon-Headset",
  "solid-icon-Heart-2",
  "solid-icon-Heart",
  "solid-icon-Heels-2",
  "solid-icon-Heels",
  "solid-icon-Height-Window",
  "solid-icon-Helicopter-2",
  "solid-icon-Helicopter",
  "solid-icon-Helix-2",
  "solid-icon-Hello",
  "solid-icon-Helmet-2",
  "solid-icon-Helmet-3",
  "solid-icon-Helmet",
  "solid-icon-Hipo",
  "solid-icon-Hipster-Glasses",
  "solid-icon-Hipster-Glasses2",
  "solid-icon-Hipster-Glasses3",
  "solid-icon-Hipster-Headphones",
  "solid-icon-Hipster-Men",
  "solid-icon-Hipster-Men2",
  "solid-icon-Hipster-Men3",
  "solid-icon-Hipster-Sunglasses",
  "solid-icon-Hipster-Sunglasses2",
  "solid-icon-Hipster-Sunglasses3",
  "solid-icon-Hokey",
  "solid-icon-Holly",
  "solid-icon-Home-2",
  "solid-icon-Home-3",
  "solid-icon-Home-4",
  "solid-icon-Home-5",
  "solid-icon-Home-Window",
  "solid-icon-Home",
  "solid-icon-Homosexual",
  "solid-icon-Honey",
  "solid-icon-Hong-Kong",
  "solid-icon-Hoodie",
  "solid-icon-Horror",
  "solid-icon-Horse",
  "solid-icon-Hospital-2",
  "solid-icon-Hospital",
  "solid-icon-Host",
  "solid-icon-Hot-Dog",
  "solid-icon-Hotel",
  "solid-icon-Hour",
  "solid-icon-Hub",
  "solid-icon-Humor",
  "solid-icon-Hurt",
  "solid-icon-Ice-Cream",
  "solid-icon-ICQ",
  "solid-icon-ID-2",
  "solid-icon-ID-3",
  "solid-icon-ID-Card",
  "solid-icon-Idea-2",
  "solid-icon-Idea-3",
  "solid-icon-Idea-4",
  "solid-icon-Idea-5",
  "solid-icon-Idea",
  "solid-icon-Identification-Badge",
  "solid-icon-ImDB",
  "solid-icon-Inbox-Empty",
  "solid-icon-Inbox-Forward",
  "solid-icon-Inbox-Full",
  "solid-icon-Inbox-Into",
  "solid-icon-Inbox-Out",
  "solid-icon-Inbox-Reply",
  "solid-icon-Inbox",
  "solid-icon-Increase-Inedit",
  "solid-icon-Indent-FirstLine",
  "solid-icon-Indent-LeftMargin",
  "solid-icon-Indent-RightMargin",
  "solid-icon-India",
  "solid-icon-Info-Window",
  "solid-icon-Information",
  "solid-icon-Inifity",
  "solid-icon-Instagram",
  "solid-icon-Internet-2",
  "solid-icon-Internet-Explorer",
  "solid-icon-Internet-Smiley",
  "solid-icon-Internet",
  "solid-icon-iOS-Apple",
  "solid-icon-Israel",
  "solid-icon-Italic-Text",
  "solid-icon-Jacket-2",
  "solid-icon-Jacket",
  "solid-icon-Jamaica",
  "solid-icon-Japan",
  "solid-icon-Japanese-Gate",
  "solid-icon-Jeans",
  "solid-icon-Jeep-2",
  "solid-icon-Jeep",
  "solid-icon-Jet",
  "solid-icon-Joystick",
  "solid-icon-Juice",
  "solid-icon-Jump-Rope",
  "solid-icon-Kangoroo",
  "solid-icon-Kenya",
  "solid-icon-Key-2",
  "solid-icon-Key-3",
  "solid-icon-Key-Lock",
  "solid-icon-Key",
  "solid-icon-Keyboard",
  "solid-icon-Keyboard3",
  "solid-icon-Keypad",
  "solid-icon-King-2",
  "solid-icon-King",
  "solid-icon-Kiss",
  "solid-icon-Knee",
  "solid-icon-Knife-2",
  "solid-icon-Knife",
  "solid-icon-Knight",
  "solid-icon-Koala",
  "solid-icon-Korea",
  "solid-icon-Lamp",
  "solid-icon-Landscape-2",
  "solid-icon-Landscape",
  "solid-icon-Lantern",
  "solid-icon-Laptop-2",
  "solid-icon-Laptop-3",
  "solid-icon-Laptop-Phone",
  "solid-icon-Laptop-Secure",
  "solid-icon-Laptop-Tablet",
  "solid-icon-Laptop",
  "solid-icon-Laser",
  "solid-icon-Last-FM",
  "solid-icon-Last",
  "solid-icon-Laughing",
  "solid-icon-Layer-Backward",
  "solid-icon-Layer-Forward",
  "solid-icon-Leafs-2",
  "solid-icon-Leafs",
  "solid-icon-Leaning-Tower",
  "solid-icon-Left--Right",
  "solid-icon-Left--Right3",
  "solid-icon-Left-2",
  "solid-icon-Left-3",
  "solid-icon-Left-4",
  "solid-icon-Left-ToRight",
  "solid-icon-Left",
  "solid-icon-Leg-2",
  "solid-icon-Leg",
  "solid-icon-Lego",
  "solid-icon-Lemon",
  "solid-icon-Len-2",
  "solid-icon-Len-3",
  "solid-icon-Len",
  "solid-icon-Leo-2",
  "solid-icon-Leo",
  "solid-icon-Leopard",
  "solid-icon-Lesbian",
  "solid-icon-Lesbians",
  "solid-icon-Letter-Close",
  "solid-icon-Letter-Open",
  "solid-icon-Letter-Sent",
  "solid-icon-Libra-2",
  "solid-icon-Libra",
  "solid-icon-Library-2",
  "solid-icon-Library",
  "solid-icon-Life-Jacket",
  "solid-icon-Life-Safer",
  "solid-icon-Light-Bulb",
  "solid-icon-Light-Bulb2",
  "solid-icon-Light-BulbLeaf",
  "solid-icon-Lighthouse",
  "solid-icon-Like-2",
  "solid-icon-Like",
  "solid-icon-Line-Chart",
  "solid-icon-Line-Chart2",
  "solid-icon-Line-Chart3",
  "solid-icon-Line-Chart4",
  "solid-icon-Line-Spacing",
  "solid-icon-Line-SpacingText",
  "solid-icon-Link-2",
  "solid-icon-Link",
  "solid-icon-Linkedin-2",
  "solid-icon-Linkedin",
  "solid-icon-Linux",
  "solid-icon-Lion",
  "solid-icon-Livejournal",
  "solid-icon-Loading-2",
  "solid-icon-Loading-3",
  "solid-icon-Loading-Window",
  "solid-icon-Loading",
  "solid-icon-Location-2",
  "solid-icon-Location",
  "solid-icon-Lock-2",
  "solid-icon-Lock-3",
  "solid-icon-Lock-User",
  "solid-icon-Lock-Window",
  "solid-icon-Lock",
  "solid-icon-Lollipop-2",
  "solid-icon-Lollipop-3",
  "solid-icon-Lollipop",
  "solid-icon-Loop",
  "solid-icon-Loud",
  "solid-icon-Loudspeaker",
  "solid-icon-Love-2",
  "solid-icon-Love-User",
  "solid-icon-Love-Window",
  "solid-icon-Love",
  "solid-icon-Lowercase-Text",
  "solid-icon-Luggafe-Front",
  "solid-icon-Luggage-2",
  "solid-icon-Macro",
  "solid-icon-Magic-Wand",
  "solid-icon-Magnet",
  "solid-icon-Magnifi-Glass-",
  "solid-icon-Magnifi-Glass",
  "solid-icon-Magnifi-Glass2",
  "solid-icon-Mail-2",
  "solid-icon-Mail-3",
  "solid-icon-Mail-Add",
  "solid-icon-Mail-Attachement",
  "solid-icon-Mail-Block",
  "solid-icon-Mail-Delete",
  "solid-icon-Mail-Favorite",
  "solid-icon-Mail-Forward",
  "solid-icon-Mail-Gallery",
  "solid-icon-Mail-Inbox",
  "solid-icon-Mail-Link",
  "solid-icon-Mail-Lock",
  "solid-icon-Mail-Love",
  "solid-icon-Mail-Money",
  "solid-icon-Mail-Open",
  "solid-icon-Mail-Outbox",
  "solid-icon-Mail-Password",
  "solid-icon-Mail-Photo",
  "solid-icon-Mail-Read",
  "solid-icon-Mail-Removex",
  "solid-icon-Mail-Reply",
  "solid-icon-Mail-ReplyAll",
  "solid-icon-Mail-Search",
  "solid-icon-Mail-Send",
  "solid-icon-Mail-Settings",
  "solid-icon-Mail-Unread",
  "solid-icon-Mail-Video",
  "solid-icon-Mail-withAtSign",
  "solid-icon-Mail-WithCursors",
  "solid-icon-Mail",
  "solid-icon-Mailbox-Empty",
  "solid-icon-Mailbox-Full",
  "solid-icon-Male-2",
  "solid-icon-Male-Sign",
  "solid-icon-Male",
  "solid-icon-MaleFemale",
  "solid-icon-Man-Sign",
  "solid-icon-Management",
  "solid-icon-Mans-Underwear",
  "solid-icon-Mans-Underwear2",
  "solid-icon-Map-Marker",
  "solid-icon-Map-Marker2",
  "solid-icon-Map-Marker3",
  "solid-icon-Map",
  "solid-icon-Map2",
  "solid-icon-Marker-2",
  "solid-icon-Marker-3",
  "solid-icon-Marker",
  "solid-icon-Martini-Glass",
  "solid-icon-Mask",
  "solid-icon-Master-Card",
  "solid-icon-Maximize-Window",
  "solid-icon-Maximize",
  "solid-icon-Medal-2",
  "solid-icon-Medal-3",
  "solid-icon-Medal",
  "solid-icon-Medical-Sign",
  "solid-icon-Medicine-2",
  "solid-icon-Medicine-3",
  "solid-icon-Medicine",
  "solid-icon-Megaphone",
  "solid-icon-Memory-Card",
  "solid-icon-Memory-Card2",
  "solid-icon-Memory-Card3",
  "solid-icon-Men",
  "solid-icon-Menorah",
  "solid-icon-Mens",
  "solid-icon-Metacafe",
  "solid-icon-Mexico",
  "solid-icon-Mic",
  "solid-icon-Microphone-2",
  "solid-icon-Microphone-3",
  "solid-icon-Microphone-4",
  "solid-icon-Microphone-5",
  "solid-icon-Microphone-6",
  "solid-icon-Microphone-8",
  "solid-icon-Microphone",
  "solid-icon-Microscope",
  "solid-icon-Milk-Bottle",
  "solid-icon-Mine",
  "solid-icon-Minimize-Maximize-Close-Window",
  "solid-icon-Minimize-Window",
  "solid-icon-Minimize",
  "solid-icon-Mirror",
  "solid-icon-Mixer",
  "solid-icon-Mixx",
  "solid-icon-Money-2",
  "solid-icon-Money-Bag",
  "solid-icon-Money-Smiley",
  "solid-icon-Money",
  "solid-icon-Monitor-2",
  "solid-icon-Monitor-3",
  "solid-icon-Monitor-4",
  "solid-icon-Monitor-5",
  "solid-icon-Monitor-Analytics",
  "solid-icon-Monitor-Laptop",
  "solid-icon-Monitor-phone",
  "solid-icon-Monitor-Tablet",
  "solid-icon-Monitor-Vertical",
  "solid-icon-Monitor",
  "solid-icon-Monitoring",
  "solid-icon-Monkey",
  "solid-icon-Monster",
  "solid-icon-Morocco",
  "solid-icon-Motorcycle",
  "solid-icon-Mouse-2",
  "solid-icon-Mouse-3",
  "solid-icon-Mouse-4",
  "solid-icon-Mouse-Pointer",
  "solid-icon-Mouse",
  "solid-icon-Moustache-Smiley",
  "solid-icon-Movie-Ticket",
  "solid-icon-Movie",
  "solid-icon-Mp3-File",
  "solid-icon-Museum",
  "solid-icon-Mushroom",
  "solid-icon-Music-Note",
  "solid-icon-Music-Note2",
  "solid-icon-Music-Note3",
  "solid-icon-Music-Note4",
  "solid-icon-Music-Player",
  "solid-icon-Mustache-2",
  "solid-icon-Mustache-3",
  "solid-icon-Mustache-4",
  "solid-icon-Mustache-5",
  "solid-icon-Mustache-6",
  "solid-icon-Mustache-7",
  "solid-icon-Mustache-8",
  "solid-icon-Mustache",
  "solid-icon-Mute",
  "solid-icon-Myspace",
  "solid-icon-Navigat-Start",
  "solid-icon-Navigate-End",
  "solid-icon-Navigation-LeftWindow",
  "solid-icon-Navigation-RightWindow",
  "solid-icon-Nepal",
  "solid-icon-Netscape",
  "solid-icon-Network-Window",
  "solid-icon-Network",
  "solid-icon-Neutron",
  "solid-icon-New-Mail",
  "solid-icon-New-Tab",
  "solid-icon-Newspaper-2",
  "solid-icon-Newspaper",
  "solid-icon-Newsvine",
  "solid-icon-Next-3",
  "solid-icon-Next-Media",
  "solid-icon-Next-Music",
  "solid-icon-Next",
  "solid-icon-No-Battery",
  "solid-icon-No-Drop",
  "solid-icon-No-Flash",
  "solid-icon-No-Smoking",
  "solid-icon-Noose",
  "solid-icon-Normal-Text",
  "solid-icon-Note",
  "solid-icon-Notepad-2",
  "solid-icon-Notepad",
  "solid-icon-Nuclear",
  "solid-icon-Numbering-List",
  "solid-icon-Nurse",
  "solid-icon-Office-Lamp",
  "solid-icon-Office",
  "solid-icon-Oil",
  "solid-icon-Old-Camera",
  "solid-icon-Old-Cassette",
  "solid-icon-Old-Clock",
  "solid-icon-Old-Radio",
  "solid-icon-Old-Sticky",
  "solid-icon-Old-Sticky2",
  "solid-icon-Old-Telephone",
  "solid-icon-Old-TV",
  "solid-icon-On-Air",
  "solid-icon-On-Off-2",
  "solid-icon-On-Off-3",
  "solid-icon-On-off",
  "solid-icon-One-Finger",
  "solid-icon-One-FingerTouch",
  "solid-icon-One-Window",
  "solid-icon-Open-Banana",
  "solid-icon-Open-Book",
  "solid-icon-Opera-House",
  "solid-icon-Opera",
  "solid-icon-Optimization",
  "solid-icon-Orientation-2",
  "solid-icon-Orientation-3",
  "solid-icon-Orientation",
  "solid-icon-Orkut",
  "solid-icon-Ornament",
  "solid-icon-Over-Time",
  "solid-icon-Over-Time2",
  "solid-icon-Owl",
  "solid-icon-Pac-Man",
  "solid-icon-Paint-Brush",
  "solid-icon-Paint-Bucket",
  "solid-icon-Paintbrush",
  "solid-icon-Palette",
  "solid-icon-Palm-Tree",
  "solid-icon-Panda",
  "solid-icon-Panorama",
  "solid-icon-Pantheon",
  "solid-icon-Pantone",
  "solid-icon-Pants",
  "solid-icon-Paper-Plane",
  "solid-icon-Paper",
  "solid-icon-Parasailing",
  "solid-icon-Parrot",
  "solid-icon-Password-2shopping",
  "solid-icon-Password-Field",
  "solid-icon-Password-shopping",
  "solid-icon-Password",
  "solid-icon-Pause-2",
  "solid-icon-Pause",
  "solid-icon-Paw",
  "solid-icon-Pawn",
  "solid-icon-Paypal",
  "solid-icon-Pen-2",
  "solid-icon-Pen-3",
  "solid-icon-Pen-4",
  "solid-icon-Pen-5",
  "solid-icon-Pen-6",
  "solid-icon-Pen",
  "solid-icon-Pencil-Ruler",
  "solid-icon-Pencil",
  "solid-icon-Penguin",
  "solid-icon-Pentagon",
  "solid-icon-People-onCloud",
  "solid-icon-Pepper-withFire",
  "solid-icon-Pepper",
  "solid-icon-Petrol",
  "solid-icon-Petronas-Tower",
  "solid-icon-Philipines",
  "solid-icon-Phone-2",
  "solid-icon-Phone-3",
  "solid-icon-Phone-3G",
  "solid-icon-Phone-4G",
  "solid-icon-Phone-Simcard",
  "solid-icon-Phone-SMS",
  "solid-icon-Phone-Wifi",
  "solid-icon-Phone",
  "solid-icon-Photo-2",
  "solid-icon-Photo-3",
  "solid-icon-Photo-Album",
  "solid-icon-Photo-Album2",
  "solid-icon-Photo-Album3",
  "solid-icon-Photo",
  "solid-icon-Photos",
  "solid-icon-Physics",
  "solid-icon-Pi",
  "solid-icon-Piano",
  "solid-icon-Picasa",
  "solid-icon-Pie-Chart",
  "solid-icon-Pie-Chart2",
  "solid-icon-Pie-Chart3",
  "solid-icon-Pilates-2",
  "solid-icon-Pilates-3",
  "solid-icon-Pilates",
  "solid-icon-Pilot",
  "solid-icon-Pinch",
  "solid-icon-Ping-Pong",
  "solid-icon-Pinterest",
  "solid-icon-Pipe",
  "solid-icon-Pipette",
  "solid-icon-Piramids",
  "solid-icon-Pisces-2",
  "solid-icon-Pisces",
  "solid-icon-Pizza-Slice",
  "solid-icon-Pizza",
  "solid-icon-Plane-2",
  "solid-icon-Plane",
  "solid-icon-Plant",
  "solid-icon-Plasmid",
  "solid-icon-Plaster",
  "solid-icon-Plastic-CupPhone",
  "solid-icon-Plastic-CupPhone2",
  "solid-icon-Plate",
  "solid-icon-Plates",
  "solid-icon-Plaxo",
  "solid-icon-Play-Music",
  "solid-icon-Plug-In",
  "solid-icon-Plug-In2",
  "solid-icon-Plurk",
  "solid-icon-Pointer",
  "solid-icon-Poland",
  "solid-icon-Police-Man",
  "solid-icon-Police-Station",
  "solid-icon-Police-Woman",
  "solid-icon-Police",
  "solid-icon-Polo-Shirt",
  "solid-icon-Portrait",
  "solid-icon-Portugal",
  "solid-icon-Post-Mail",
  "solid-icon-Post-Mail2",
  "solid-icon-Post-Office",
  "solid-icon-Post-Sign",
  "solid-icon-Post-Sign2ways",
  "solid-icon-Posterous",
  "solid-icon-Pound-Sign",
  "solid-icon-Pound-Sign2",
  "solid-icon-Pound",
  "solid-icon-Power-2",
  "solid-icon-Power-3",
  "solid-icon-Power-Cable",
  "solid-icon-Power-Station",
  "solid-icon-Power",
  "solid-icon-Prater",
  "solid-icon-Present",
  "solid-icon-Presents",
  "solid-icon-Press",
  "solid-icon-Preview",
  "solid-icon-Previous",
  "solid-icon-Pricing",
  "solid-icon-Printer",
  "solid-icon-Professor",
  "solid-icon-Profile",
  "solid-icon-Project",
  "solid-icon-Projector-2",
  "solid-icon-Projector",
  "solid-icon-Pulse",
  "solid-icon-Pumpkin",
  "solid-icon-Punk",
  "solid-icon-Punker",
  "solid-icon-Puzzle",
  "solid-icon-QIK",
  "solid-icon-QR-Code",
  "solid-icon-Queen-2",
  "solid-icon-Queen",
  "solid-icon-Quill-2",
  "solid-icon-Quill-3",
  "solid-icon-Quill",
  "solid-icon-Quotes-2",
  "solid-icon-Quotes",
  "solid-icon-Radio",
  "solid-icon-Radioactive",
  "solid-icon-Rafting",
  "solid-icon-Rain-Drop",
  "solid-icon-Rainbow-2",
  "solid-icon-Rainbow",
  "solid-icon-Ram",
  "solid-icon-Razzor-Blade",
  "solid-icon-Receipt-2",
  "solid-icon-Receipt-3",
  "solid-icon-Receipt-4",
  "solid-icon-Receipt",
  "solid-icon-Record-3",
  "solid-icon-Record-Media",
  "solid-icon-Record-Music",
  "solid-icon-Record",
  "solid-icon-Recycling-2",
  "solid-icon-Recycling",
  "solid-icon-Reddit",
  "solid-icon-Redhat",
  "solid-icon-Redirect",
  "solid-icon-Redo",
  "solid-icon-Reel",
  "solid-icon-Refinery",
  "solid-icon-Refresh-Window",
  "solid-icon-Refresh",
  "solid-icon-Reload-2",
  "solid-icon-Reload-3",
  "solid-icon-Reload",
  "solid-icon-Remote-Controll",
  "solid-icon-Remote-Controll2",
  "solid-icon-Remove-Bag",
  "solid-icon-Remove-Basket",
  "solid-icon-Remove-Cart",
  "solid-icon-Remove-File",
  "solid-icon-Remove-User",
  "solid-icon-Remove-Window",
  "solid-icon-Remove",
  "solid-icon-Rename",
  "solid-icon-Repair",
  "solid-icon-Repeat-2",
  "solid-icon-Repeat-3",
  "solid-icon-Repeat-4",
  "solid-icon-Repeat-5",
  "solid-icon-Repeat-6",
  "solid-icon-Repeat-7",
  "solid-icon-Repeat",
  "solid-icon-Reset",
  "solid-icon-Resize",
  "solid-icon-Restore-Window",
  "solid-icon-Retouching",
  "solid-icon-Retro-Camera",
  "solid-icon-Retro",
  "solid-icon-Retweet",
  "solid-icon-Reverbnation",
  "solid-icon-Rewind",
  "solid-icon-RGB",
  "solid-icon-Ribbon-2",
  "solid-icon-Ribbon-3",
  "solid-icon-Ribbon",
  "solid-icon-Right-2",
  "solid-icon-Right-3",
  "solid-icon-Right-4",
  "solid-icon-Right-ToLeft",
  "solid-icon-Right",
  "solid-icon-Road-2",
  "solid-icon-Road-3",
  "solid-icon-Road",
  "solid-icon-Robot-2",
  "solid-icon-Robot",
  "solid-icon-Rock-andRoll",
  "solid-icon-Rocket",
  "solid-icon-Roller",
  "solid-icon-Roof",
  "solid-icon-Rook",
  "solid-icon-Rotate-Gesture",
  "solid-icon-Rotate-Gesture2",
  "solid-icon-Rotate-Gesture3",
  "solid-icon-Rotation-390",
  "solid-icon-Rotation",
  "solid-icon-Router-2",
  "solid-icon-Router",
  "solid-icon-RSS",
  "solid-icon-Ruler-2",
  "solid-icon-Ruler",
  "solid-icon-Running-Shoes",
  "solid-icon-Running",
  "solid-icon-Safari",
  "solid-icon-Safe-Box",
  "solid-icon-Safe-Box2",
  "solid-icon-Safety-PinClose",
  "solid-icon-Safety-PinOpen",
  "solid-icon-Sagittarus-2",
  "solid-icon-Sagittarus",
  "solid-icon-Sailing-Ship",
  "solid-icon-Sand-watch",
  "solid-icon-Sand-watch2",
  "solid-icon-Santa-Claus",
  "solid-icon-Santa-Claus2",
  "solid-icon-Santa-onSled",
  "solid-icon-Satelite-2",
  "solid-icon-Satelite",
  "solid-icon-Save-Window",
  "solid-icon-Save",
  "solid-icon-Saw",
  "solid-icon-Saxophone",
  "solid-icon-Scale",
  "solid-icon-Scarf",
  "solid-icon-Scissor",
  "solid-icon-Scooter-Front",
  "solid-icon-Scooter",
  "solid-icon-Scorpio-2",
  "solid-icon-Scorpio",
  "solid-icon-Scotland",
  "solid-icon-Screwdriver",
  "solid-icon-Scroll-Fast",
  "solid-icon-Scroll",
  "solid-icon-Scroller-2",
  "solid-icon-Scroller",
  "solid-icon-Sea-Dog",
  "solid-icon-Search-onCloud",
  "solid-icon-Search-People",
  "solid-icon-secound",
  "solid-icon-secound2",
  "solid-icon-Security-Block",
  "solid-icon-Security-Bug",
  "solid-icon-Security-Camera",
  "solid-icon-Security-Check",
  "solid-icon-Security-Settings",
  "solid-icon-Security-Smiley",
  "solid-icon-Securiy-Remove",
  "solid-icon-Seed",
  "solid-icon-Selfie",
  "solid-icon-Serbia",
  "solid-icon-Server-2",
  "solid-icon-Server",
  "solid-icon-Servers",
  "solid-icon-Settings-Window",
  "solid-icon-Sewing-Machine",
  "solid-icon-Sexual",
  "solid-icon-Share-onCloud",
  "solid-icon-Share-Window",
  "solid-icon-Share",
  "solid-icon-Sharethis",
  "solid-icon-Shark",
  "solid-icon-Sheep",
  "solid-icon-Sheriff-Badge",
  "solid-icon-Shield",
  "solid-icon-Ship-2",
  "solid-icon-Ship",
  "solid-icon-Shirt",
  "solid-icon-Shoes-2",
  "solid-icon-Shoes-3",
  "solid-icon-Shoes",
  "solid-icon-Shop-2",
  "solid-icon-Shop-3",
  "solid-icon-Shop-4",
  "solid-icon-Shop",
  "solid-icon-Shopping-Bag",
  "solid-icon-Shopping-Basket",
  "solid-icon-Shopping-Cart",
  "solid-icon-Short-Pants",
  "solid-icon-Shoutwire",
  "solid-icon-Shovel",
  "solid-icon-Shuffle-2",
  "solid-icon-Shuffle-3",
  "solid-icon-Shuffle-4",
  "solid-icon-Shuffle",
  "solid-icon-Shutter",
  "solid-icon-Sidebar-Window",
  "solid-icon-Signal",
  "solid-icon-Singapore",
  "solid-icon-Skate-Shoes",
  "solid-icon-Skateboard-2",
  "solid-icon-Skateboard",
  "solid-icon-Skeleton",
  "solid-icon-Ski",
  "solid-icon-Skirt",
  "solid-icon-Skrill",
  "solid-icon-Skull",
  "solid-icon-Skydiving",
  "solid-icon-Skype",
  "solid-icon-Sled-withGifts",
  "solid-icon-Sled",
  "solid-icon-Sleeping",
  "solid-icon-Sleet",
  "solid-icon-Slippers",
  "solid-icon-Smart",
  "solid-icon-Smartphone-2",
  "solid-icon-Smartphone-3",
  "solid-icon-Smartphone-4",
  "solid-icon-Smartphone-Secure",
  "solid-icon-Smartphone",
  "solid-icon-Smile",
  "solid-icon-Smoking-Area",
  "solid-icon-Smoking-Pipe",
  "solid-icon-Snake",
  "solid-icon-Snorkel",
  "solid-icon-Snow-2",
  "solid-icon-Snow-Dome",
  "solid-icon-Snow-Storm",
  "solid-icon-Snow",
  "solid-icon-Snowflake-2",
  "solid-icon-Snowflake-3",
  "solid-icon-Snowflake-4",
  "solid-icon-Snowflake",
  "solid-icon-Snowman",
  "solid-icon-Soccer-Ball",
  "solid-icon-Soccer-Shoes",
  "solid-icon-Socks",
  "solid-icon-Solar",
  "solid-icon-Sound-Wave",
  "solid-icon-Sound",
  "solid-icon-Soundcloud",
  "solid-icon-Soup",
  "solid-icon-South-Africa",
  "solid-icon-Space-Needle",
  "solid-icon-Spain",
  "solid-icon-Spam-Mail",
  "solid-icon-Speach-Bubble",
  "solid-icon-Speach-Bubble2",
  "solid-icon-Speach-Bubble3",
  "solid-icon-Speach-Bubble4",
  "solid-icon-Speach-Bubble5",
  "solid-icon-Speach-Bubble6",
  "solid-icon-Speach-Bubble7",
  "solid-icon-Speach-Bubble8",
  "solid-icon-Speach-Bubble9",
  "solid-icon-Speach-Bubble10",
  "solid-icon-Speach-Bubble11",
  "solid-icon-Speach-Bubble12",
  "solid-icon-Speach-Bubble13",
  "solid-icon-Speach-BubbleAsking",
  "solid-icon-Speach-BubbleComic",
  "solid-icon-Speach-BubbleComic2",
  "solid-icon-Speach-BubbleComic3",
  "solid-icon-Speach-BubbleComic4",
  "solid-icon-Speach-BubbleDialog",
  "solid-icon-Speach-Bubbles",
  "solid-icon-Speak-2",
  "solid-icon-Speak",
  "solid-icon-Speaker-2",
  "solid-icon-Speaker",
  "solid-icon-Spell-Check",
  "solid-icon-Spell-CheckABC",
  "solid-icon-Spermium",
  "solid-icon-Spider",
  "solid-icon-Spiderweb",
  "solid-icon-Split-FourSquareWindow",
  "solid-icon-Split-Horizontal",
  "solid-icon-Split-Horizontal2Window",
  "solid-icon-Split-Vertical",
  "solid-icon-Split-Vertical2",
  "solid-icon-Split-Window",
  "solid-icon-Spoder",
  "solid-icon-Spoon",
  "solid-icon-Sport-Mode",
  "solid-icon-Sports-Clothings1",
  "solid-icon-Sports-Clothings2",
  "solid-icon-Sports-Shirt",
  "solid-icon-Spot",
  "solid-icon-Spray",
  "solid-icon-Spread",
  "solid-icon-Spring",
  "solid-icon-Spurl",
  "solid-icon-Spy",
  "solid-icon-Squirrel",
  "solid-icon-SSL",
  "solid-icon-St-BasilsCathedral",
  "solid-icon-St-PaulsCathedral",
  "solid-icon-Stamp-2",
  "solid-icon-Stamp",
  "solid-icon-Stapler",
  "solid-icon-Star-Track",
  "solid-icon-Star",
  "solid-icon-Starfish",
  "solid-icon-Start2",
  "solid-icon-Start-3",
  "solid-icon-Start-ways",
  "solid-icon-Start",
  "solid-icon-Statistic",
  "solid-icon-Stethoscope",
  "solid-icon-Stop-2",
  "solid-icon-Stop-Music",
  "solid-icon-Stop",
  "solid-icon-Stopwatch-2",
  "solid-icon-Stopwatch",
  "solid-icon-Storm",
  "solid-icon-Street-View",
  "solid-icon-Street-View2",
  "solid-icon-Strikethrough-Text",
  "solid-icon-Stroller",
  "solid-icon-Structure",
  "solid-icon-Student-Female",
  "solid-icon-Student-Hat",
  "solid-icon-Student-Hat2",
  "solid-icon-Student-Male",
  "solid-icon-Student-MaleFemale",
  "solid-icon-Students",
  "solid-icon-Studio-Flash",
  "solid-icon-Studio-Lightbox",
  "solid-icon-Stumbleupon",
  "solid-icon-Suit",
  "solid-icon-Suitcase",
  "solid-icon-Sum-2",
  "solid-icon-Sum",
  "solid-icon-Summer",
  "solid-icon-Sun-CloudyRain",
  "solid-icon-Sun",
  "solid-icon-Sunglasses-2",
  "solid-icon-Sunglasses-3",
  "solid-icon-Sunglasses-Smiley",
  "solid-icon-Sunglasses-Smiley2",
  "solid-icon-Sunglasses-W",
  "solid-icon-Sunglasses-W2",
  "solid-icon-Sunglasses-W3",
  "solid-icon-Sunglasses",
  "solid-icon-Sunrise",
  "solid-icon-Sunset",
  "solid-icon-Superman",
  "solid-icon-Support",
  "solid-icon-Surprise",
  "solid-icon-Sushi",
  "solid-icon-Sweden",
  "solid-icon-Swimming-Short",
  "solid-icon-Swimming",
  "solid-icon-Swimmwear",
  "solid-icon-Switch",
  "solid-icon-Switzerland",
  "solid-icon-Sync-Cloud",
  "solid-icon-Sync",
  "solid-icon-Synchronize-2",
  "solid-icon-Synchronize",
  "solid-icon-T-Shirt",
  "solid-icon-Tablet-2",
  "solid-icon-Tablet-3",
  "solid-icon-Tablet-Orientation",
  "solid-icon-Tablet-Phone",
  "solid-icon-Tablet-Secure",
  "solid-icon-Tablet-Vertical",
  "solid-icon-Tablet",
  "solid-icon-Tactic",
  "solid-icon-Tag-2",
  "solid-icon-Tag-3",
  "solid-icon-Tag-4",
  "solid-icon-Tag-5",
  "solid-icon-Tag",
  "solid-icon-Taj-Mahal",
  "solid-icon-Talk-Man",
  "solid-icon-Tap",
  "solid-icon-Target-Market",
  "solid-icon-Target",
  "solid-icon-Taurus-2",
  "solid-icon-Taurus",
  "solid-icon-Taxi-2",
  "solid-icon-Taxi-Sign",
  "solid-icon-Taxi",
  "solid-icon-Teacher",
  "solid-icon-Teapot",
  "solid-icon-Technorati",
  "solid-icon-Teddy-Bear",
  "solid-icon-Tee-Mug",
  "solid-icon-Telephone-2",
  "solid-icon-Telephone",
  "solid-icon-Telescope",
  "solid-icon-Temperature-2",
  "solid-icon-Temperature-3",
  "solid-icon-Temperature"
]

export const FeatherIconData = [
  "feather-activity",
  "feather-airplay",
  "feather-alert-circle",
  "feather-alert-octagon",
  "feather-alert-triangle",
  "feather-align-center",
  "feather-align-justify",
  "feather-align-left",
  "feather-align-right",
  "feather-anchor",
  "feather-aperture",
  "feather-archive",
  "feather-arrow-down",
  "feather-arrow-down-circle",
  "feather-arrow-down-left",
  "feather-arrow-down-right",
  "feather-arrow-left",
  "feather-arrow-left-circle",
  "feather-arrow-right",
  "feather-arrow-right-circle",
  "feather-arrow-up",
  "feather-arrow-up-circle",
  "feather-arrow-up-left",
  "feather-arrow-up-right",
  "feather-at-sign",
  "feather-award",
  "feather-bar-chart",
  "feather-bar-chart-2",
  "feather-battery",
  "feather-battery-charging",
  "feather-bell",
  "feather-bell-off",
  "feather-bluetooth",
  "feather-bold",
  "feather-book",
  "feather-book-open",
  "feather-bookmark",
  "feather-box",
  "feather-briefcase",
  "feather-calendar",
  "feather-camera",
  "feather-camera-off",
  "feather-cast",
  "feather-check",
  "feather-check-circle",
  "feather-check-square",
  "feather-chevron-down",
  "feather-chevron-left",
  "feather-chevron-right",
  "feather-chevron-up",
  "feather-chevrons-down",
  "feather-chevrons-left",
  "feather-chevrons-right",
  "feather-chevrons-up",
  "feather-chrome",
  "feather-circle",
  "feather-clipboard",
  "feather-clock",
  "feather-cloud",
  "feather-cloud-drizzle",
  "feather-cloud-lightning",
  "feather-cloud-off",
  "feather-cloud-rain",
  "feather-cloud-snow",
  "feather-code",
  "feather-codepen",
  "feather-command",
  "feather-compass",
  "feather-copy",
  "feather-corner-down-left",
  "feather-corner-down-right",
  "feather-corner-left-down",
  "feather-corner-left-up",
  "feather-corner-right-down",
  "feather-corner-right-up",
  "feather-corner-up-left",
  "feather-corner-up-right",
  "feather-cpu",
  "feather-credit-card",
  "feather-crop",
  "feather-crosshair",
  "feather-database",
  "feather-delete",
  "feather-disc",
  "feather-dollar-sign",
  "feather-download",
  "feather-download-cloud",
  "feather-droplet",
  "feather-edit",
  "feather-edit-2",
  "feather-edit-3",
  "feather-external-link",
  "feather-eye",
  "feather-eye-off",
  "feather-facebook",
  "feather-fast-forward",
  "feather-feather",
  "feather-file",
  "feather-file-minus",
  "feather-file-plus",
  "feather-file-text",
  "feather-film",
  "feather-filter",
  "feather-flag",
  "feather-folder",
  "feather-folder-minus",
  "feather-folder-plus",
  "feather-gift",
  "feather-git-branch",
  "feather-git-commit",
  "feather-git-merge",
  "feather-git-pull-request",
  "feather-github",
  "feather-gitlab",
  "feather-globe",
  "feather-grid",
  "feather-hard-drive",
  "feather-hash",
  "feather-headphones",
  "feather-heart",
  "feather-help-circle",
  "feather-home",
  "feather-image",
  "feather-inbox",
  "feather-info",
  "feather-instagram",
  "feather-italic",
  "feather-layers",
  "feather-layout",
  "feather-life-buoy",
  "feather-link",
  "feather-link-2",
  "feather-linkedin",
  "feather-list",
  "feather-loader",
  "feather-lock",
  "feather-log-in",
  "feather-log-out",
  "feather-mail",
  "feather-map",
  "feather-map-pin",
  "feather-maximize",
  "feather-maximize-2",
  "feather-menu",
  "feather-message-circle",
  "feather-message-square",
  "feather-mic",
  "feather-mic-off",
  "feather-minimize",
  "feather-minimize-2",
  "feather-minus",
  "feather-minus-circle",
  "feather-minus-square",
  "feather-monitor",
  "feather-moon",
  "feather-more-horizontal",
  "feather-more-vertical",
  "feather-move",
  "feather-music",
  "feather-navigation",
  "feather-navigation-2",
  "feather-octagon",
  "feather-package",
  "feather-paperclip",
  "feather-pause",
  "feather-pause-circle",
  "feather-percent",
  "feather-phone",
  "feather-phone-call",
  "feather-phone-forwarded",
  "feather-phone-incoming",
  "feather-phone-missed",
  "feather-phone-off",
  "feather-phone-outgoing",
  "feather-pie-chart",
  "feather-play",
  "feather-play-circle",
  "feather-plus",
  "feather-plus-circle",
  "feather-plus-square",
  "feather-pocket",
  "feather-power",
  "feather-printer",
  "feather-radio",
  "feather-refresh-ccw",
  "feather-refresh-cw",
  "feather-repeat",
  "feather-rewind",
  "feather-rotate-ccw",
  "feather-rotate-cw",
  "feather-rss",
  "feather-save",
  "feather-scissors",
  "feather-search",
  "feather-send",
  "feather-server",
  "feather-settings",
  "feather-share",
  "feather-share-2",
  "feather-shield",
  "feather-shield-off",
  "feather-shopping-bag",
  "feather-shopping-cart",
  "feather-shuffle",
  "feather-sidebar",
  "feather-skip-back",
  "feather-skip-forward",
  "feather-slack",
  "feather-slash",
  "feather-sliders",
  "feather-smartphone",
  "feather-speaker",
  "feather-square",
  "feather-star",
  "feather-stop-circle",
  "feather-sun",
  "feather-sunrise",
  "feather-sunset",
  "feather-tablet",
  "feather-tag",
  "feather-target",
  "feather-terminal",
  "feather-thermometer",
  "feather-thumbs-down",
  "feather-thumbs-up",
  "feather-toggle-left",
  "feather-toggle-right",
  "feather-trash",
  "feather-trash-2",
  "feather-trending-down",
  "feather-trending-up",
  "feather-triangle",
  "feather-truck",
  "feather-tv",
  "feather-twitter",
  "feather-type",
  "feather-umbrella",
  "feather-underline",
  "feather-unlock",
  "feather-upload",
  "feather-upload-cloud",
  "feather-user",
  "feather-user-check",
  "feather-user-minus",
  "feather-user-plus",
  "feather-user-x",
  "feather-users",
  "feather-video",
  "feather-video-off",
  "feather-voicemail",
  "feather-volume",
  "feather-volume-1",
  "feather-volume-2",
  "feather-volume-x",
  "feather-watch",
  "feather-wifi",
  "feather-wifi-off",
  "feather-wind",
  "feather-x",
  "feather-x-circle",
  "feather-x-square",
  "feather-youtube",
  "feather-zap",
  "feather-zap-off",
  "feather-zoom-in",
  "feather-zoom-out"
]

export const FontAwesomeIconData = [
  "fab fa-500px",
  "fab fa-accessible-icon",
  "fab fa-accusoft",
  "fas fa-ad",
  "fas fa-address-book",
  "far fa-address-book",
  "fas fa-address-card",
  "far fa-address-card",
  "fas fa-adjust",
  "fab fa-adn",
  "fab fa-adversal",
  "fab fa-affiliatetheme",
  "fas fa-air-freshener",
  "fab fa-airbnb",
  "fab fa-algolia",
  "fas fa-align-center",
  "fas fa-align-justify",
  "fas fa-align-left",
  "fas fa-align-right",
  "fab fa-alipay",
  "fas fa-allergies",
  "fab fa-amazon",
  "fab fa-amazon-pay",
  "fas fa-ambulance",
  "fas fa-american-sign-language-interpreting",
  "fab fa-amilia",
  "fas fa-anchor",
  "fab fa-android",
  "fab fa-angellist",
  "fas fa-angle-double-down",
  "fas fa-angle-double-left",
  "fas fa-angle-double-right",
  "fas fa-angle-double-up",
  "fas fa-angle-down",
  "fas fa-angle-left",
  "fas fa-angle-right",
  "fas fa-angle-up",
  "fas fa-angry",
  "far fa-angry",
  "fab fa-angrycreative",
  "fab fa-angular",
  "fas fa-ankh",
  "fab fa-app-store",
  "fab fa-app-store-ios",
  "fab fa-apper",
  "fab fa-apple",
  "fas fa-apple-alt",
  "fab fa-apple-pay",
  "fas fa-archive",
  "fas fa-archway",
  "fas fa-arrow-alt-circle-down",
  "far fa-arrow-alt-circle-down",
  "fas fa-arrow-alt-circle-left",
  "far fa-arrow-alt-circle-left",
  "fas fa-arrow-alt-circle-right",
  "far fa-arrow-alt-circle-right",
  "fas fa-arrow-alt-circle-up",
  "far fa-arrow-alt-circle-up",
  "fas fa-arrow-circle-down",
  "fas fa-arrow-circle-left",
  "fas fa-arrow-circle-right",
  "fas fa-arrow-circle-up",
  "fas fa-arrow-down",
  "fas fa-arrow-left",
  "fas fa-arrow-right",
  "fas fa-arrow-up",
  "fas fa-arrows-alt",
  "fas fa-arrows-alt-h",
  "fas fa-arrows-alt-v",
  "fab fa-artstation",
  "fas fa-assistive-listening-systems",
  "fas fa-asterisk",
  "fab fa-asymmetrik",
  "fas fa-at",
  "fas fa-atlas",
  "fab fa-atlassian",
  "fas fa-atom",
  "fab fa-audible",
  "fas fa-audio-description",
  "fab fa-autoprefixer",
  "fab fa-avianex",
  "fab fa-aviato",
  "fas fa-award",
  "fab fa-aws",
  "fas fa-baby",
  "fas fa-baby-carriage",
  "fas fa-backspace",
  "fas fa-backward",
  "fas fa-bacon",
  "fas fa-bahai",
  "fas fa-balance-scale",
  "fas fa-balance-scale-left",
  "fas fa-balance-scale-right",
  "fas fa-ban",
  "fas fa-band-aid",
  "fab fa-bandcamp",
  "fas fa-barcode",
  "fas fa-bars",
  "fas fa-baseball-ball",
  "fas fa-basketball-ball",
  "fas fa-bath",
  "fas fa-battery-empty",
  "fas fa-battery-full",
  "fas fa-battery-half",
  "fas fa-battery-quarter",
  "fas fa-battery-three-quarters",
  "fab fa-battle-net",
  "fas fa-bed",
  "fas fa-beer",
  "fab fa-behance",
  "fab fa-behance-square",
  "fas fa-bell",
  "far fa-bell",
  "fas fa-bell-slash",
  "far fa-bell-slash",
  "fas fa-bezier-curve",
  "fas fa-bible",
  "fas fa-bicycle",
  "fas fa-biking",
  "fab fa-bimobject",
  "fas fa-binoculars",
  "fas fa-biohazard",
  "fas fa-birthday-cake",
  "fab fa-bitbucket",
  "fab fa-bitcoin",
  "fab fa-bity",
  "fab fa-black-tie",
  "fab fa-blackberry",
  "fas fa-blender",
  "fas fa-blender-phone",
  "fas fa-blind",
  "fas fa-blog",
  "fab fa-blogger",
  "fab fa-blogger-b",
  "fab fa-bluetooth",
  "fab fa-bluetooth-b",
  "fas fa-bold",
  "fas fa-bolt",
  "fas fa-bomb",
  "fas fa-bone",
  "fas fa-bong",
  "fas fa-book",
  "fas fa-book-dead",
  "fas fa-book-medical",
  "fas fa-book-open",
  "fas fa-book-reader",
  "fas fa-bookmark",
  "far fa-bookmark",
  "fab fa-bootstrap",
  "fas fa-border-all",
  "fas fa-border-none",
  "fas fa-border-style",
  "fas fa-bowling-ball",
  "fas fa-box",
  "fas fa-box-open",
  "fas fa-boxes",
  "fas fa-braille",
  "fas fa-brain",
  "fas fa-bread-slice",
  "fas fa-briefcase",
  "fas fa-briefcase-medical",
  "fas fa-broadcast-tower",
  "fas fa-broom",
  "fas fa-brush",
  "fab fa-btc",
  "fab fa-buffer",
  "fas fa-bug",
  "fas fa-building",
  "far fa-building",
  "fas fa-bullhorn",
  "fas fa-bullseye",
  "fas fa-burn",
  "fab fa-buromobelexperte",
  "fas fa-bus",
  "fas fa-bus-alt",
  "fas fa-business-time",
  "fab fa-buy-n-large",
  "fab fa-buysellads",
  "fas fa-calculator",
  "fas fa-calendar",
  "far fa-calendar",
  "fas fa-calendar-alt",
  "far fa-calendar-alt",
  "fas fa-calendar-check",
  "far fa-calendar-check",
  "fas fa-calendar-day",
  "fas fa-calendar-minus",
  "far fa-calendar-minus",
  "fas fa-calendar-plus",
  "far fa-calendar-plus",
  "fas fa-calendar-times",
  "far fa-calendar-times",
  "fas fa-calendar-week",
  "fas fa-camera",
  "fas fa-camera-retro",
  "fas fa-campground",
  "fab fa-canadian-maple-leaf",
  "fas fa-candy-cane",
  "fas fa-cannabis",
  "fas fa-capsules",
  "fas fa-car",
  "fas fa-car-alt",
  "fas fa-car-battery",
  "fas fa-car-crash",
  "fas fa-car-side",
  "fas fa-caravan",
  "fas fa-caret-down",
  "fas fa-caret-left",
  "fas fa-caret-right",
  "fas fa-caret-square-down",
  "far fa-caret-square-down",
  "fas fa-caret-square-left",
  "far fa-caret-square-left",
  "fas fa-caret-square-right",
  "far fa-caret-square-right",
  "fas fa-caret-square-up",
  "far fa-caret-square-up",
  "fas fa-caret-up",
  "fas fa-carrot",
  "fas fa-cart-arrow-down",
  "fas fa-cart-plus",
  "fas fa-cash-register",
  "fas fa-cat",
  "fab fa-cc-amazon-pay",
  "fab fa-cc-amex",
  "fab fa-cc-apple-pay",
  "fab fa-cc-diners-club",
  "fab fa-cc-discover",
  "fab fa-cc-jcb",
  "fab fa-cc-mastercard",
  "fab fa-cc-paypal",
  "fab fa-cc-stripe",
  "fab fa-cc-visa",
  "fab fa-centercode",
  "fab fa-centos",
  "fas fa-certificate",
  "fas fa-chair",
  "fas fa-chalkboard",
  "fas fa-chalkboard-teacher",
  "fas fa-charging-station",
  "fas fa-chart-area",
  "fas fa-chart-bar",
  "far fa-chart-bar",
  "fas fa-chart-line",
  "fas fa-chart-pie",
  "fas fa-check",
  "fas fa-check-circle",
  "far fa-check-circle",
  "fas fa-check-double",
  "fas fa-check-square",
  "far fa-check-square",
  "fas fa-cheese",
  "fas fa-chess",
  "fas fa-chess-bishop",
  "fas fa-chess-board",
  "fas fa-chess-king",
  "fas fa-chess-knight",
  "fas fa-chess-pawn",
  "fas fa-chess-queen",
  "fas fa-chess-rook",
  "fas fa-chevron-circle-down",
  "fas fa-chevron-circle-left",
  "fas fa-chevron-circle-right",
  "fas fa-chevron-circle-up",
  "fas fa-chevron-down",
  "fas fa-chevron-left",
  "fas fa-chevron-right",
  "fas fa-chevron-up",
  "fas fa-child",
  "fab fa-chrome",
  "fab fa-chromecast",
  "fas fa-church",
  "fas fa-circle",
  "far fa-circle",
  "fas fa-circle-notch",
  "fas fa-city",
  "fas fa-clinic-medical",
  "fas fa-clipboard",
  "far fa-clipboard",
  "fas fa-clipboard-check",
  "fas fa-clipboard-list",
  "fas fa-clock",
  "far fa-clock",
  "fas fa-clone",
  "far fa-clone",
  "fas fa-closed-captioning",
  "far fa-closed-captioning",
  "fas fa-cloud",
  "fas fa-cloud-meatball",
  "fas fa-cloud-moon",
  "fas fa-cloud-moon-rain",
  "fas fa-cloud-rain",
  "fas fa-cloud-showers-heavy",
  "fas fa-cloud-sun",
  "fas fa-cloud-sun-rain",
  "fab fa-cloudscale",
  "fab fa-cloudsmith",
  "fab fa-cloudversify",
  "fas fa-cocktail",
  "fas fa-code",
  "fas fa-code-branch",
  "fab fa-codepen",
  "fab fa-codiepie",
  "fas fa-coffee",
  "fas fa-cog",
  "fas fa-cogs",
  "fas fa-coins",
  "fas fa-columns",
  "fas fa-comment",
  "far fa-comment",
  "fas fa-comment-alt",
  "far fa-comment-alt",
  "fas fa-comment-dollar",
  "fas fa-comment-dots",
  "far fa-comment-dots",
  "fas fa-comment-medical",
  "fas fa-comment-slash",
  "fas fa-comments",
  "far fa-comments",
  "fas fa-comments-dollar",
  "fas fa-compact-disc",
  "fas fa-compass",
  "far fa-compass",
  "fas fa-compress",
  "fas fa-compress-alt",
  "fas fa-compress-arrows-alt",
  "fas fa-concierge-bell",
  "fab fa-confluence",
  "fab fa-connectdevelop",
  "fab fa-contao",
  "fas fa-cookie",
  "fas fa-cookie-bite",
  "fas fa-copy",
  "far fa-copy",
  "fas fa-copyright",
  "far fa-copyright",
  "fab fa-cotton-bureau",
  "fas fa-couch",
  "fab fa-cpanel",
  "fab fa-creative-commons",
  "fab fa-creative-commons-by",
  "fab fa-creative-commons-nc",
  "fab fa-creative-commons-nc-eu",
  "fab fa-creative-commons-nc-jp",
  "fab fa-creative-commons-nd",
  "fab fa-creative-commons-pd",
  "fab fa-creative-commons-pd-alt",
  "fab fa-creative-commons-remix",
  "fab fa-creative-commons-sa",
  "fab fa-creative-commons-sampling",
  "fab fa-creative-commons-sampling-plus",
  "fab fa-creative-commons-share",
  "fab fa-creative-commons-zero",
  "fas fa-credit-card",
  "far fa-credit-card",
  "fab fa-critical-role",
  "fas fa-crop",
  "fas fa-crop-alt",
  "fas fa-cross",
  "fas fa-crosshairs",
  "fas fa-crow",
  "fas fa-crown",
  "fas fa-crutch",
  "fab fa-css3",
  "fab fa-css3-alt",
  "fas fa-cube",
  "fas fa-cubes",
  "fas fa-cut",
  "fab fa-cuttlefish",
  "fab fa-d-and-d",
  "fab fa-d-and-d-beyond",
  "fab fa-dashcube",
  "fas fa-database",
  "fas fa-deaf",
  "fab fa-delicious",
  "fas fa-democrat",
  "fab fa-deploydog",
  "fab fa-deskpro",
  "fab fa-dev",
  "fab fa-deviantart",
  "fas fa-dharmachakra",
  "fab fa-dhl",
  "fas fa-diagnoses",
  "fab fa-diaspora",
  "fas fa-dice",
  "fas fa-dice-d20",
  "fas fa-dice-d6",
  "fas fa-dice-five",
  "fas fa-dice-four",
  "fas fa-dice-one",
  "fas fa-dice-six",
  "fas fa-dice-three",
  "fas fa-dice-two",
  "fab fa-digg",
  "fab fa-digital-ocean",
  "fas fa-digital-tachograph",
  "fas fa-directions",
  "fab fa-discord",
  "fab fa-discourse",
  "fas fa-divide",
  "fas fa-dizzy",
  "far fa-dizzy",
  "fas fa-dna",
  "fab fa-dochub",
  "fab fa-docker",
  "fas fa-dog",
  "fas fa-dollar-sign",
  "fas fa-dolly",
  "fas fa-dolly-flatbed",
  "fas fa-donate",
  "fas fa-door-closed",
  "fas fa-door-open",
  "fas fa-dot-circle",
  "far fa-dot-circle",
  "fas fa-dove",
  "fas fa-download",
  "fab fa-draft2digital",
  "fas fa-drafting-compass",
  "fas fa-dragon",
  "fas fa-draw-polygon",
  "fab fa-dribbble",
  "fab fa-dribbble-square",
  "fab fa-dropbox",
  "fas fa-drum",
  "fas fa-drum-steelpan",
  "fas fa-drumstick-bite",
  "fab fa-drupal",
  "fas fa-dumbbell",
  "fas fa-dumpster",
  "fas fa-dumpster-fire",
  "fas fa-dungeon",
  "fab fa-dyalog",
  "fab fa-earlybirds",
  "fab fa-ebay",
  "fab fa-edge",
  "fas fa-edit",
  "far fa-edit",
  "fas fa-egg",
  "fas fa-eject",
  "fab fa-elementor",
  "fas fa-ellipsis-h",
  "fas fa-ellipsis-v",
  "fab fa-ello",
  "fab fa-ember",
  "fab fa-empire",
  "fas fa-envelope",
  "far fa-envelope",
  "fas fa-envelope-open",
  "far fa-envelope-open",
  "fas fa-envelope-open-text",
  "fas fa-envelope-square",
  "fab fa-envira",
  "fas fa-equals",
  "fas fa-eraser",
  "fab fa-erlang",
  "fab fa-ethereum",
  "fas fa-ethernet",
  "fab fa-etsy",
  "fas fa-euro-sign",
  "fab fa-evernote",
  "fas fa-exchange-alt",
  "fas fa-exclamation",
  "fas fa-exclamation-circle",
  "fas fa-exclamation-triangle",
  "fas fa-expand",
  "fas fa-expand-alt",
  "fas fa-expand-arrows-alt",
  "fab fa-expeditedssl",
  "fas fa-external-link-alt",
  "fas fa-external-link-square-alt",
  "fas fa-eye",
  "far fa-eye",
  "fas fa-eye-dropper",
  "fas fa-eye-slash",
  "far fa-eye-slash",
  "fab fa-facebook",
  "fab fa-facebook-f",
  "fab fa-facebook-messenger",
  "fab fa-facebook-square",
  "fas fa-fan",
  "fab fa-fantasy-flight-games",
  "fas fa-fast-backward",
  "fas fa-fast-forward",
  "fas fa-fax",
  "fas fa-feather",
  "fas fa-feather-alt",
  "fab fa-fedex",
  "fab fa-fedora",
  "fas fa-female",
  "fas fa-fighter-jet",
  "fab fa-figma",
  "fas fa-file",
  "far fa-file",
  "fas fa-file-alt",
  "far fa-file-alt",
  "fas fa-file-archive",
  "far fa-file-archive",
  "fas fa-file-audio",
  "far fa-file-audio",
  "fas fa-file-code",
  "far fa-file-code",
  "fas fa-file-contract",
  "fas fa-file-csv",
  "fas fa-file-download",
  "fas fa-file-excel",
  "far fa-file-excel",
  "fas fa-file-export",
  "fas fa-file-image",
  "far fa-file-image",
  "fas fa-file-import",
  "fas fa-file-invoice",
  "fas fa-file-invoice-dollar",
  "fas fa-file-medical",
  "fas fa-file-medical-alt",
  "fas fa-file-pdf",
  "far fa-file-pdf",
  "fas fa-file-powerpoint",
  "far fa-file-powerpoint",
  "fas fa-file-prescription",
  "fas fa-file-signature",
  "fas fa-file-upload",
  "fas fa-file-video",
  "far fa-file-video",
  "fas fa-file-word",
  "far fa-file-word",
  "fas fa-fill",
  "fas fa-fill-drip",
  "fas fa-film",
  "fas fa-filter",
  "fas fa-fingerprint",
  "fas fa-fire",
  "fas fa-fire-alt",
  "fas fa-fire-extinguisher",
  "fab fa-firefox",
  "fab fa-firefox-browser",
  "fas fa-first-aid",
  "fab fa-first-order",
  "fab fa-first-order-alt",
  "fab fa-firstdraft",
  "fas fa-fish",
  "fas fa-fist-raised",
  "fas fa-flag",
  "far fa-flag",
  "fas fa-flag-checkered",
  "fas fa-flag-usa",
  "fas fa-flask",
  "fab fa-flickr",
  "fab fa-flipboard",
  "fas fa-flushed",
  "far fa-flushed",
  "fab fa-fly",
  "fas fa-folder",
  "far fa-folder",
  "fas fa-folder-minus",
  "fas fa-folder-open",
  "far fa-folder-open",
  "fas fa-folder-plus",
  "fas fa-font",
  "fab fa-font-awesome",
  "fab fa-font-awesome-alt",
  "fab fa-font-awesome-flag",
  "fab fa-fonticons",
  "fab fa-fonticons-fi",
  "fas fa-football-ball",
  "fab fa-fort-awesome",
  "fab fa-fort-awesome-alt",
  "fab fa-forumbee",
  "fas fa-forward",
  "fab fa-foursquare",
  "fab fa-free-code-camp",
  "fab fa-freebsd",
  "fas fa-frog",
  "fas fa-frown",
  "far fa-frown",
  "fas fa-frown-open",
  "far fa-frown-open",
  "fab fa-fulcrum",
  "fas fa-funnel-dollar",
  "fas fa-futbol",
  "far fa-futbol",
  "fab fa-galactic-republic",
  "fab fa-galactic-senate",
  "fas fa-gamepad",
  "fas fa-gas-pump",
  "fas fa-gavel",
  "fas fa-gem",
  "far fa-gem",
  "fas fa-genderless",
  "fab fa-get-pocket",
  "fab fa-gg",
  "fab fa-gg-circle",
  "fas fa-ghost",
  "fas fa-gift",
  "fas fa-gifts",
  "fab fa-git",
  "fab fa-git-alt",
  "fab fa-git-square",
  "fab fa-github",
  "fab fa-github-alt",
  "fab fa-github-square",
  "fab fa-gitkraken",
  "fab fa-gitlab",
  "fab fa-gitter",
  "fas fa-glass-cheers",
  "fas fa-glass-martini",
  "fas fa-glass-martini-alt",
  "fas fa-glass-whiskey",
  "fas fa-glasses",
  "fab fa-glide",
  "fab fa-glide-g",
  "fas fa-globe",
  "fas fa-globe-africa",
  "fas fa-globe-americas",
  "fas fa-globe-asia",
  "fas fa-globe-europe",
  "fab fa-gofore",
  "fas fa-golf-ball",
  "fab fa-goodreads",
  "fab fa-goodreads-g",
  "fab fa-google",
  "fab fa-google-drive",
  "fab fa-google-play",
  "fab fa-google-plus",
  "fab fa-google-plus-g",
  "fab fa-google-plus-square",
  "fab fa-google-wallet",
  "fas fa-gopuram",
  "fas fa-graduation-cap",
  "fab fa-gratipay",
  "fab fa-grav",
  "fas fa-greater-than",
  "fas fa-greater-than-equal",
  "fas fa-grimace",
  "far fa-grimace",
  "fas fa-grin",
  "far fa-grin",
  "fas fa-grin-alt",
  "far fa-grin-alt",
  "fas fa-grin-beam",
  "far fa-grin-beam",
  "fas fa-grin-beam-sweat",
  "far fa-grin-beam-sweat",
  "fas fa-grin-hearts",
  "far fa-grin-hearts",
  "fas fa-grin-squint",
  "far fa-grin-squint",
  "fas fa-grin-squint-tears",
  "far fa-grin-squint-tears",
  "fas fa-grin-stars",
  "far fa-grin-stars",
  "fas fa-grin-tears",
  "far fa-grin-tears",
  "fas fa-grin-tongue",
  "far fa-grin-tongue",
  "fas fa-grin-tongue-squint",
  "far fa-grin-tongue-squint",
  "fas fa-grin-tongue-wink",
  "far fa-grin-tongue-wink",
  "fas fa-grin-wink",
  "far fa-grin-wink",
  "fas fa-grip-horizontal",
  "fas fa-grip-lines",
  "fas fa-grip-lines-vertical",
  "fas fa-grip-vertical",
  "fab fa-gripfire",
  "fab fa-grunt",
  "fas fa-guitar",
  "fab fa-gulp",
  "fas fa-h-square",
  "fab fa-hacker-news",
  "fab fa-hacker-news-square",
  "fab fa-hackerrank",
  "fas fa-hamburger",
  "fas fa-hammer",
  "fas fa-hamsa",
  "fas fa-hand-holding",
  "fas fa-hand-holding-heart",
  "fas fa-hand-holding-usd",
  "fas fa-hand-lizard",
  "far fa-hand-lizard",
  "fas fa-hand-middle-finger",
  "fas fa-hand-paper",
  "far fa-hand-paper",
  "fas fa-hand-peace",
  "far fa-hand-peace",
  "fas fa-hand-point-down",
  "far fa-hand-point-down",
  "fas fa-hand-point-left",
  "far fa-hand-point-left",
  "fas fa-hand-point-right",
  "far fa-hand-point-right",
  "fas fa-hand-point-up",
  "far fa-hand-point-up",
  "fas fa-hand-pointer",
  "far fa-hand-pointer",
  "fas fa-hand-rock",
  "far fa-hand-rock",
  "fas fa-hand-scissors",
  "far fa-hand-scissors",
  "fas fa-hand-spock",
  "far fa-hand-spock",
  "fas fa-hands",
  "fas fa-hands-helping",
  "fas fa-handshake",
  "far fa-handshake",
  "fas fa-hanukiah",
  "fas fa-hard-hat",
  "fas fa-hashtag",
  "fas fa-hat-cowboy",
  "fas fa-hat-cowboy-side",
  "fas fa-hat-wizard",
  "fas fa-hdd",
  "far fa-hdd",
  "fas fa-heading",
  "fas fa-headphones",
  "fas fa-headphones-alt",
  "fas fa-headset",
  "fas fa-heart",
  "far fa-heart",
  "fas fa-heart-broken",
  "fas fa-heartbeat",
  "fas fa-helicopter",
  "fas fa-highlighter",
  "fas fa-hiking",
  "fas fa-hippo",
  "fab fa-hips",
  "fab fa-hire-a-helper",
  "fas fa-history",
  "fas fa-hockey-puck",
  "fas fa-holly-berry",
  "fas fa-home",
  "fab fa-hooli",
  "fab fa-hornbill",
  "fas fa-horse",
  "fas fa-horse-head",
  "fas fa-hospital",
  "far fa-hospital",
  "fas fa-hospital-alt",
  "fas fa-hospital-symbol",
  "fas fa-hot-tub",
  "fas fa-hotdog",
  "fas fa-hotel",
  "fab fa-hotjar",
  "fas fa-hourglass",
  "far fa-hourglass",
  "fas fa-hourglass-end",
  "fas fa-hourglass-half",
  "fas fa-hourglass-start",
  "fas fa-house-damage",
  "fab fa-houzz",
  "fas fa-hryvnia",
  "fab fa-html5",
  "fab fa-hubspot",
  "fas fa-i-cursor",
  "fas fa-ice-cream",
  "fas fa-icicles",
  "fas fa-icons",
  "fas fa-id-badge",
  "far fa-id-badge",
  "fas fa-id-card",
  "far fa-id-card",
  "fas fa-id-card-alt",
  "fab fa-ideal",
  "fas fa-igloo",
  "fas fa-image",
  "far fa-image",
  "fas fa-images",
  "far fa-images",
  "fab fa-imdb",
  "fas fa-inbox",
  "fas fa-indent",
  "fas fa-industry",
  "fas fa-infinity",
  "fas fa-info",
  "fas fa-info-circle",
  "fab fa-instagram",
  "fab fa-intercom",
  "fab fa-internet-explorer",
  "fab fa-invision",
  "fab fa-ioxhost",
  "fas fa-italic",
  "fab fa-itch-io",
  "fab fa-itunes",
  "fab fa-itunes-note",
  "fab fa-java",
  "fas fa-jedi",
  "fab fa-jedi-order",
  "fab fa-jenkins",
  "fab fa-jira",
  "fab fa-joget",
  "fas fa-joint",
  "fab fa-joomla",
  "fas fa-journal-whills",
  "fab fa-js",
  "fab fa-js-square",
  "fab fa-jsfiddle",
  "fas fa-kaaba",
  "fab fa-kaggle",
  "fas fa-key",
  "fab fa-keybase",
  "fas fa-keyboard",
  "far fa-keyboard",
  "fab fa-keycdn",
  "fas fa-khanda",
  "fab fa-kickstarter",
  "fab fa-kickstarter-k",
  "fas fa-kiss",
  "far fa-kiss",
  "fas fa-kiss-beam",
  "far fa-kiss-beam",
  "fas fa-kiss-wink-heart",
  "far fa-kiss-wink-heart",
  "fas fa-kiwi-bird",
  "fab fa-korvue",
  "fas fa-landmark",
  "fas fa-language",
  "fas fa-laptop",
  "fas fa-laptop-code",
  "fas fa-laptop-medical",
  "fab fa-laravel",
  "fab fa-lastfm",
  "fab fa-lastfm-square",
  "fas fa-laugh",
  "far fa-laugh",
  "fas fa-laugh-beam",
  "far fa-laugh-beam",
  "fas fa-laugh-squint",
  "far fa-laugh-squint",
  "fas fa-laugh-wink",
  "far fa-laugh-wink",
  "fas fa-layer-group",
  "fas fa-leaf",
  "fab fa-leanpub",
  "fas fa-lemon",
  "far fa-lemon",
  "fab fa-less",
  "fas fa-less-than",
  "fas fa-less-than-equal",
  "fas fa-level-down-alt",
  "fas fa-level-up-alt",
  "fas fa-life-ring",
  "far fa-life-ring",
  "fas fa-lightbulb",
  "far fa-lightbulb",
  "fab fa-line",
  "fas fa-link",
  "fab fa-linkedin",
  "fab fa-linkedin-in",
  "fab fa-linode",
  "fab fa-linux",
  "fas fa-lira-sign",
  "fas fa-list",
  "fas fa-list-alt",
  "far fa-list-alt",
  "fas fa-list-ol",
  "fas fa-list-ul",
  "fas fa-location-arrow",
  "fas fa-lock",
  "fas fa-lock-open",
  "fas fa-long-arrow-alt-down",
  "fas fa-long-arrow-alt-left",
  "fas fa-long-arrow-alt-right",
  "fas fa-long-arrow-alt-up",
  "fas fa-low-vision",
  "fas fa-luggage-cart",
  "fab fa-lyft",
  "fab fa-magento",
  "fas fa-magic",
  "fas fa-magnet",
  "fas fa-mail-bulk",
  "fab fa-mailchimp",
  "fas fa-male",
  "fab fa-mandalorian",
  "fas fa-map",
  "far fa-map",
  "fas fa-map-marked",
  "fas fa-map-marked-alt",
  "fas fa-map-marker",
  "fas fa-map-marker-alt",
  "fas fa-map-pin",
  "fas fa-map-signs",
  "fab fa-markdown",
  "fas fa-marker",
  "fas fa-mars",
  "fas fa-mars-double",
  "fas fa-mars-stroke",
  "fas fa-mars-stroke-h",
  "fas fa-mars-stroke-v",
  "fas fa-mask",
  "fab fa-mastodon",
  "fab fa-maxcdn",
  "fab fa-mdb",
  "fas fa-medal",
  "fab fa-medapps",
  "fab fa-medium",
  "fab fa-medium-m",
  "fas fa-medkit",
  "fab fa-medrt",
  "fab fa-meetup",
  "fab fa-megaport",
  "fas fa-meh",
  "far fa-meh",
  "fas fa-meh-blank",
  "far fa-meh-blank",
  "fas fa-meh-rolling-eyes",
  "far fa-meh-rolling-eyes",
  "fas fa-memory",
  "fab fa-mendeley",
  "fas fa-menorah",
  "fas fa-mercury",
  "fas fa-meteor",
  "fab fa-microblog",
  "fas fa-microchip",
  "fas fa-microphone",
  "fas fa-microphone-alt",
  "fas fa-microphone-alt-slash",
  "fas fa-microphone-slash",
  "fas fa-microscope",
  "fab fa-microsoft",
  "fas fa-minus",
  "fas fa-minus-circle",
  "fas fa-minus-square",
  "far fa-minus-square",
  "fas fa-mitten",
  "fab fa-mix",
  "fab fa-mixcloud",
  "fab fa-mizuni",
  "fas fa-mobile-alt",
  "fab fa-modx",
  "fab fa-monero",
  "fas fa-money-bill",
  "fas fa-money-bill-alt",
  "far fa-money-bill-alt",
  "fas fa-money-bill-wave",
  "fas fa-money-bill-wave-alt",
  "fas fa-money-check",
  "fas fa-money-check-alt",
  "fas fa-monument",
  "fas fa-moon",
  "far fa-moon",
  "fas fa-mortar-pestle",
  "fas fa-mosque",
  "fas fa-motorcycle",
  "fas fa-mountain",
  "fas fa-mouse",
  "fas fa-mouse-pointer",
  "fas fa-mug-hot",
  "fas fa-music",
  "fab fa-napster",
  "fab fa-neos",
  "fas fa-network-wired",
  "fas fa-neuter",
  "fas fa-newspaper",
  "far fa-newspaper",
  "fab fa-nimblr",
  "fab fa-node",
  "fab fa-node-js",
  "fas fa-not-equal",
  "fas fa-notes-medical",
  "fab fa-npm",
  "fab fa-ns8",
  "fab fa-nutritionix",
  "fas fa-object-group",
  "far fa-object-group",
  "fas fa-object-ungroup",
  "far fa-object-ungroup",
  "fab fa-odnoklassniki",
  "fab fa-odnoklassniki-square",
  "fas fa-oil-can",
  "fab fa-old-republic",
  "fas fa-om",
  "fab fa-opencart",
  "fab fa-openid",
  "fab fa-opera",
  "fab fa-optin-monster",
  "fab fa-orcid",
  "fab fa-osi",
  "fas fa-otter",
  "fas fa-outdent",
  "fab fa-page4",
  "fab fa-pagelines",
  "fas fa-pager",
  "fas fa-paint-brush",
  "fas fa-paint-roller",
  "fas fa-palette",
  "fab fa-palfed",
  "fas fa-pallet",
  "fas fa-paper-plane",
  "far fa-paper-plane",
  "fas fa-paperclip",
  "fas fa-parachute-box",
  "fas fa-paragraph",
  "fas fa-parking",
  "fas fa-passport",
  "fas fa-pastafarianism",
  "fas fa-paste",
  "fab fa-patreon",
  "fas fa-pause",
  "fas fa-pause-circle",
  "far fa-pause-circle",
  "fas fa-paw",
  "fab fa-paypal",
  "fas fa-peace",
  "fas fa-pen",
  "fas fa-pen-alt",
  "fas fa-pen-fancy",
  "fas fa-pen-nib",
  "fas fa-pen-square",
  "fas fa-pencil-alt",
  "fas fa-pencil-ruler",
  "fas fa-people-carry",
  "fas fa-pepper-hot",
  "fas fa-percent",
  "fas fa-percentage",
  "fab fa-periscope",
  "fas fa-person-booth",
  "fab fa-phabricator",
  "fab fa-phoenix-framework",
  "fab fa-phoenix-squadron",
  "fas fa-phone",
  "fas fa-phone-alt",
  "fas fa-phone-slash",
  "fas fa-phone-square",
  "fas fa-phone-square-alt",
  "fas fa-phone-volume",
  "fas fa-photo-video",
  "fab fa-php",
  "fab fa-pied-piper",
  "fab fa-pied-piper-alt",
  "fab fa-pied-piper-hat",
  "fab fa-pied-piper-pp",
  "fab fa-pied-piper-square",
  "fas fa-piggy-bank",
  "fas fa-pills",
  "fab fa-pinterest",
  "fab fa-pinterest-p",
  "fab fa-pinterest-square",
  "fas fa-pizza-slice",
  "fas fa-place-of-worship",
  "fas fa-plane",
  "fas fa-plane-arrival",
  "fas fa-plane-departure",
  "fas fa-play",
  "fas fa-play-circle",
  "far fa-play-circle",
  "fab fa-playstation",
  "fas fa-plug",
  "fas fa-plus",
  "fas fa-plus-circle",
  "fas fa-plus-square",
  "far fa-plus-square",
  "fas fa-podcast",
  "fas fa-poll",
  "fas fa-poll-h",
  "fas fa-poo",
  "fas fa-poo-storm",
  "fas fa-poop",
  "fas fa-portrait",
  "fas fa-pound-sign",
  "fas fa-power-off",
  "fas fa-pray",
  "fas fa-praying-hands",
  "fas fa-prescription",
  "fas fa-prescription-bottle",
  "fas fa-prescription-bottle-alt",
  "fas fa-print",
  "fas fa-procedures",
  "fab fa-product-hunt",
  "fas fa-project-diagram",
  "fab fa-pushed",
  "fas fa-puzzle-piece",
  "fab fa-python",
  "fab fa-qq",
  "fas fa-qrcode",
  "fas fa-question",
  "fas fa-question-circle",
  "far fa-question-circle",
  "fas fa-quidditch",
  "fab fa-quinscape",
  "fab fa-quora",
  "fas fa-quote-left",
  "fas fa-quote-right",
  "fas fa-quran",
  "fab fa-r-project",
  "fas fa-radiation",
  "fas fa-radiation-alt",
  "fas fa-rainbow",
  "fas fa-random",
  "fab fa-raspberry-pi",
  "fab fa-ravelry",
  "fab fa-react",
  "fab fa-reacteurope",
  "fab fa-readme",
  "fab fa-rebel",
  "fas fa-receipt",
  "fas fa-record-vinyl",
  "fas fa-recycle",
  "fab fa-red-river",
  "fab fa-reddit",
  "fab fa-reddit-alien",
  "fab fa-reddit-square",
  "fab fa-redhat",
  "fas fa-redo",
  "fas fa-redo-alt",
  "fas fa-registered",
  "far fa-registered",
  "fas fa-remove-format",
  "fab fa-renren",
  "fas fa-reply",
  "fas fa-reply-all",
  "fab fa-replyd",
  "fas fa-republican",
  "fab fa-researchgate",
  "fab fa-resolving",
  "fas fa-restroom",
  "fas fa-retweet",
  "fab fa-rev",
  "fas fa-ribbon",
  "fas fa-ring",
  "fas fa-road",
  "fas fa-robot",
  "fas fa-rocket",
  "fab fa-rocketchat",
  "fab fa-rockrms",
  "fas fa-route",
  "fas fa-rss",
  "fas fa-rss-square",
  "fas fa-ruble-sign",
  "fas fa-ruler",
  "fas fa-ruler-combined",
  "fas fa-ruler-horizontal",
  "fas fa-ruler-vertical",
  "fas fa-running",
  "fas fa-rupee-sign",
  "fas fa-sad-cry",
  "far fa-sad-cry",
  "fas fa-sad-tear",
  "far fa-sad-tear",
  "fab fa-safari",
  "fab fa-salesforce",
  "fab fa-sass",
  "fas fa-satellite",
  "fas fa-satellite-dish",
  "fas fa-save",
  "far fa-save",
  "fab fa-schlix",
  "fas fa-school",
  "fas fa-screwdriver",
  "fab fa-scribd",
  "fas fa-scroll",
  "fas fa-sd-card",
  "fas fa-search",
  "fas fa-search-dollar",
  "fas fa-search-location",
  "fas fa-search-minus",
  "fas fa-search-plus",
  "fab fa-searchengin",
  "fas fa-seedling",
  "fab fa-sellcast",
  "fab fa-sellsy",
  "fas fa-server",
  "fab fa-servicestack",
  "fas fa-shapes",
  "fas fa-share",
  "fas fa-share-alt",
  "fas fa-share-alt-square",
  "fas fa-share-square",
  "far fa-share-square",
  "fas fa-shekel-sign",
  "fas fa-shield-alt",
  "fas fa-ship",
  "fas fa-shipping-fast",
  "fab fa-shirtsinbulk",
  "fas fa-shoe-prints",
  "fas fa-shopping-bag",
  "fas fa-shopping-basket",
  "fas fa-shopping-cart",
  "fab fa-shopware",
  "fas fa-shower",
  "fas fa-shuttle-van",
  "fas fa-sign",
  "fas fa-sign-in-alt",
  "fas fa-sign-language",
  "fas fa-sign-out-alt",
  "fas fa-signal",
  "fas fa-signature",
  "fas fa-sim-card",
  "fab fa-simplybuilt",
  "fab fa-sistrix",
  "fas fa-sitemap",
  "fab fa-sith",
  "fas fa-skating",
  "fab fa-sketch",
  "fas fa-skiing",
  "fas fa-skiing-nordic",
  "fas fa-skull",
  "fas fa-skull-crossbones",
  "fab fa-skyatlas",
  "fab fa-skype",
  "fab fa-slack",
  "fab fa-slack-hash",
  "fas fa-slash",
  "fas fa-sleigh",
  "fas fa-sliders-h",
  "fab fa-slideshare",
  "fas fa-smile",
  "far fa-smile",
  "fas fa-smile-beam",
  "far fa-smile-beam",
  "fas fa-smile-wink",
  "far fa-smile-wink",
  "fas fa-smog",
  "fas fa-smoking",
  "fas fa-smoking-ban",
  "fas fa-sms",
  "fab fa-snapchat",
  "fab fa-snapchat-ghost",
  "fab fa-snapchat-square",
  "fas fa-snowboarding",
  "fas fa-snowflake",
  "far fa-snowflake",
  "fas fa-snowman",
  "fas fa-snowplow",
  "fas fa-socks",
  "fas fa-solar-panel",
  "fas fa-sort",
  "fas fa-sort-alpha-down",
  "fas fa-sort-alpha-down-alt",
  "fas fa-sort-alpha-up",
  "fas fa-sort-alpha-up-alt",
  "fas fa-sort-amount-down",
  "fas fa-sort-amount-down-alt",
  "fas fa-sort-amount-up",
  "fas fa-sort-amount-up-alt",
  "fas fa-sort-down",
  "fas fa-sort-numeric-down",
  "fas fa-sort-numeric-down-alt",
  "fas fa-sort-numeric-up",
  "fas fa-sort-numeric-up-alt",
  "fas fa-sort-up",
  "fab fa-soundcloud",
  "fab fa-sourcetree",
  "fas fa-spa",
  "fas fa-space-shuttle",
  "fab fa-speakap",
  "fab fa-speaker-deck",
  "fas fa-spell-check",
  "fas fa-spider",
  "fas fa-spinner",
  "fas fa-splotch",
  "fab fa-spotify",
  "fas fa-spray-can",
  "fas fa-square",
  "far fa-square",
  "fas fa-square-full",
  "fas fa-square-root-alt",
  "fab fa-squarespace",
  "fab fa-stack-exchange",
  "fab fa-stack-overflow",
  "fab fa-stackpath",
  "fas fa-stamp",
  "fas fa-star",
  "far fa-star",
  "fas fa-star-and-crescent",
  "fas fa-star-half",
  "far fa-star-half",
  "fas fa-star-half-alt",
  "fas fa-star-of-david",
  "fas fa-star-of-life",
  "fab fa-staylinked",
  "fab fa-steam",
  "fab fa-steam-square",
  "fab fa-steam-symbol",
  "fas fa-step-backward",
  "fas fa-step-forward",
  "fas fa-stethoscope",
  "fab fa-sticker-mule",
  "fas fa-sticky-note",
  "far fa-sticky-note",
  "fas fa-stop",
  "fas fa-stop-circle",
  "far fa-stop-circle",
  "fas fa-stopwatch",
  "fas fa-store",
  "fas fa-store-alt",
  "fab fa-strava",
  "fas fa-stream",
  "fas fa-street-view",
  "fas fa-strikethrough",
  "fab fa-stripe",
  "fab fa-stripe-s",
  "fas fa-stroopwafel",
  "fab fa-studiovinari",
  "fab fa-stumbleupon",
  "fab fa-stumbleupon-circle",
  "fas fa-subscript",
  "fas fa-subway",
  "fas fa-suitcase",
  "fas fa-suitcase-rolling",
  "fas fa-sun",
  "far fa-sun",
  "fab fa-superpowers",
  "fas fa-superscript",
  "fab fa-supple",
  "fas fa-surprise",
  "far fa-surprise",
  "fab fa-suse",
  "fas fa-swatchbook",
  "fab fa-swift",
  "fas fa-swimmer",
  "fas fa-swimming-pool",
  "fab fa-symfony",
  "fas fa-synagogue",
  "fas fa-sync",
  "fas fa-sync-alt",
  "fas fa-syringe",
  "fas fa-table",
  "fas fa-table-tennis",
  "fas fa-tablet-alt",
  "fas fa-tablets",
  "fas fa-tag",
  "fas fa-tags",
  "fas fa-tape",
  "fas fa-tasks",
  "fas fa-taxi",
  "fab fa-teamspeak",
  "fas fa-teeth",
  "fas fa-teeth-open",
  "fab fa-telegram",
  "fab fa-telegram-plane",
  "fas fa-temperature-high",
  "fas fa-temperature-low",
  "fab fa-tencent-weibo",
  "fas fa-tenge",
  "fas fa-terminal",
  "fas fa-text-height",
  "fas fa-text-width",
  "fas fa-th",
  "fas fa-th-large",
  "fas fa-th-list",
  "fab fa-the-red-yeti",
  "fas fa-theater-masks",
  "fab fa-themeco",
  "fab fa-themeisle",
  "fas fa-thermometer",
  "fas fa-thermometer-empty",
  "fas fa-thermometer-full",
  "fas fa-thermometer-half",
  "fas fa-thermometer-quarter",
  "fas fa-thermometer-three-quarters",
  "fab fa-think-peaks",
  "fas fa-thumbs-down",
  "far fa-thumbs-down",
  "fas fa-thumbs-up",
  "far fa-thumbs-up",
  "fas fa-thumbtack",
  "fas fa-ticket-alt",
  "fas fa-times",
  "fas fa-times-circle",
  "far fa-times-circle",
  "fas fa-tint",
  "fas fa-tint-slash",
  "fas fa-tired",
  "far fa-tired",
  "fas fa-toggle-off",
  "fas fa-toggle-on",
  "fas fa-toilet",
  "fas fa-toilet-paper",
  "fas fa-toolbox",
  "fas fa-tools",
  "fas fa-tooth",
  "fas fa-torah",
  "fas fa-torii-gate",
  "fas fa-tractor",
  "fab fa-trade-federation",
  "fas fa-trademark",
  "fas fa-traffic-light",
  "fas fa-trailer",
  "fas fa-train",
  "fas fa-tram",
  "fas fa-transgender",
  "fas fa-transgender-alt",
  "fas fa-trash",
  "fas fa-trash-alt",
  "far fa-trash-alt",
  "fas fa-trash-restore",
  "fas fa-trash-restore-alt",
  "fas fa-tree",
  "fab fa-trello",
  "fas fa-trophy",
  "fas fa-truck",
  "fas fa-truck-loading",
  "fas fa-truck-monster",
  "fas fa-truck-moving",
  "fas fa-truck-pickup",
  "fas fa-tshirt",
  "fas fa-tty",
  "fab fa-tumblr",
  "fab fa-tumblr-square",
  "fas fa-tv",
  "fab fa-twitch",
  "fab fa-twitter",
  "fab fa-twitter-square",
  "fab fa-typo3",
  "fab fa-uber",
  "fab fa-ubuntu",
  "fab fa-uikit",
  "fab fa-umbraco",
  "fas fa-umbrella",
  "fas fa-umbrella-beach",
  "fas fa-underline",
  "fas fa-undo",
  "fas fa-undo-alt",
  "fab fa-uniregistry",
  "fab fa-unity",
  "fas fa-universal-access",
  "fas fa-university",
  "fas fa-unlink",
  "fas fa-unlock",
  "fas fa-unlock-alt",
  "fab fa-untappd",
  "fas fa-upload",
  "fab fa-ups",
  "fab fa-usb",
  "fas fa-user",
  "far fa-user",
  "fas fa-user-alt",
  "fas fa-user-alt-slash",
  "fas fa-user-astronaut",
  "fas fa-user-check",
  "fas fa-user-circle",
  "far fa-user-circle",
  "fas fa-user-clock",
  "fas fa-user-cog",
  "fas fa-user-edit",
  "fas fa-user-friends",
  "fas fa-user-graduate",
  "fas fa-user-injured",
  "fas fa-user-lock",
  "fas fa-user-md",
  "fas fa-user-minus",
  "fas fa-user-ninja",
  "fas fa-user-nurse",
  "fas fa-user-plus",
  "fas fa-user-secret",
  "fas fa-user-shield",
  "fas fa-user-slash",
  "fas fa-user-tag",
  "fas fa-user-tie",
  "fas fa-user-times",
  "fas fa-users",
  "fas fa-users-cog",
  "fab fa-usps",
  "fab fa-ussunnah",
  "fas fa-utensil-spoon",
  "fas fa-utensils",
  "fab fa-vaadin",
  "fas fa-vector-square",
  "fas fa-venus",
  "fas fa-venus-double",
  "fas fa-venus-mars",
  "fab fa-viacoin",
  "fab fa-viadeo",
  "fab fa-viadeo-square",
  "fas fa-vial",
  "fas fa-vials",
  "fab fa-viber",
  "fas fa-video",
  "fas fa-video-slash",
  "fas fa-vihara",
  "fab fa-vimeo",
  "fab fa-vimeo-square",
  "fab fa-vimeo-v",
  "fab fa-vine",
  "fab fa-vk",
  "fab fa-vnv",
  "fas fa-voicemail",
  "fas fa-volleyball-ball",
  "fas fa-volume-down",
  "fas fa-volume-mute",
  "fas fa-volume-off",
  "fas fa-volume-up",
  "fas fa-vote-yea",
  "fas fa-vr-cardboard",
  "fab fa-vuejs",
  "fas fa-walking",
  "fas fa-wallet",
  "fas fa-warehouse",
  "fas fa-water",
  "fas fa-wave-square",
  "fab fa-waze",
  "fab fa-weebly",
  "fab fa-weibo",
  "fas fa-weight",
  "fas fa-weight-hanging",
  "fab fa-weixin",
  "fab fa-whatsapp",
  "fab fa-whatsapp-square",
  "fas fa-wheelchair",
  "fab fa-whmcs",
  "fas fa-wifi",
  "fab fa-wikipedia-w",
  "fas fa-wind",
  "fas fa-window-close",
  "far fa-window-close",
  "fas fa-window-maximize",
  "far fa-window-maximize",
  "fas fa-window-minimize",
  "far fa-window-minimize",
  "fas fa-window-restore",
  "far fa-window-restore",
  "fab fa-windows",
  "fas fa-wine-bottle",
  "fas fa-wine-glass",
  "fas fa-wine-glass-alt",
  "fab fa-wix",
  "fab fa-wizards-of-the-coast",
  "fab fa-wolf-pack-battalion",
  "fas fa-won-sign",
  "fab fa-wordpress",
  "fab fa-wordpress-simple",
  "fab fa-wpbeginner",
  "fab fa-wpexplorer",
  "fab fa-wpforms",
  "fab fa-wpressr",
  "fas fa-wrench",
  "fas fa-x-ray",
  "fab fa-xbox",
  "fab fa-xing",
  "fab fa-xing-square",
  "fab fa-y-combinator",
  "fab fa-yahoo",
  "fab fa-yammer",
  "fab fa-yandex",
  "fab fa-yandex-international",
  "fab fa-yarn",
  "fab fa-yelp",
  "fas fa-yen-sign",
  "fas fa-yin-yang",
  "fab fa-yoast",
  "fab fa-youtube",
  "fab fa-youtube-square",
  "fab fa-zhihu"
]

export const ETLineIconData = [
  "icon-mobile",
  "icon-laptop",
  "icon-desktop",
  "icon-tablet",
  "icon-phone",
  "icon-document",
  "icon-documents",
  "icon-search",
  "icon-clipboard",
  "icon-newspaper",
  "icon-notebook",
  "icon-book-open",
  "icon-browser",
  "icon-calendar",
  "icon-presentation",
  "icon-picture",
  "icon-pictures",
  "icon-video",
  "icon-camera",
  "icon-printer",
  "icon-toolbox",
  "icon-briefcase",
  "icon-wallet",
  "icon-gift",
  "icon-bargraph",
  "icon-grid",
  "icon-expand",
  "icon-focus",
  "icon-edit",
  "icon-adjustments",
  "icon-ribbon",
  "icon-hourglass",
  "icon-lock",
  "icon-megaphone",
  "icon-shield",
  "icon-trophy",
  "icon-flag",
  "icon-map",
  "icon-puzzle",
  "icon-basket",
  "icon-envelope",
  "icon-streetsign",
  "icon-telescope",
  "icon-gears",
  "icon-key",
  "icon-paperclip",
  "icon-attachment",
  "icon-pricetags",
  "icon-lightbulb",
  "icon-layers",
  "icon-pencil",
  "icon-tools",
  "icon-tools-2",
  "icon-scissors",
  "icon-paintbrush",
  "icon-magnifying-glass",
  "icon-circle-compass",
  "icon-linegraph",
  "icon-mic",
  "icon-strategy",
  "icon-beaker",
  "icon-caution",
  "icon-recycle",
  "icon-anchor",
  "icon-profile-male",
  "icon-profile-female",
  "icon-bike",
  "icon-wine",
  "icon-hotairballoon",
  "icon-globe",
  "icon-genius",
  "icon-map-pin",
  "icon-dial",
  "icon-chat",
  "icon-heart",
  "icon-cloud",
  "icon-upload",
  "icon-download",
  "icon-target",
  "icon-hazardous",
  "icon-piechart",
  "icon-speedometer",
  "icon-global",
  "icon-compass",
  "icon-lifesaver",
  "icon-clock",
  "icon-aperture",
  "icon-quote",
  "icon-scope",
  "icon-alarmclock",
  "icon-refresh",
  "icon-happy",
  "icon-sad",
  "icon-facebook",
  "icon-twitter",
  "icon-googleplus",
  "icon-rss",
  "icon-tumblr",
  "icon-linkedin",
  "icon-dribbble"
]

export const ThemifyIconData = [
  "ti-arrow-up",
  "ti-arrow-right",
  "ti-arrow-left",
  "ti-arrow-down",
  "ti-arrows-vertical",
  "ti-arrows-horizontal",
  "ti-angle-up",
  "ti-angle-right",
  "ti-angle-left",
  "ti-angle-down",
  "ti-angle-double-up",
  "ti-angle-double-right",
  "ti-angle-double-left",
  "ti-angle-double-down",
  "ti-move",
  "ti-fullscreen",
  "ti-arrow-top-right",
  "ti-arrow-top-left",
  "ti-arrow-circle-up",
  "ti-arrow-circle-right",
  "ti-arrow-circle-left",
  "ti-arrow-circle-down",
  "ti-arrows-corner",
  "ti-split-v",
  "ti-split-v-alt",
  "ti-split-h",
  "ti-hand-point-up",
  "ti-hand-point-right",
  "ti-hand-point-left",
  "ti-hand-point-down",
  "ti-back-right",
  "ti-back-left",
  "ti-exchange-vertical",
  "ti-wand",
  "ti-save",
  "ti-save-alt",
  "ti-direction",
  "ti-direction-alt",
  "ti-user",
  "ti-link",
  "ti-unlink",
  "ti-trash",
  "ti-target",
  "ti-tag",
  "ti-desktop",
  "ti-tablet",
  "ti-mobile",
  "ti-email",
  "ti-star",
  "ti-spray",
  "ti-signal",
  "ti-shopping-cart",
  "ti-shopping-cart-full",
  "ti-settings",
  "ti-search",
  "ti-zoom-in",
  "ti-zoom-out",
  "ti-cut",
  "ti-ruler",
  "ti-ruler-alt-2",
  "ti-ruler-pencil",
  "ti-ruler-alt",
  "ti-bookmark",
  "ti-bookmark-alt",
  "ti-reload",
  "ti-plus",
  "ti-minus",
  "ti-close",
  "ti-pin",
  "ti-pencil",
  "ti-pencil-alt",
  "ti-paint-roller",
  "ti-paint-bucket",
  "ti-na",
  "ti-medall",
  "ti-medall-alt",
  "ti-marker",
  "ti-marker-alt",
  "ti-lock",
  "ti-unlock",
  "ti-location-arrow",
  "ti-layout",
  "ti-layers",
  "ti-layers-alt",
  "ti-key",
  "ti-image",
  "ti-heart",
  "ti-heart-broken",
  "ti-hand-stop",
  "ti-hand-open",
  "ti-hand-drag",
  "ti-flag",
  "ti-flag-alt",
  "ti-flag-alt-2",
  "ti-eye",
  "ti-import",
  "ti-export",
  "ti-cup",
  "ti-crown",
  "ti-comments",
  "ti-comment",
  "ti-comment-alt",
  "ti-thought",
  "ti-clip",
  "ti-check",
  "ti-check-box",
  "ti-camera",
  "ti-announcement",
  "ti-brush",
  "ti-brush-alt",
  "ti-palette",
  "ti-briefcase",
  "ti-bolt",
  "ti-bolt-alt",
  "ti-blackboard",
  "ti-bag",
  "ti-world",
  "ti-wheelchair",
  "ti-car",
  "ti-truck",
  "ti-timer",
  "ti-ticket",
  "ti-thumb-up",
  "ti-thumb-down",
  "ti-stats-up",
  "ti-stats-down",
  "ti-shine",
  "ti-shift-right",
  "ti-shift-left",
  "ti-shift-right-alt",
  "ti-shift-left-alt",
  "ti-shield",
  "ti-notepad",
  "ti-server",
  "ti-pulse",
  "ti-printer",
  "ti-power-off",
  "ti-plug",
  "ti-pie-chart",
  "ti-panel",
  "ti-package",
  "ti-music",
  "ti-music-alt",
  "ti-mouse",
  "ti-mouse-alt",
  "ti-money",
  "ti-microphone",
  "ti-menu",
  "ti-menu-alt",
  "ti-map",
  "ti-map-alt",
  "ti-location-pin",
  "ti-light-bulb",
  "ti-info",
  "ti-infinite",
  "ti-id-badge",
  "ti-hummer",
  "ti-home",
  "ti-help",
  "ti-headphone",
  "ti-harddrives",
  "ti-harddrive",
  "ti-gift",
  "ti-game",
  "ti-filter",
  "ti-files",
  "ti-file",
  "ti-zip",
  "ti-folder",
  "ti-envelope",
  "ti-dashboard",
  "ti-cloud",
  "ti-cloud-up",
  "ti-cloud-down",
  "ti-clipboard",
  "ti-calendar",
  "ti-book",
  "ti-bell",
  "ti-basketball",
  "ti-bar-chart",
  "ti-bar-chart-alt",
  "ti-archive",
  "ti-anchor",
  "ti-alert",
  "ti-alarm-clock",
  "ti-agenda",
  "ti-write",
  "ti-wallet",
  "ti-video-clapper",
  "ti-video-camera",
  "ti-vector",
  "ti-support",
  "ti-stamp",
  "ti-slice",
  "ti-shortcode",
  "ti-receipt",
  "ti-pin2",
  "ti-pin-alt",
  "ti-pencil-alt2",
  "ti-eraser",
  "ti-more",
  "ti-more-alt",
  "ti-microphone-alt",
  "ti-magnet",
  "ti-line-double",
  "ti-line-dotted",
  "ti-line-dashed",
  "ti-ink-pen",
  "ti-info-alt",
  "ti-help-alt",
  "ti-headphone-alt",
  "ti-gallery",
  "ti-face-smile",
  "ti-face-sad",
  "ti-credit-card",
  "ti-comments-smiley",
  "ti-time",
  "ti-share",
  "ti-share-alt",
  "ti-rocket",
  "ti-new-window",
  "ti-rss",
  "ti-rss-alt",
  "ti-control-stop",
  "ti-control-shuffle",
  "ti-control-play",
  "ti-control-pause",
  "ti-control-forward",
  "ti-control-backward",
  "ti-volume",
  "ti-control-skip-forward",
  "ti-control-skip-backward",
  "ti-control-record",
  "ti-control-eject",
  "ti-paragraph",
  "ti-uppercase",
  "ti-underline",
  "ti-text",
  "ti-Italic",
  "ti-smallcap",
  "ti-list",
  "ti-list-ol",
  "ti-align-right",
  "ti-align-left",
  "ti-align-justify",
  "ti-align-center",
  "ti-quote-right",
  "ti-quote-left",
  "ti-layout-width-full",
  "ti-layout-width-default",
  "ti-layout-width-default-alt",
  "ti-layout-tab",
  "ti-layout-tab-window",
  "ti-layout-tab-v",
  "ti-layout-tab-min",
  "ti-layout-slider",
  "ti-layout-slider-alt",
  "ti-layout-sidebar-right",
  "ti-layout-sidebar-none",
  "ti-layout-sidebar-left",
  "ti-layout-placeholder",
  "ti-layout-menu",
  "ti-layout-menu-v",
  "ti-layout-menu-separated",
  "ti-layout-menu-full",
  "ti-layout-media-right",
  "ti-layout-media-right-alt",
  "ti-layout-media-overlay",
  "ti-layout-media-overlay-alt",
  "ti-layout-media-overlay-alt-2",
  "ti-layout-media-left",
  "ti-layout-media-left-alt",
  "ti-layout-media-center",
  "ti-layout-media-center-alt",
  "ti-layout-list-thumb",
  "ti-layout-list-thumb-alt",
  "ti-layout-list-post",
  "ti-layout-list-large-image",
  "ti-layout-line-solid",
  "ti-layout-grid4",
  "ti-layout-grid3",
  "ti-layout-grid2",
  "ti-layout-grid2-thumb",
  "ti-layout-cta-right",
  "ti-layout-cta-left",
  "ti-layout-cta-center",
  "ti-layout-cta-btn-right",
  "ti-layout-cta-btn-left",
  "ti-layout-column4",
  "ti-layout-column3",
  "ti-layout-column2",
  "ti-layout-accordion-separated",
  "ti-layout-accordion-merged",
  "ti-layout-accordion-list",
  "ti-widgetized",
  "ti-widget",
  "ti-widget-alt",
  "ti-view-list",
  "ti-view-list-alt",
  "ti-view-grid",
  "ti-upload",
  "ti-download",
  "ti-loop",
  "ti-layout-sidebar-2",
  "ti-layout-grid4-alt",
  "ti-layout-grid3-alt",
  "ti-layout-grid2-alt",
  "ti-layout-column4-alt",
  "ti-layout-column3-alt",
  "ti-layout-column2-alt",
  "ti-flickr",
  "ti-flickr-alt",
  "ti-instagram",
  "ti-google",
  "ti-github",
  "ti-facebook",
  "ti-dropbox",
  "ti-dropbox-alt",
  "ti-dribbble",
  "ti-apple",
  "ti-android",
  "ti-yahoo",
  "ti-trello",
  "ti-stack-overflow",
  "ti-soundcloud",
  "ti-sharethis",
  "ti-sharethis-alt",
  "ti-reddit",
  "ti-microsoft",
  "ti-microsoft-alt",
  "ti-linux",
  "ti-jsfiddle",
  "ti-joomla",
  "ti-html5",
  "ti-css3",
  "ti-drupal",
  "ti-wordpress",
  "ti-tumblr",
  "ti-tumblr-alt",
  "ti-skype",
  "ti-youtube",
  "ti-vimeo",
  "ti-vimeo-alt",
  "ti-twitter",
  "ti-twitter-alt",
  "ti-linkedin",
  "ti-pinterest",
  "ti-pinterest-alt",
  "ti-themify-logo",
  "ti-themify-favicon",
  "ti-themify-favicon-alt"
]

export const SimpleLineIconData = [
  "icon-user",
  "icon-people",
  "icon-user-female",
  "icon-user-follow",
  "icon-user-following",
  "icon-user-unfollow",
  "icon-login",
  "icon-logout",
  "icon-emotsmile",
  "icon-phone",
  "icon-call-end",
  "icon-call-in",
  "icon-call-out",
  "icon-map",
  "icon-location-pin",
  "icon-direction",
  "icon-directions",
  "icon-compass",
  "icon-layers",
  "icon-menu",
  "icon-list",
  "icon-options-vertical",
  "icon-options",
  "icon-arrow-down",
  "icon-arrow-left",
  "icon-arrow-right",
  "icon-arrow-up",
  "icon-arrow-up-circle",
  "icon-arrow-left-circle",
  "icon-arrow-right-circle",
  "icon-arrow-down-circle",
  "icon-check",
  "icon-clock",
  "icon-plus",
  "icon-minus",
  "icon-close",
  "icon-event",
  "icon-exclamation",
  "icon-organization",
  "icon-trophy",
  "icon-screen-smartphone",
  "icon-screen-desktop",
  "icon-plane",
  "icon-notebook",
  "icon-mustache",
  "icon-mouse",
  "icon-magnet",
  "icon-energy",
  "icon-disc",
  "icon-cursor",
  "icon-cursor-move",
  "icon-crop",
  "icon-chemistry",
  "icon-speedometer",
  "icon-shield",
  "icon-screen-tablet",
  "icon-magic-wand",
  "icon-hourglass",
  "icon-graduation",
  "icon-ghost",
  "icon-game-controller",
  "icon-fire",
  "icon-eyeglass",
  "icon-envelope-open",
  "icon-envelope-letter",
  "icon-bell",
  "icon-badge",
  "icon-anchor",
  "icon-wallet",
  "icon-vector",
  "icon-speech",
  "icon-puzzle",
  "icon-printer",
  "icon-present",
  "icon-playlist",
  "icon-pin",
  "icon-picture",
  "icon-handbag",
  "icon-globe-alt",
  "icon-globe",
  "icon-folder-alt",
  "icon-folder",
  "icon-film",
  "icon-feed",
  "icon-drop",
  "icon-drawer",
  "icon-docs",
  "icon-doc",
  "icon-diamond",
  "icon-cup",
  "icon-calculator",
  "icon-bubbles",
  "icon-briefcase",
  "icon-book-open",
  "icon-basket-loaded",
  "icon-basket",
  "icon-bag",
  "icon-action-undo",
  "icon-action-redo",
  "icon-wrench",
  "icon-umbrella",
  "icon-trash",
  "icon-tag",
  "icon-support",
  "icon-frame",
  "icon-size-fullscreen",
  "icon-size-actual",
  "icon-shuffle",
  "icon-share-alt",
  "icon-share",
  "icon-rocket",
  "icon-question",
  "icon-pie-chart",
  "icon-pencil",
  "icon-note",
  "icon-loop",
  "icon-home",
  "icon-grid",
  "icon-graph",
  "icon-microphone",
  "icon-music-tone-alt",
  "icon-music-tone",
  "icon-earphones-alt",
  "icon-earphones",
  "icon-equalizer",
  "icon-like",
  "icon-dislike",
  "icon-control-start",
  "icon-control-rewind",
  "icon-control-play",
  "icon-control-pause",
  "icon-control-forward",
  "icon-control-end",
  "icon-volume-1",
  "icon-volume-2",
  "icon-volume-off",
  "icon-calendar",
  "icon-bulb",
  "icon-chart",
  "icon-ban",
  "icon-bubble",
  "icon-camrecorder",
  "icon-camera",
  "icon-cloud-download",
  "icon-cloud-upload",
  "icon-envelope",
  "icon-eye",
  "icon-flag",
  "icon-heart",
  "icon-info",
  "icon-key",
  "icon-link",
  "icon-lock",
  "icon-lock-open",
  "icon-magnifier",
  "icon-magnifier-add",
  "icon-magnifier-remove",
  "icon-paper-clip",
  "icon-paper-plane",
  "icon-power",
  "icon-refresh",
  "icon-reload",
  "icon-settings",
  "icon-star",
  "icon-symbol-female",
  "icon-symbol-male",
  "icon-target",
  "icon-credit-card",
  "icon-paypal",
  "icon-social-tumblr",
  "icon-social-twitter",
  "icon-social-facebook",
  "icon-social-instagram",
  "icon-social-linkedin",
  "icon-social-pinterest",
  "icon-social-github",
  "icon-social-google",
  "icon-social-reddit",
  "icon-social-skype",
  "icon-social-dribbble",
  "icon-social-behance",
  "icon-social-foursqare",
  "icon-social-soundcloud",
  "icon-social-spotify",
  "icon-social-stumbleupon",
  "icon-social-youtube",
  "icon-social-dropbox",
  "icon-social-vkontakte",
  "icon-social-steam"
]